const UpdateState = {
  fetchAndUpdateCart: function () {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        UpdateState.updateVariantButtonStates(cart);
      })
      .catch(function (error) {
        console.error("Error fetching cart data: ", error);
      });
  },

  updateVariantButtonStates: function (cart) {
    let variantButtons = document.querySelectorAll(".variant-button");
    variantButtons.forEach(function (button) {
      let variantId = button.getAttribute("data-variant-id");
      let variantQuantity = parseInt(
        button.getAttribute("data-variant-quantity"),
        10
      );
      let cartItem = cart.items.find((item) => item.variant_id == variantId);
      if (
        variantQuantity === 0 ||
        (cartItem && cartItem.quantity >= variantQuantity)
      ) {
        button.classList.add("disabled");
        button.setAttribute("disabled", "disabled");
      }
    });
  },

  init: function () {
    window.addEventListener("load", function () {
      UpdateState.fetchAndUpdateCart();
    });
  },
};

UpdateState.init();

!(function () {
  function e(e, t, i, n, a, o, r) {
    try {
      var s = e[o](r),
        l = s.value;
    } catch (e) {
      return void i(e);
    }
    s.done ? t(l) : Promise.resolve(l).then(n, a);
  }
  function t(t) {
    return function () {
      var i = this,
        n = arguments;
      return new Promise(function (a, o) {
        var r = t.apply(i, n);
        function s(t) {
          e(r, a, o, s, l, "next", t);
        }
        function l(t) {
          e(r, a, o, s, l, "throw", t);
        }
        s(void 0);
      });
    };
  }
  function i(e) {
    return e && e.constructor === Symbol ? "symbol" : typeof e;
  }
  function n(e, t) {
    var i,
      n,
      a,
      o,
      r = function (e) {
        return function (t) {
          return s([e, t]);
        };
      },
      s = function (r) {
        if (i) throw new TypeError("Generator is already executing.");
        for (; o && ((o = 0), r[0] && (l = 0)), l; )
          try {
            if (
              ((i = 1),
              n &&
                (a =
                  2 & r[0]
                    ? n.return
                    : r[0]
                    ? n.throw || ((a = n.return) && a.call(n), 0)
                    : n.next) &&
                !(a = a.call(n, r[1])).done)
            )
              return a;
            switch (((n = 0), a && (r = [2 & r[0], a.value]), r[0])) {
              case 0:
              case 1:
                a = r;
                break;
              case 4:
                return l.label++, { value: r[1], done: !1 };
              case 5:
                l.label++, (n = r[1]), (r = [0]);
                continue;
              case 7:
                (r = l.ops.pop()), l.trys.pop();
                continue;
              default:
                if (
                  !((a = l.trys),
                  (a = a.length > 0 && a[a.length - 1]) ||
                    (6 !== r[0] && 2 !== r[0]))
                ) {
                  l = 0;
                  continue;
                }
                if (3 === r[0] && (!a || (r[1] > a[0] && r[1] < a[3]))) {
                  l.label = r[1];
                  break;
                }
                if (6 === r[0] && l.label < a[1]) {
                  (l.label = a[1]), (a = r);
                  break;
                }
                if (a && l.label < a[2]) {
                  (l.label = a[2]), l.ops.push(r);
                  break;
                }
                a[2] && l.ops.pop(), l.trys.pop();
                continue;
            }
            r = t.call(e, l);
          } catch (e) {
            (r = [6, e]), (n = 0);
          } finally {
            i = a = 0;
          }
        if (5 & r[0]) throw r[1];
        return { value: r[0] ? r[1] : void 0, done: !0 };
      },
      l = {
        label: 0,
        sent: function () {
          if (1 & a[0]) throw a[1];
          return a[1];
        },
        trys: [],
        ops: [],
      };
    return (
      (o = { next: r(0), throw: r(1), return: r(2) }),
      "function" == typeof Symbol &&
        (o[Symbol.iterator] = function () {
          return this;
        }),
      o
    );
  }
  Object.create;
  Object.create;
  function a(e) {
    if (Array.isArray(e)) return e;
  }
  function o(e) {
    if (
      ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
      null != e["@@iterator"]
    )
      return Array.from(e);
  }
  function r() {
    throw new TypeError(
      "Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
    );
  }
  function s(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var i = 0, n = new Array(t); i < t; i++) n[i] = e[i];
    return n;
  }
  function l(e, t) {
    if (e) {
      if ("string" == typeof e) return s(e, t);
      var i = Object.prototype.toString.call(e).slice(8, -1);
      return (
        "Object" === i && e.constructor && (i = e.constructor.name),
        "Map" === i || "Set" === i
          ? Array.from(i)
          : "Arguments" === i ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
          ? s(e, t)
          : void 0
      );
    }
  }
  function c(e, t) {
    return a(e) || o(e) || l(e, t) || r();
  }
  var u,
    d = window.ThemeVars;
  function p(e) {
    var t = new FormData(e),
      i = {},
      n = !0,
      a = !1,
      o = void 0;
    try {
      for (
        var r, s = t.entries()[Symbol.iterator]();
        !(n = (r = s.next()).done);
        n = !0
      ) {
        var l = c(r.value, 2),
          u = l[0],
          d = l[1];
        if (u.includes("[]")) {
          var p = u.replace("[]", "");
          i[p] || (i[p] = []), i[p].push(d);
        } else i[u] = d;
      }
    } catch (e) {
      (a = !0), (o = e);
    } finally {
      try {
        n || null == s.return || s.return();
      } finally {
        if (a) throw o;
      }
    }
    return i;
  }
  function f(e) {
    return Array.isArray(e)
      ? 0 === e.length
      : "object" == typeof e
      ? 0 === Object.keys(e).length
      : "" === e;
  }
  function h(e, t) {
    if ("boolean" != typeof t)
      return console.error(
        "Invalid value for  cookie, expected true or false."
      );
    document.cookie = ""
      .concat(e, "=")
      .concat(t, "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/");
  }
  function g(e, t) {
    for (var i = 0; i < v.length; i++) if (v[i][e] === t) return v[i];
    return null;
  }
  u = function (e) {
    if (!isNaN(parseInt(e))) return g("isoNo", e.toString());
    if (2 === e.length) return g("iso2", e.toUpperCase());
    if (3 === e.length) return g("iso3", e.toUpperCase());
    throw new Error("cannot determine ISO code type");
  };
  var v = [
    {
      continent: "Asia",
      region: "South Asia",
      country: "Afghanistan",
      capital: "Kabul",
      fips: "AF",
      iso2: "AF",
      iso3: "AFG",
      isoNo: "4",
      internet: "AF",
    },
    {
      continent: "Europe",
      region: "South East Europe",
      country: "Albania",
      capital: "Tirana",
      fips: "AL",
      iso2: "AL",
      iso3: "ALB",
      isoNo: "8",
      internet: "AL",
    },
    {
      continent: "Africa",
      region: "Northern Africa",
      country: "Algeria",
      capital: "Algiers",
      fips: "AG",
      iso2: "DZ",
      iso3: "DZA",
      isoNo: "12",
      internet: "DZ",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "American Samoa",
      capital: "Pago Pago",
      fips: "AQ",
      iso2: "AS",
      iso3: "ASM",
      isoNo: "16",
      internet: "AS",
    },
    {
      continent: "Europe",
      region: "South West Europe",
      country: "Andorra",
      capital: "Andorra la Vella",
      fips: "AN",
      iso2: "AD",
      iso3: "AND",
      isoNo: "20",
      internet: "AD",
    },
    {
      continent: "Africa",
      region: "Southern Africa",
      country: "Angola",
      capital: "Luanda",
      fips: "AO",
      iso2: "AO",
      iso3: "AGO",
      isoNo: "24",
      internet: "AO",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Anguilla",
      capital: "The Valley",
      fips: "AV",
      iso2: "AI",
      iso3: "AIA",
      isoNo: "660",
      internet: "AI",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Antigua and Barbuda",
      capital: "Saint John's",
      fips: "AC",
      iso2: "AG",
      iso3: "ATG",
      isoNo: "28",
      internet: "AG",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Argentina",
      capital: "Buenos Aires",
      fips: "AR",
      iso2: "AR",
      iso3: "ARG",
      isoNo: "32",
      internet: "AR",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Armenia",
      capital: "Yerevan",
      fips: "AM",
      iso2: "AM",
      iso3: "ARM",
      isoNo: "51",
      internet: "AM",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Aruba",
      capital: "Oranjestad",
      fips: "AA",
      iso2: "AW",
      iso3: "ABW",
      isoNo: "533",
      internet: "AW",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Australia",
      capital: "Canberra",
      fips: "AS",
      iso2: "AU",
      iso3: "AUS",
      isoNo: "36",
      internet: "AU",
    },
    {
      continent: "Europe",
      region: "Central Europe",
      country: "Austria",
      capital: "Vienna",
      fips: "AU",
      iso2: "AT",
      iso3: "AUT",
      isoNo: "40",
      internet: "AT",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Azerbaijan",
      capital: "Baku (Baki)",
      fips: "AJ",
      iso2: "AZ",
      iso3: "AZE",
      isoNo: "31",
      internet: "AZ",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "The Bahamas",
      capital: "Nassau",
      fips: "BF",
      iso2: "BS",
      iso3: "BHS",
      isoNo: "44",
      internet: "BS",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Bahrain",
      capital: "Manama",
      fips: "BA",
      iso2: "BH",
      iso3: "BHR",
      isoNo: "48",
      internet: "BH",
    },
    {
      continent: "Asia",
      region: "South Asia",
      country: "Bangladesh",
      capital: "Dhaka",
      fips: "BG",
      iso2: "BD",
      iso3: "BGD",
      isoNo: "50",
      internet: "BD",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Barbados",
      capital: "Bridgetown",
      fips: "BB",
      iso2: "BB",
      iso3: "BRB",
      isoNo: "52",
      internet: "BB",
    },
    {
      continent: "Europe",
      region: "Eastern Europe",
      country: "Belarus",
      capital: "Minsk",
      fips: "BO",
      iso2: "BY",
      iso3: "BLR",
      isoNo: "112",
      internet: "BY",
    },
    {
      continent: "Europe",
      region: "Western Europe",
      country: "Belgium",
      capital: "Brussels",
      fips: "BE",
      iso2: "BE",
      iso3: "BEL",
      isoNo: "56",
      internet: "BE",
    },
    {
      continent: "Americas",
      region: "Central America",
      country: "Belize",
      capital: "Belmopan",
      fips: "BH",
      iso2: "BZ",
      iso3: "BLZ",
      isoNo: "84",
      internet: "BZ",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Benin",
      capital: "Porto-Novo��",
      fips: "BN",
      iso2: "BJ",
      iso3: "BEN",
      isoNo: "204",
      internet: "BJ",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Bermuda",
      capital: "Hamilton",
      fips: "BD",
      iso2: "BM",
      iso3: "BMU",
      isoNo: "60",
      internet: "BM",
    },
    {
      continent: "Asia",
      region: "South Asia",
      country: "Bhutan",
      capital: "Thimphu",
      fips: "BT",
      iso2: "BT",
      iso3: "BTN",
      isoNo: "64",
      internet: "BT",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Bolivia",
      capital: "La Paz / Sucre",
      fips: "BL",
      iso2: "BO",
      iso3: "BOL",
      isoNo: "68",
      internet: "BO",
    },
    {
      continent: "Europe",
      region: "South East Europe",
      country: "Bosnia and Herzegovina",
      capital: "Sarajevo",
      fips: "BK",
      iso2: "BA",
      iso3: "BIH",
      isoNo: "70",
      internet: "BA",
    },
    {
      continent: "Africa",
      region: "Southern Africa",
      country: "Botswana",
      capital: "Gaborone",
      fips: "BC",
      iso2: "BW",
      iso3: "BWA",
      isoNo: "72",
      internet: "BW",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Brazil",
      capital: "Brasilia",
      fips: "BR",
      iso2: "BR",
      iso3: "BRA",
      isoNo: "76",
      internet: "BR",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "British Virgin Islands",
      capital: "Road Town",
      fips: "VI",
      iso2: "VG",
      iso3: "VGB",
      isoNo: "92",
      internet: "VG",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Brunei",
      capital: "Bandar Seri Begawan",
      fips: "BX",
      iso2: "BN",
      iso3: "BRN",
      isoNo: "96",
      internet: "BN",
    },
    {
      continent: "Europe",
      region: "South East Europe",
      country: "Bulgaria",
      capital: "Sofia",
      fips: "BU",
      iso2: "BG",
      iso3: "BGR",
      isoNo: "100",
      internet: "BG",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Burkina Faso",
      capital: "Ouagadougou",
      fips: "UV",
      iso2: "BF",
      iso3: "BFA",
      isoNo: "854",
      internet: "BF",
    },
    {
      continent: "Africa",
      region: "Central Africa",
      country: "Burundi",
      capital: "Bujumbura",
      fips: "BY",
      iso2: "BI",
      iso3: "BDI",
      isoNo: "108",
      internet: "BI",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Cambodia",
      capital: "Phnom Penh",
      fips: "CB",
      iso2: "KH",
      iso3: "KHM",
      isoNo: "116",
      internet: "KH",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Cameroon",
      capital: "Yaounde",
      fips: "CM",
      iso2: "CM",
      iso3: "CMR",
      isoNo: "120",
      internet: "CM",
    },
    {
      continent: "Americas",
      region: "North America",
      country: "Canada",
      capital: "Ottawa",
      fips: "CA",
      iso2: "CA",
      iso3: "CAN",
      isoNo: "124",
      internet: "CA",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Cape Verde",
      capital: "Praia",
      fips: "CV",
      iso2: "CV",
      iso3: "CPV",
      isoNo: "132",
      internet: "CV",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Cayman Islands",
      capital: "George Town",
      fips: "CJ",
      iso2: "KY",
      iso3: "CYM",
      isoNo: "136",
      internet: "KY",
    },
    {
      continent: "Africa",
      region: "Central Africa",
      country: "Central African Republic",
      capital: "Bangui",
      fips: "CT",
      iso2: "CF",
      iso3: "CAF",
      isoNo: "140",
      internet: "CF",
    },
    {
      continent: "Africa",
      region: "Central Africa",
      country: "Chad",
      capital: "N'Djamena",
      fips: "CD",
      iso2: "TD",
      iso3: "TCD",
      isoNo: "148",
      internet: "TD",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Chile",
      capital: "Santiago",
      fips: "CI",
      iso2: "CL",
      iso3: "CHL",
      isoNo: "152",
      internet: "CL",
    },
    {
      continent: "Asia",
      region: "East Asia",
      country: "China",
      capital: "Beijing",
      fips: "CH",
      iso2: "CN",
      iso3: "CHN",
      isoNo: "156",
      internet: "CN",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Christmas Island",
      capital: "The Settlement",
      fips: "KT",
      iso2: "CX",
      iso3: "CXR",
      isoNo: "162",
      internet: "CX",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Cocos (Keeling) Islands",
      capital: "West Island",
      fips: "CK",
      iso2: "CC",
      iso3: "CCK",
      isoNo: "166",
      internet: "CC",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Colombia",
      capital: "Bogota",
      fips: "CO",
      iso2: "CO",
      iso3: "COL",
      isoNo: "170",
      internet: "CO",
    },
    {
      continent: "Africa",
      region: "Indian Ocean",
      country: "Comoros",
      capital: "Moroni",
      fips: "CN",
      iso2: "KM",
      iso3: "COM",
      isoNo: "174",
      internet: "KM",
    },
    {
      continent: "Africa",
      region: "Central Africa",
      country: "Republic of the Congo",
      capital: "Brazzaville",
      fips: "CF",
      iso2: "CG",
      iso3: "COG",
      isoNo: "178",
      internet: "CG",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Cook Islands",
      capital: "Avarua",
      fips: "CW",
      iso2: "CK",
      iso3: "COK",
      isoNo: "184",
      internet: "CK",
    },
    {
      continent: "Americas",
      region: "Central America",
      country: "Costa Rica",
      capital: "San Jose",
      fips: "CS",
      iso2: "CR",
      iso3: "CRI",
      isoNo: "188",
      internet: "CR",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Cote d'Ivoire",
      capital: "Yamoussoukro",
      fips: "IV",
      iso2: "CI",
      iso3: "CIV",
      isoNo: "384",
      internet: "CI",
    },
    {
      continent: "Europe",
      region: "South East Europe",
      country: "Croatia",
      capital: "Zagreb",
      fips: "HR",
      iso2: "HR",
      iso3: "HRV",
      isoNo: "191",
      internet: "HR",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Cuba",
      capital: "Havana",
      fips: "CU",
      iso2: "CU",
      iso3: "CUB",
      isoNo: "192",
      internet: "CU",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Cyprus",
      capital: "Nicosia",
      fips: "CY",
      iso2: "CY",
      iso3: "CYP",
      isoNo: "196",
      internet: "CY",
    },
    {
      continent: "Europe",
      region: "Central Europe",
      country: "Czech Republic",
      capital: "Prague",
      fips: "EZ",
      iso2: "CZ",
      iso3: "CZE",
      isoNo: "203",
      internet: "CZ",
    },
    {
      continent: "Europe",
      region: "Northern Europe",
      country: "Denmark",
      capital: "Copenhagen",
      fips: "DA",
      iso2: "DK",
      iso3: "DNK",
      isoNo: "208",
      internet: "DK",
    },
    {
      continent: "Africa",
      region: "Eastern Africa",
      country: "Djibouti",
      capital: "Djibouti",
      fips: "DJ",
      iso2: "DJ",
      iso3: "DJI",
      isoNo: "262",
      internet: "DJ",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Dominica",
      capital: "Roseau",
      fips: "DO",
      iso2: "DM",
      iso3: "DMA",
      isoNo: "212",
      internet: "DM",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Dominican Republic",
      capital: "Santo Domingo",
      fips: "DR",
      iso2: "DO",
      iso3: "DOM",
      isoNo: "214",
      internet: "DO",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Ecuador",
      capital: "Quito",
      fips: "EC",
      iso2: "EC",
      iso3: "ECU",
      isoNo: "218",
      internet: "EC",
    },
    {
      continent: "Africa",
      region: "Northern Africa",
      country: "Egypt",
      capital: "Cairo",
      fips: "EG",
      iso2: "EG",
      iso3: "EGY",
      isoNo: "818",
      internet: "EG",
    },
    {
      continent: "Americas",
      region: "Central America",
      country: "El Salvador",
      capital: "San Salvador",
      fips: "ES",
      iso2: "SV",
      iso3: "SLV",
      isoNo: "222",
      internet: "SV",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Equatorial Guinea",
      capital: "Malabo",
      fips: "EK",
      iso2: "GQ",
      iso3: "GNQ",
      isoNo: "226",
      internet: "GQ",
    },
    {
      continent: "Africa",
      region: "Eastern Africa",
      country: "Eritrea",
      capital: "Asmara",
      fips: "ER",
      iso2: "ER",
      iso3: "ERI",
      isoNo: "232",
      internet: "ER",
    },
    {
      continent: "Europe",
      region: "Eastern Europe",
      country: "Estonia",
      capital: "Tallinn",
      fips: "EN",
      iso2: "EE",
      iso3: "EST",
      isoNo: "233",
      internet: "EE",
    },
    {
      continent: "Africa",
      region: "Eastern Africa",
      country: "Ethiopia",
      capital: "Addis Ababa",
      fips: "ET",
      iso2: "ET",
      iso3: "ETH",
      isoNo: "231",
      internet: "ET",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Falkland Islands (Islas Malvinas)",
      capital: "Stanley",
      fips: "FA",
      iso2: "FK",
      iso3: "FLK",
      isoNo: "238",
      internet: "FK",
    },
    {
      continent: "Europe",
      region: "Northern Europe",
      country: "Faroe Islands",
      capital: "Torshavn",
      fips: "FO",
      iso2: "FO",
      iso3: "FRO",
      isoNo: "234",
      internet: "FO",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Fiji",
      capital: "Suva",
      fips: "FJ",
      iso2: "FJ",
      iso3: "FJI",
      isoNo: "242",
      internet: "FJ",
    },
    {
      continent: "Europe",
      region: "Northern Europe",
      country: "Finland",
      capital: "Helsinki",
      fips: "FI",
      iso2: "FI",
      iso3: "FIN",
      isoNo: "246",
      internet: "FI",
    },
    {
      continent: "Europe",
      region: "Western Europe",
      country: "France",
      capital: "Paris",
      fips: "FR",
      iso2: "FR",
      iso3: "FRA",
      isoNo: "250",
      internet: "FR",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "French Guiana",
      capital: "Cayenne",
      fips: "FG",
      iso2: "GF",
      iso3: "GUF",
      isoNo: "254",
      internet: "GF",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "French Polynesia",
      capital: "Papeete",
      fips: "FP",
      iso2: "PF",
      iso3: "PYF",
      isoNo: "258",
      internet: "PF",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Gabon",
      capital: "Libreville",
      fips: "GB",
      iso2: "GA",
      iso3: "GAB",
      isoNo: "266",
      internet: "GA",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "The Gambia",
      capital: "Banjul",
      fips: "GA",
      iso2: "GM",
      iso3: "GMB",
      isoNo: "270",
      internet: "GM",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Georgia",
      capital: "T'bilisi",
      fips: "GG",
      iso2: "GE",
      iso3: "GEO",
      isoNo: "268",
      internet: "GE",
    },
    {
      continent: "Europe",
      region: "Western Europe",
      country: "Germany",
      capital: "Berlin",
      fips: "GM",
      iso2: "DE",
      iso3: "DEU",
      isoNo: "276",
      internet: "DE",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Ghana",
      capital: "Accra",
      fips: "GH",
      iso2: "GH",
      iso3: "GHA",
      isoNo: "288",
      internet: "GH",
    },
    {
      continent: "Europe",
      region: "South West Europe",
      country: "Gibraltar",
      capital: "Gibraltar",
      fips: "GI",
      iso2: "GI",
      iso3: "GIB",
      isoNo: "292",
      internet: "GI",
    },
    {
      continent: "Europe",
      region: "South East Europe",
      country: "Greece",
      capital: "Athens",
      fips: "GR",
      iso2: "GR",
      iso3: "GRC",
      isoNo: "300",
      internet: "GR",
    },
    {
      continent: "Americas",
      region: "North America",
      country: "Greenland",
      capital: "Nuuk (Godthab)",
      fips: "GL",
      iso2: "GL",
      iso3: "GRL",
      isoNo: "304",
      internet: "GL",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Grenada",
      capital: "Saint George's",
      fips: "GJ",
      iso2: "GD",
      iso3: "GRD",
      isoNo: "308",
      internet: "GD",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Guadeloupe",
      capital: "Basse-Terre",
      fips: "GP",
      iso2: "GP",
      iso3: "GLP",
      isoNo: "312",
      internet: "GP",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Guam",
      capital: "Hagatna (Agana)",
      fips: "GQ",
      iso2: "GU",
      iso3: "GUM",
      isoNo: "316",
      internet: "GU",
    },
    {
      continent: "Americas",
      region: "Central America",
      country: "Guatemala",
      capital: "Guatemala",
      fips: "GT",
      iso2: "GT",
      iso3: "GTM",
      isoNo: "320",
      internet: "GT",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Guinea",
      capital: "Conakry",
      fips: "GV",
      iso2: "GN",
      iso3: "GIN",
      isoNo: "324",
      internet: "GN",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Guinea-Bissau",
      capital: "Bissau",
      fips: "PU",
      iso2: "GW",
      iso3: "GNB",
      isoNo: "624",
      internet: "GW",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Guyana",
      capital: "Georgetown",
      fips: "GY",
      iso2: "GY",
      iso3: "GUY",
      isoNo: "328",
      internet: "GY",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Haiti",
      capital: "Port-au-Prince",
      fips: "HA",
      iso2: "HT",
      iso3: "HTI",
      isoNo: "332",
      internet: "HT",
    },
    {
      continent: "Europe",
      region: "Southern Europe",
      country: "Holy See (Vatican City)",
      capital: "Vatican City",
      fips: "VT",
      iso2: "VA",
      iso3: "VAT",
      isoNo: "336",
      internet: "VA",
    },
    {
      continent: "Americas",
      region: "Central America",
      country: "Honduras",
      capital: "Tegucigalpa",
      fips: "HO",
      iso2: "HN",
      iso3: "HND",
      isoNo: "340",
      internet: "HN",
    },
    {
      continent: "Europe",
      region: "Central Europe",
      country: "Hungary",
      capital: "Budapest",
      fips: "HU",
      iso2: "HU",
      iso3: "HUN",
      isoNo: "348",
      internet: "HU",
    },
    {
      continent: "Europe",
      region: "Northern Europe",
      country: "Iceland",
      capital: "Reykjavik",
      fips: "IC",
      iso2: "IS",
      iso3: "ISL",
      isoNo: "352",
      internet: "IS",
    },
    {
      continent: "Asia",
      region: "South Asia",
      country: "India",
      capital: "New Delhi",
      fips: "IN",
      iso2: "IN",
      iso3: "IND",
      isoNo: "356",
      internet: "IN",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Indonesia",
      capital: "Jakarta",
      fips: "ID",
      iso2: "ID",
      iso3: "IDN",
      isoNo: "360",
      internet: "ID",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Iran",
      capital: "Tehran",
      fips: "IR",
      iso2: "IR",
      iso3: "IRN",
      isoNo: "364",
      internet: "IR",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Iraq",
      capital: "Baghdad",
      fips: "IZ",
      iso2: "IQ",
      iso3: "IRQ",
      isoNo: "368",
      internet: "IQ",
    },
    {
      continent: "Europe",
      region: "Western Europe",
      country: "Ireland",
      capital: "Dublin",
      fips: "EI",
      iso2: "IE",
      iso3: "IRL",
      isoNo: "372",
      internet: "IE",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Israel",
      capital: "Jerusalem",
      fips: "IS",
      iso2: "IL",
      iso3: "ISR",
      isoNo: "376",
      internet: "IL",
    },
    {
      continent: "Europe",
      region: "Southern Europe",
      country: "Italy",
      capital: "Rome",
      fips: "IT",
      iso2: "IT",
      iso3: "ITA",
      isoNo: "380",
      internet: "IT",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Jamaica",
      capital: "Kingston",
      fips: "JM",
      iso2: "JM",
      iso3: "JAM",
      isoNo: "388",
      internet: "JM",
    },
    {
      continent: "Asia",
      region: "East Asia",
      country: "Japan",
      capital: "Tokyo",
      fips: "JA",
      iso2: "JP",
      iso3: "JPN",
      isoNo: "392",
      internet: "JP",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Jordan",
      capital: "Amman",
      fips: "JO",
      iso2: "JO",
      iso3: "JOR",
      isoNo: "400",
      internet: "JO",
    },
    {
      continent: "Asia",
      region: "Central Asia",
      country: "Kazakhstan",
      capital: "Astana (Akmola)",
      fips: "KZ",
      iso2: "KZ",
      iso3: "KAZ",
      isoNo: "398",
      internet: "KZ",
    },
    {
      continent: "Africa",
      region: "Eastern Africa",
      country: "Kenya",
      capital: "Nairobi",
      fips: "KE",
      iso2: "KE",
      iso3: "KEN",
      isoNo: "404",
      internet: "KE",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Kiribati",
      capital: "Tarawa",
      fips: "KR",
      iso2: "KI",
      iso3: "KIR",
      isoNo: "296",
      internet: "KI",
    },
    {
      continent: "Asia",
      region: "East Asia",
      country: "North Korea",
      capital: "P'yongyang",
      fips: "KN",
      iso2: "KP",
      iso3: "PRK",
      isoNo: "408",
      internet: "KP",
    },
    {
      continent: "Asia",
      region: "East Asia",
      country: "South Korea",
      capital: "Seoul",
      fips: "KS",
      iso2: "KR",
      iso3: "KOR",
      isoNo: "410",
      internet: "KR",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Kuwait",
      capital: "Kuwait",
      fips: "KU",
      iso2: "KW",
      iso3: "KWT",
      isoNo: "414",
      internet: "KW",
    },
    {
      continent: "Asia",
      region: "Central Asia",
      country: "Kyrgyzstan",
      capital: "Bishkek",
      fips: "KG",
      iso2: "KG",
      iso3: "KGZ",
      isoNo: "417",
      internet: "KG",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Laos",
      capital: "Vientiane",
      fips: "LA",
      iso2: "LA",
      iso3: "LAO",
      isoNo: "418",
      internet: "LA",
    },
    {
      continent: "Europe",
      region: "Eastern Europe",
      country: "Latvia",
      capital: "Riga",
      fips: "LG",
      iso2: "LV",
      iso3: "LVA",
      isoNo: "428",
      internet: "LV",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Lebanon",
      capital: "Beirut",
      fips: "LE",
      iso2: "LB",
      iso3: "LBN",
      isoNo: "422",
      internet: "LB",
    },
    {
      continent: "Africa",
      region: "Southern Africa",
      country: "Lesotho",
      capital: "Maseru",
      fips: "LT",
      iso2: "LS",
      iso3: "LSO",
      isoNo: "426",
      internet: "LS",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Liberia",
      capital: "Monrovia",
      fips: "LI",
      iso2: "LR",
      iso3: "LBR",
      isoNo: "430",
      internet: "LR",
    },
    {
      continent: "Africa",
      region: "Northern Africa",
      country: "Libya",
      capital: "Tripoli",
      fips: "LY",
      iso2: "LY",
      iso3: "LBY",
      isoNo: "434",
      internet: "LY",
    },
    {
      continent: "Europe",
      region: "Central Europe",
      country: "Liechtenstein",
      capital: "Vaduz",
      fips: "LS",
      iso2: "LI",
      iso3: "LIE",
      isoNo: "438",
      internet: "LI",
    },
    {
      continent: "Europe",
      region: "Eastern Europe",
      country: "Lithuania",
      capital: "Vilnius",
      fips: "LH",
      iso2: "LT",
      iso3: "LTU",
      isoNo: "440",
      internet: "LT",
    },
    {
      continent: "Europe",
      region: "Western Europe",
      country: "Luxembourg",
      capital: "Luxembourg",
      fips: "LU",
      iso2: "LU",
      iso3: "LUX",
      isoNo: "442",
      internet: "LU",
    },
    {
      continent: "Europe",
      region: "South East Europe",
      country: "North Macedonia",
      capital: "Skopje",
      fips: "MK",
      iso2: "MK",
      iso3: "MKD",
      isoNo: "807",
      internet: "MK",
    },
    {
      continent: "Africa",
      region: "Indian Ocean",
      country: "Madagascar",
      capital: "Antananarivo",
      fips: "MA",
      iso2: "MG",
      iso3: "MDG",
      isoNo: "450",
      internet: "MG",
    },
    {
      continent: "Africa",
      region: "Southern Africa",
      country: "Malawi",
      capital: "Lilongwe",
      fips: "MI",
      iso2: "MW",
      iso3: "MWI",
      isoNo: "454",
      internet: "MW",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Malaysia",
      capital: "Kuala Lumpur",
      fips: "MY",
      iso2: "MY",
      iso3: "MYS",
      isoNo: "458",
      internet: "MY",
    },
    {
      continent: "Asia",
      region: "South Asia",
      country: "Maldives",
      capital: "Male (Maale)",
      fips: "MV",
      iso2: "MV",
      iso3: "MDV",
      isoNo: "462",
      internet: "MV",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Mali",
      capital: "Bamako",
      fips: "ML",
      iso2: "ML",
      iso3: "MLI",
      isoNo: "466",
      internet: "ML",
    },
    {
      continent: "Europe",
      region: "Southern Europe",
      country: "Malta",
      capital: "Valletta",
      fips: "MT",
      iso2: "MT",
      iso3: "MLT",
      isoNo: "470",
      internet: "MT",
    },
    {
      continent: "Europe",
      region: "Western Europe",
      country: "Isle of Man",
      capital: "Douglas",
      fips: "IM",
      iso2: "IM",
      iso3: "IMN",
      isoNo: "833",
      internet: "IM",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Marshall Islands",
      capital: "Majuro",
      fips: "RM",
      iso2: "MH",
      iso3: "MHL",
      isoNo: "584",
      internet: "MH",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Martinique",
      capital: "Fort-de-France",
      fips: "MB",
      iso2: "MQ",
      iso3: "MTQ",
      isoNo: "474",
      internet: "MQ",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Mauritania",
      capital: "Nouakchott",
      fips: "MR",
      iso2: "MR",
      iso3: "MRT",
      isoNo: "478",
      internet: "MR",
    },
    {
      continent: "Africa",
      region: "Indian Ocean",
      country: "Mauritius",
      capital: "Port Louis",
      fips: "MP",
      iso2: "MU",
      iso3: "MUS",
      isoNo: "480",
      internet: "MU",
    },
    {
      continent: "Africa",
      region: "Indian Ocean",
      country: "Mayotte",
      capital: "Mamoutzou",
      fips: "MF",
      iso2: "YT",
      iso3: "MYT",
      isoNo: "175",
      internet: "YT",
    },
    {
      continent: "Americas",
      region: "Central America",
      country: "Mexico",
      capital: "Mexico",
      fips: "MX",
      iso2: "MX",
      iso3: "MEX",
      isoNo: "484",
      internet: "MX",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Federated States of Micronesia",
      capital: "Palikir",
      fips: "",
      iso2: "FM",
      iso3: "FSM",
      isoNo: "583",
      internet: "FM",
    },
    {
      continent: "Europe",
      region: "Eastern Europe",
      country: "Moldova",
      capital: "Chisinau",
      fips: "MD",
      iso2: "MD",
      iso3: "MDA",
      isoNo: "498",
      internet: "MD",
    },
    {
      continent: "Europe",
      region: "Western Europe",
      country: "Monaco",
      capital: "Monaco",
      fips: "MN",
      iso2: "MC",
      iso3: "MCO",
      isoNo: "492",
      internet: "MC",
    },
    {
      continent: "Asia",
      region: "Northern Asia",
      country: "Mongolia",
      capital: "Ulaanbaatar",
      fips: "MG",
      iso2: "MN",
      iso3: "MNG",
      isoNo: "496",
      internet: "MN",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Montserrat",
      capital: "Plymouth",
      fips: "MH",
      iso2: "MS",
      iso3: "MSR",
      isoNo: "500",
      internet: "MS",
    },
    {
      continent: "Africa",
      region: "Northern Africa",
      country: "Morocco",
      capital: "Rabat",
      fips: "MO",
      iso2: "MA",
      iso3: "MAR",
      isoNo: "504",
      internet: "MA",
    },
    {
      continent: "Africa",
      region: "Southern Africa",
      country: "Mozambique",
      capital: "Maputo",
      fips: "MZ",
      iso2: "MZ",
      iso3: "MOZ",
      isoNo: "508",
      internet: "MZ",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Myanmar (Burma)",
      capital: "Rangoon (Yangon)",
      fips: "BM",
      iso2: "MM",
      iso3: "MMR",
      isoNo: "104",
      internet: "MM",
    },
    {
      continent: "Africa",
      region: "Southern Africa",
      country: "Namibia",
      capital: "Windhoek",
      fips: "WA",
      iso2: "NA",
      iso3: "NAM",
      isoNo: "516",
      internet: "NA",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Nauru",
      capital: "no official capital",
      fips: "NR",
      iso2: "NR",
      iso3: "NRU",
      isoNo: "520",
      internet: "NR",
    },
    {
      continent: "Asia",
      region: "South Asia",
      country: "Nepal",
      capital: "Kathmandu",
      fips: "NP",
      iso2: "NP",
      iso3: "NPL",
      isoNo: "524",
      internet: "NP",
    },
    {
      continent: "Europe",
      region: "Western Europe",
      country: "Netherlands",
      capital: "Amsterdam",
      fips: "NL",
      iso2: "NL",
      iso3: "NLD",
      isoNo: "528",
      internet: "NL",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Netherlands Antilles",
      capital: "Willemstad",
      fips: "NT",
      iso2: "AN",
      iso3: "ANT",
      isoNo: "530",
      internet: "AN",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "New Caledonia",
      capital: "Noumea",
      fips: "NC",
      iso2: "NC",
      iso3: "NCL",
      isoNo: "540",
      internet: "NC",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "New Zealand",
      capital: "Wellington",
      fips: "NZ",
      iso2: "NZ",
      iso3: "NZL",
      isoNo: "554",
      internet: "NZ",
    },
    {
      continent: "Americas",
      region: "Central America",
      country: "Nicaragua",
      capital: "Managua",
      fips: "NU",
      iso2: "NI",
      iso3: "NIC",
      isoNo: "558",
      internet: "NI",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Niger",
      capital: "Niamey",
      fips: "NG",
      iso2: "NE",
      iso3: "NER",
      isoNo: "562",
      internet: "NE",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Nigeria",
      capital: "Abuja",
      fips: "NI",
      iso2: "NG",
      iso3: "NGA",
      isoNo: "566",
      internet: "NG",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Niue",
      capital: "Alofi",
      fips: "NE",
      iso2: "NU",
      iso3: "NIU",
      isoNo: "570",
      internet: "NU",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Norfolk Island",
      capital: "Kingston",
      fips: "NF",
      iso2: "NF",
      iso3: "NFK",
      isoNo: "574",
      internet: "NF",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Northern Mariana Islands",
      capital: "Saipan",
      fips: "CQ",
      iso2: "MP",
      iso3: "MNP",
      isoNo: "580",
      internet: "MP",
    },
    {
      continent: "Europe",
      region: "Northern Europe",
      country: "Norway",
      capital: "Oslo",
      fips: "NO",
      iso2: "NO",
      iso3: "NOR",
      isoNo: "578",
      internet: "NO",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Oman",
      capital: "Muscat",
      fips: "MU",
      iso2: "OM",
      iso3: "OMN",
      isoNo: "512",
      internet: "OM",
    },
    {
      continent: "Asia",
      region: "South Asia",
      country: "Pakistan",
      capital: "Islamabad",
      fips: "PK",
      iso2: "PK",
      iso3: "PAK",
      isoNo: "586",
      internet: "PK",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Palau",
      capital: "Koror",
      fips: "PS",
      iso2: "PW",
      iso3: "PLW",
      isoNo: "585",
      internet: "PW",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Palestinian Territory",
      capital: "East Jerusalem",
      fips: "WE",
      iso2: "PS",
      iso3: "PSE",
      isoNo: "275",
      internet: "PS",
    },
    {
      continent: "Americas",
      region: "Central America",
      country: "Panama",
      capital: "Panama",
      fips: "PM",
      iso2: "PA",
      iso3: "PAN",
      isoNo: "591",
      internet: "PA",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Papua New Guinea",
      capital: "Port Moresby",
      fips: "PP",
      iso2: "PG",
      iso3: "PNG",
      isoNo: "598",
      internet: "PG",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Paraguay",
      capital: "Asuncion",
      fips: "PA",
      iso2: "PY",
      iso3: "PRY",
      isoNo: "600",
      internet: "PY",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Peru",
      capital: "Lima",
      fips: "PE",
      iso2: "PE",
      iso3: "PER",
      isoNo: "604",
      internet: "PE",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Philippines",
      capital: "Manila",
      fips: "RP",
      iso2: "PH",
      iso3: "PHL",
      isoNo: "608",
      internet: "PH",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Pitcairn Islands",
      capital: "Adamstown",
      fips: "PC",
      iso2: "PN",
      iso3: "PCN",
      isoNo: "612",
      internet: "PN",
    },
    {
      continent: "Europe",
      region: "Eastern Europe",
      country: "Poland",
      capital: "Warsaw",
      fips: "PL",
      iso2: "PL",
      iso3: "POL",
      isoNo: "616",
      internet: "PL",
    },
    {
      continent: "Europe",
      region: "South West Europe",
      country: "Portugal",
      capital: "Lisbon",
      fips: "PO",
      iso2: "PT",
      iso3: "PRT",
      isoNo: "620",
      internet: "PT",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Puerto Rico",
      capital: "San Juan",
      fips: "RQ",
      iso2: "PR",
      iso3: "PRI",
      isoNo: "630",
      internet: "PR",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Qatar",
      capital: "Doha",
      fips: "QA",
      iso2: "QA",
      iso3: "QAT",
      isoNo: "634",
      internet: "QA",
    },
    {
      continent: "Africa",
      region: "Indian Ocean",
      country: "Reunion",
      capital: "Saint-Denis",
      fips: "RE",
      iso2: "RE",
      iso3: "REU",
      isoNo: "638",
      internet: "RE",
    },
    {
      continent: "Europe",
      region: "South East Europe",
      country: "Romania",
      capital: "Bucharest",
      fips: "RO",
      iso2: "RO",
      iso3: "ROU",
      isoNo: "642",
      internet: "RO",
    },
    {
      continent: "Asia",
      region: "Northern Asia",
      country: "Russia",
      capital: "Moscow",
      fips: "RS",
      iso2: "RU",
      iso3: "RUS",
      isoNo: "643",
      internet: "RU",
    },
    {
      continent: "Africa",
      region: "Central Africa",
      country: "Rwanda",
      capital: "Kigali",
      fips: "RW",
      iso2: "RW",
      iso3: "RWA",
      isoNo: "646",
      internet: "RW",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Saint Kitts and Nevis",
      capital: "Basseterre",
      fips: "SC",
      iso2: "KN",
      iso3: "KNA",
      isoNo: "659",
      internet: "KN",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Saint Lucia",
      capital: "Castries",
      fips: "ST",
      iso2: "LC",
      iso3: "LCA",
      isoNo: "662",
      internet: "LC",
    },
    {
      continent: "Americas",
      region: "North America",
      country: "Saint Pierre and Miquelon",
      capital: "Saint-Pierre",
      fips: "SB",
      iso2: "PM",
      iso3: "SPM",
      isoNo: "666",
      internet: "PM",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Saint Vincent and the Grenadines",
      capital: "Kingstown",
      fips: "VC",
      iso2: "VC",
      iso3: "VCT",
      isoNo: "670",
      internet: "VC",
    },
    {
      continent: "Europe",
      region: "Southern Europe",
      country: "San Marino",
      capital: "San Marino",
      fips: "SM",
      iso2: "SM",
      iso3: "SMR",
      isoNo: "674",
      internet: "SM",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Sao Tome and Principe",
      capital: "Sao Tome",
      fips: "TP",
      iso2: "ST",
      iso3: "STP",
      isoNo: "678",
      internet: "ST",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Saudi Arabia",
      capital: "Riyadh",
      fips: "SA",
      iso2: "SA",
      iso3: "SAU",
      isoNo: "682",
      internet: "SA",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Senegal",
      capital: "Dakar",
      fips: "SG",
      iso2: "SN",
      iso3: "SEN",
      isoNo: "686",
      internet: "SN",
    },
    {
      continent: "Africa",
      region: "Indian Ocean",
      country: "Seychelles",
      capital: "Victoria",
      fips: "SE",
      iso2: "SC",
      iso3: "SYC",
      isoNo: "690",
      internet: "SC",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Sierra Leone",
      capital: "Freetown",
      fips: "SL",
      iso2: "SL",
      iso3: "SLE",
      isoNo: "694",
      internet: "SL",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Singapore",
      capital: "Singapore",
      fips: "SN",
      iso2: "SG",
      iso3: "SGP",
      isoNo: "702",
      internet: "SG",
    },
    {
      continent: "Europe",
      region: "Central Europe",
      country: "Slovakia",
      capital: "Bratislava",
      fips: "LO",
      iso2: "SK",
      iso3: "SVK",
      isoNo: "703",
      internet: "SK",
    },
    {
      continent: "Europe",
      region: "South East Europe",
      country: "Slovenia",
      capital: "Ljubljana",
      fips: "SI",
      iso2: "SI",
      iso3: "SVN",
      isoNo: "705",
      internet: "SI",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Solomon Islands",
      capital: "Honiara",
      fips: "BP",
      iso2: "SB",
      iso3: "SLB",
      isoNo: "90",
      internet: "SB",
    },
    {
      continent: "Africa",
      region: "Eastern Africa",
      country: "Somalia",
      capital: "Mogadishu",
      fips: "SO",
      iso2: "SO",
      iso3: "SOM",
      isoNo: "706",
      internet: "SO",
    },
    {
      continent: "Africa",
      region: "Southern Africa",
      country: "South Africa",
      capital: "Pretoria��",
      fips: "SF",
      iso2: "ZA",
      iso3: "ZAF",
      isoNo: "710",
      internet: "ZA",
    },
    {
      continent: "Europe",
      region: "South West Europe",
      country: "Spain",
      capital: "Madrid",
      fips: "SP",
      iso2: "ES",
      iso3: "ESP",
      isoNo: "724",
      internet: "ES",
    },
    {
      continent: "Asia",
      region: "South Asia",
      country: "Sri Lanka",
      capital: "Colombo",
      fips: "CE",
      iso2: "LK",
      iso3: "LKA",
      isoNo: "144",
      internet: "LK",
    },
    {
      continent: "Africa",
      region: "Northern Africa",
      country: "Sudan",
      capital: "Khartoum",
      fips: "SU",
      iso2: "SD",
      iso3: "SDN",
      isoNo: "736",
      internet: "SD",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Suriname",
      capital: "Paramaribo",
      fips: "NS",
      iso2: "SR",
      iso3: "SUR",
      isoNo: "740",
      internet: "SR",
    },
    {
      continent: "Europe",
      region: "Northern Europe",
      country: "Svalbard",
      capital: "Longyearbyen",
      fips: "SV",
      iso2: "SJ",
      iso3: "SJM",
      isoNo: "744",
      internet: "SJ",
    },
    {
      continent: "Africa",
      region: "Southern Africa",
      country: "Eswatini",
      capital: "Mbabane",
      fips: "WZ",
      iso2: "SZ",
      iso3: "SWZ",
      isoNo: "748",
      internet: "SZ",
    },
    {
      continent: "Europe",
      region: "Northern Europe",
      country: "Sweden",
      capital: "Stockholm",
      fips: "SW",
      iso2: "SE",
      iso3: "SWE",
      isoNo: "752",
      internet: "SE",
    },
    {
      continent: "Europe",
      region: "Central Europe",
      country: "Switzerland",
      capital: "Bern",
      fips: "SZ",
      iso2: "CH",
      iso3: "CHE",
      isoNo: "756",
      internet: "CH",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Syria",
      capital: "Damascus",
      fips: "SY",
      iso2: "SY",
      iso3: "SYR",
      isoNo: "760",
      internet: "SY",
    },
    {
      continent: "Asia",
      region: "East Asia",
      country: "Taiwan",
      capital: "Taipei",
      fips: "TW",
      iso2: "TW",
      iso3: "TWN",
      isoNo: "158",
      internet: "TW",
    },
    {
      continent: "Asia",
      region: "Central Asia",
      country: "Tajikistan",
      capital: "Dushanbe",
      fips: "TI",
      iso2: "TJ",
      iso3: "TJK",
      isoNo: "762",
      internet: "TJ",
    },
    {
      continent: "Africa",
      region: "Eastern Africa",
      country: "Tanzania",
      capital: "Dar es Salaam",
      fips: "TZ",
      iso2: "TZ",
      iso3: "TZA",
      isoNo: "834",
      internet: "TZ",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Thailand",
      capital: "Bangkok",
      fips: "TH",
      iso2: "TH",
      iso3: "THA",
      isoNo: "764",
      internet: "TH",
    },
    {
      continent: "Africa",
      region: "Western Africa",
      country: "Togo",
      capital: "Lome",
      fips: "TO",
      iso2: "TG",
      iso3: "TGO",
      isoNo: "768",
      internet: "TG",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Tokelau",
      capital: "none",
      fips: "TL",
      iso2: "TK",
      iso3: "TKL",
      isoNo: "772",
      internet: "TK",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Tonga",
      capital: "Nuku'alofa",
      fips: "TN",
      iso2: "TO",
      iso3: "TON",
      isoNo: "776",
      internet: "TO",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Trinidad and Tobago",
      capital: "Port-of-Spain",
      fips: "TD",
      iso2: "TT",
      iso3: "TTO",
      isoNo: "780",
      internet: "TT",
    },
    {
      continent: "Africa",
      region: "Northern Africa",
      country: "Tunisia",
      capital: "Tunis",
      fips: "TS",
      iso2: "TN",
      iso3: "TUN",
      isoNo: "788",
      internet: "TN",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Turkey",
      capital: "Ankara",
      fips: "TU",
      iso2: "TR",
      iso3: "TUR",
      isoNo: "792",
      internet: "TR",
    },
    {
      continent: "Asia",
      region: "Central Asia",
      country: "Turkmenistan",
      capital: "Ashgabat",
      fips: "TX",
      iso2: "TM",
      iso3: "TKM",
      isoNo: "795",
      internet: "TM",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Turks and Caicos Islands",
      capital: "Grand Turk",
      fips: "TK",
      iso2: "TC",
      iso3: "TCA",
      isoNo: "796",
      internet: "TC",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Tuvalu",
      capital: "Funafuti",
      fips: "TV",
      iso2: "TV",
      iso3: "TUV",
      isoNo: "798",
      internet: "TV",
    },
    {
      continent: "Africa",
      region: "Eastern Africa",
      country: "Uganda",
      capital: "Kampala",
      fips: "UG",
      iso2: "UG",
      iso3: "UGA",
      isoNo: "800",
      internet: "UG",
    },
    {
      continent: "Europe",
      region: "Eastern Europe",
      country: "Ukraine",
      capital: "Kiev",
      fips: "UP",
      iso2: "UA",
      iso3: "UKR",
      isoNo: "804",
      internet: "UA",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "United Arab Emirates",
      capital: "Abu Dhabi",
      fips: "TC",
      iso2: "AE",
      iso3: "ARE",
      isoNo: "784",
      internet: "AE",
    },
    {
      continent: "Europe",
      region: "Western Europe",
      country: "United Kingdom",
      capital: "London",
      fips: "UK",
      iso2: "GB",
      iso3: "GBR",
      isoNo: "826",
      internet: "UK",
    },
    {
      continent: "Americas",
      region: "North America",
      country: "United States",
      capital: "Washington DC",
      fips: "US",
      iso2: "US",
      iso3: "USA",
      isoNo: "840",
      internet: "US",
    },
    {
      continent: "Americas",
      region: "North America",
      country: "United States Minor Outlying Islands",
      capital: "Washington DC",
      fips: "",
      iso2: "UM",
      iso3: "UMI",
      isoNo: "581",
      internet: "US",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Uruguay",
      capital: "Montevideo",
      fips: "UY",
      iso2: "UY",
      iso3: "URY",
      isoNo: "858",
      internet: "UY",
    },
    {
      continent: "Asia",
      region: "Central Asia",
      country: "Uzbekistan",
      capital: "Tashkent (Toshkent)",
      fips: "UZ",
      iso2: "UZ",
      iso3: "UZB",
      isoNo: "860",
      internet: "UZ",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Vanuatu",
      capital: "Port-Vila",
      fips: "NH",
      iso2: "VU",
      iso3: "VUT",
      isoNo: "548",
      internet: "VU",
    },
    {
      continent: "Americas",
      region: "South America",
      country: "Venezuela",
      capital: "Caracas",
      fips: "VE",
      iso2: "VE",
      iso3: "VEN",
      isoNo: "862",
      internet: "UE",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Vietnam",
      capital: "Hanoi",
      fips: "VN",
      iso2: "VN",
      iso3: "VNM",
      isoNo: "704",
      internet: "VN",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Virgin Islands",
      capital: "Charlotte Amalie",
      fips: "VQ",
      iso2: "VI",
      iso3: "VIR",
      isoNo: "850",
      internet: "VI",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Wallis and Futuna",
      capital: "Mata-Utu (on Ile Uvea)",
      fips: "WF",
      iso2: "WF",
      iso3: "WLF",
      isoNo: "876",
      internet: "WF",
    },
    {
      continent: "Africa",
      region: "Northern Africa",
      country: "Western Sahara",
      capital: "none",
      fips: "WI",
      iso2: "EH",
      iso3: "ESH",
      isoNo: "732",
      internet: "EH",
    },
    {
      continent: "Oceania",
      region: "Pacific",
      country: "Western Samoa",
      capital: "Apia",
      fips: "WS",
      iso2: "WS",
      iso3: "WSM",
      isoNo: "882",
      internet: "WS",
    },
    {
      continent: "Asia",
      region: "South West Asia",
      country: "Yemen",
      capital: "Sanaa",
      fips: "YM",
      iso2: "YE",
      iso3: "YEM",
      isoNo: "887",
      internet: "YE",
    },
    {
      continent: "Africa",
      region: "Central Africa",
      country: "Democratic Republic of the Congo",
      capital: "Kinshasa",
      fips: "CG",
      iso2: "CD",
      iso3: "COD",
      isoNo: "180",
      internet: "ZR",
    },
    {
      continent: "Africa",
      region: "Southern Africa",
      country: "Zambia",
      capital: "Lusaka",
      fips: "ZA",
      iso2: "ZM",
      iso3: "ZMB",
      isoNo: "894",
      internet: "ZM",
    },
    {
      continent: "Africa",
      region: "Southern Africa",
      country: "Zimbabwe",
      capital: "Harare",
      fips: "ZI",
      iso2: "ZW",
      iso3: "ZWE",
      isoNo: "716",
      internet: "ZW",
    },
    {
      continent: "Asia",
      region: "East Asia",
      country: "Hong Kong",
      capital: "Victoria",
      fips: "HK",
      iso2: "HK",
      iso3: "HKG",
      isoNo: "344",
      internet: "HK",
    },
    {
      continent: "Asia",
      region: "East Asia",
      country: "Macau",
      capital: "Macau",
      fips: "MC",
      iso2: "MO",
      iso3: "MAC",
      isoNo: "446",
      internet: "MO",
    },
    {
      continent: "Antarctica",
      region: "Antarctica",
      country: "Antarctica",
      capital: "",
      fips: "AY",
      iso2: "AQ",
      iso3: "ATA",
      isoNo: "10",
      internet: "AQ",
    },
    {
      continent: "Atlantic Ocean",
      region: "South Atlantic Ocean",
      country: "Bouvet Island",
      capital: "",
      fips: "BV",
      iso2: "BV",
      iso3: "BVT",
      isoNo: "74",
      internet: "BV",
    },
    {
      continent: "Asia",
      region: "South Asia",
      country: "British Indian Ocean Territory",
      capital: "",
      fips: "IO",
      iso2: "IO",
      iso3: "IOT",
      isoNo: "86",
      internet: "IO",
    },
    {
      continent: "Indian Ocean",
      region: "Southern Indian Ocean",
      country: "French Southern and Antarctic Lands",
      capital: "",
      fips: "FS",
      iso2: "TF",
      iso3: "ATF",
      isoNo: "260",
      internet: "--",
    },
    {
      continent: "Indian Ocean",
      region: "Southern Indian Ocean",
      country: "Heard Island and McDonald Islands",
      capital: "",
      fips: "HM",
      iso2: "HM",
      iso3: "HMD",
      isoNo: "334",
      internet: "HM",
    },
    {
      continent: "Atlantic Ocean",
      region: "South Atlantic Ocean",
      country: "Saint Helena",
      capital: "",
      fips: "SH",
      iso2: "SH",
      iso3: "SHN",
      isoNo: "654",
      internet: "SH",
    },
    {
      continent: "Atlantic Ocean",
      region: "South Atlantic Ocean",
      country: "South Georgia and the South Sandwich Islands",
      capital: "",
      fips: "SX",
      iso2: "GS",
      iso3: "SGS",
      isoNo: "239",
      internet: "GS",
    },
    {
      continent: "Europe",
      region: "Western Europe",
      country: "Guernsey",
      capital: "Saint Peter Port",
      fips: "GK",
      iso2: "GG",
      iso3: "GGY",
      isoNo: "831",
      internet: "GG",
    },
    {
      continent: "Europe",
      region: "South East Europe",
      country: "Serbia",
      capital: "Belgrade",
      fips: "RI",
      iso2: "RS",
      iso3: "SRB",
      isoNo: "688",
      internet: "RS",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Saint Barthélemy",
      capital: "Gustavia",
      fips: "TB",
      iso2: "BL",
      iso3: "BLM",
      isoNo: "652",
      internet: "BL",
    },
    {
      continent: "Europe",
      region: "South East Europe",
      country: "Montenegro",
      capital: "Podgorica",
      fips: "MJ",
      iso2: "ME",
      iso3: "MNE",
      isoNo: "499",
      internet: "ME",
    },
    {
      continent: "Europe",
      region: "Western Europe",
      country: "Jersey",
      capital: "Saint Helier",
      fips: "JE",
      iso2: "JE",
      iso3: "JEY",
      isoNo: "832",
      internet: "JE",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Curaçao",
      capital: "Willemstad",
      fips: "UC",
      iso2: "CW",
      iso3: "CUW",
      isoNo: "531",
      internet: "CW",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Saint Martin",
      capital: "Marigot",
      fips: "RN",
      iso2: "MF",
      iso3: "MAF",
      isoNo: "663",
      internet: "MF",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Sint Maarten",
      capital: "Philipsburg",
      fips: "NN",
      iso2: "SX",
      iso3: "SXM",
      isoNo: "534",
      internet: "SX",
    },
    {
      continent: "Asia",
      region: "South East Asia",
      country: "Timor-Leste",
      capital: "Dili",
      fips: "TT",
      iso2: "TL",
      iso3: "TLS",
      isoNo: "626",
      internet: "TL",
    },
    {
      continent: "Africa",
      region: "Northern Africa",
      country: "South Sudan",
      capital: "Juba",
      fips: "OD",
      iso2: "SS",
      iso3: "SSD",
      isoNo: "728",
      internet: "SS",
    },
    {
      continent: "Europe",
      region: "Northern Europe",
      country: "Åland Islands",
      capital: "Mariehamn",
      fips: "AX",
      iso2: "AX",
      iso3: "ALA",
      isoNo: "248",
      internet: "AX",
    },
    {
      continent: "Americas",
      region: "West Indies",
      country: "Bonaire",
      capital: "Kralendijk",
      fips: "BQ",
      iso2: "BQ",
      iso3: "BES",
      isoNo: "535",
      internet: "BQ",
    },
    {
      continent: "Europe",
      region: "South East Europe",
      country: "Republic of Kosovo",
      capital: "Pristina",
      fips: "KV",
      iso2: "XK",
      iso3: "UNK",
      isoNo: null,
      internet: "XK",
    },
  ];
  var m = {
    getUserLocationData: t(function () {
      var e, t;
      return n(this, function (i) {
        switch (i.label) {
          case 0:
            return [4, this.getUserData()];
          case 1:
            return null == (e = i.sent()) || "" === e
              ? (console.warn(
                  "Geo.getUserLocationData() : userData is unavailable."
                ),
                [2, void 0])
              : ((t = e.loc), [2, u(t)]);
        }
      });
    }),
    getUserData: t(function () {
      var e;
      return n(this, function (t) {
        switch (t.label) {
          case 0:
            return [4, this.getUserDataFromStorage()];
          case 1:
            return (e = t.sent()) && !f(e)
              ? [3, 3]
              : (console.log(
                  "No user data found in storage, fetching from API instead..."
                ),
                [4, this.getUserDataFromAPI()]);
          case 2:
            (e = t.sent()),
              window.localStorage.setItem("userData", JSON.stringify(e)),
              (t.label = 3);
          case 3:
            return [2, e];
        }
      });
    }),
    getUserDataFromStorage: t(function () {
      var e;
      return n(this, function (t) {
        return (
          (e = localStorage.getItem("userData")) && (e = JSON.parse(e)), [2, e]
        );
      });
    }),
    getUserDataFromAPI: t(function () {
      var e, t, i;
      return n(this, function (n) {
        switch (n.label) {
          case 0:
            return [
              4,
              fetch("https://www.cloudflare.com/cdn-cgi/trace").then(function (
                e
              ) {
                return e.text();
              }),
            ];
          case 1:
            return (
              (e = n.sent()),
              (t = e.split("\n")),
              (i = {}),
              t.forEach(function (e) {
                var t = e.split("=");
                i[t[0]] = t[1];
              }),
              [2, i]
            );
        }
      });
    }),
  };
  window.Geo = m;
  var y = m;
  function S(e, t, i) {
    return (
      t in e
        ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = i),
      e
    );
  }
  function w(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = null != arguments[t] ? arguments[t] : {},
        n = Object.keys(i);
      "function" == typeof Object.getOwnPropertySymbols &&
        (n = n.concat(
          Object.getOwnPropertySymbols(i).filter(function (e) {
            return Object.getOwnPropertyDescriptor(i, e).enumerable;
          })
        )),
        n.forEach(function (t) {
          S(e, t, i[t]);
        });
    }
    return e;
  }
  document.dispatchEvent(new Event("geoReady"));

  var E = window.ThemeVars,
    T = {
      config: {
        bottleModel: document.querySelector(".bottle-model"),
        sticky: document.querySelector(".sticky"),
        stickyParent: document.querySelector(".sticky-parent"),
        transitionBackgroundTrigger: document.getElementById(
          "transitionBackgroundTrigger"
        ),
        transitionBackground: document.querySelector(".transition-background"),
        specs: document.querySelector(".desktop-section-group .specs"),
        textBlocks: document.querySelectorAll(
          ".desktop-section-group .specs__text-block:not(:first-child)"
        ),
        imageWithText: document.querySelector(
          ".desktop-section-group .image-with-text"
        ),
      },
      state: {
        ingredientsScrollWidth: 0,
        ingredientsVerticalScrollHeight: 0,
        lastScrollTop: 0,
        currentBottleLeft: 50,
      },
      init: function () {
        if (
          !this.config.sticky ||
          !this.config.stickyParent ||
          !this.config.bottleModel ||
          !this.config.specs ||
          !this.config.transitionBackgroundTrigger ||
          !this.config.transitionBackground
        ) return;
        var e = this;
        (this.state.ingredientsScrollWidth = this.config.sticky.scrollWidth),
          (this.state.ingredientsVerticalScrollHeight =
            this.config.stickyParent.getBoundingClientRect().height -
            this.config.sticky.getBoundingClientRect().height),
          document.addEventListener("scroll", function () {
            window.innerWidth > 900 &&
              (e.ingredientsHorizontalScroll(),
              e.bacgkroundTransition(),
              e.specsTransitions());
          }),
          window.innerWidth > 900 && this.imageSequence();
      },
      ingredientsHorizontalScroll: function () {
        var e = this.config,
          t = e.bottleModel,
          i = e.sticky,
          n = e.stickyParent,
          a = e.specs,
          o = this.state,
          r = o.ingredientsScrollWidth,
          s = o.ingredientsVerticalScrollHeight;
        a.getBoundingClientRect().top >= 500
          ? "50%" != t.style.left && this.moveBottle("right", 0.3)
          : a.getBoundingClientRect().top <= 500 &&
            a.getBoundingClientRect().top >= -100
          ? this.isScrollingDown()
            ? this.moveBottle("left", 0.3)
            : this.moveBottle("right", 0.3)
          : a.getBoundingClientRect().top <= -100 &&
            a.getBoundingClientRect().top >= -1500
          ? this.moveBottle("left", 0.3)
          : a.getBoundingClientRect().top <= -1500 &&
            a.getBoundingClientRect().top >= -2350
          ? this.isScrollingDown()
            ? this.moveBottle("right", 0.3)
            : this.moveBottle("left", 0.3)
          : a.getBoundingClientRect().top <= -2350 &&
            "50%" != t.style.left &&
            this.moveBottle("right", 0.3),
          (function e() {
            if (
              i.getBoundingClientRect().top === t.getBoundingClientRect().top
            ) {
              var a = n.getBoundingClientRect().top;
              i.scrollLeft = (r / s) * -a;
            }
            requestAnimationFrame(e);
          })();
      },
      imageSequence: function () {
        var e = function () {
            var e = window.pageYOffset,
              s = t.getBoundingClientRect().top;
            (a = e > o && s < 400 ? (a % n) + 1 : 1 === a ? n : a - 1),
              (o = e),
              r[a - 1] && (i.src = r[a - 1].src);
          },
          t = document.querySelector(".bottle-model"),
          i = document.querySelector(".bottle-model img"),
          n = 99,
          a = 1,
          o = window.pageYOffset,
          r = [];
        window.addEventListener("scroll", function () {
          requestAnimationFrame(e);
        }),
          window.addEventListener("load", function () {
            for (var e = 1; e <= n; e++) {
              var t = new Image(),
                i = "final" + e.toString().padStart(3, "0") + ".png";
              (t.src =
                "https://cdn.shopify.com/s/files/1/0728/2871/5290/files/" +
                i +
                "?v=1682501078"),
                r.push(t);
            }
          });
      },
      bacgkroundTransition: function () {
        var e = this.config,
          t = e.transitionBackgroundTrigger,
          i = e.transitionBackground;
        t.getBoundingClientRect().top <= 0
          ? ((i.style.opacity = 1), (i.style.zIndex = 1))
          : ((i.style.opacity = 0), (i.style.zIndex = -1));
      },
      specsTransitions: function () {
        var e = this;
        this.config.textBlocks.forEach(function (t) {
          t.getBoundingClientRect().y <=
          e.config.bottleModel.getBoundingClientRect().y
            ? (t.style.opacity = 1)
            : (t.style.opacity = 0);
        });
      },
      isScrollingDown: function () {
        var e = window.pageXOffset || document.documentElement.scrollTop,
          t = e > this.state.lastScrollTop;
        return (this.state.lastScrollTop = e <= 0 ? 0 : e), t;
      },
      moveBottle: function () {
        var e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : "left",
          t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
          i = this.config.bottleModel;
        if ("left" === e) {
          this.state.currentBottleLeft = Math.max(
            40,
            parseFloat(this.state.currentBottleLeft) - t
          );
          var n = "".concat(
            Math.max(40, this.state.currentBottleLeft - t),
            "%"
          );
          i.style.left = n;
        }
        if ("right" === e) {
          this.state.currentBottleLeft = Math.min(
            50,
            parseFloat(this.state.currentBottleLeft) + t
          );
          var a = "".concat(
            Math.min(50, this.state.currentBottleLeft + t),
            "%"
          );
          i.style.left = a;
        }
      },
    };
  "index" === E.template.name && ((window.HomePageScripts = T), T.init());
  var N = {
    init: function () {
      window.innerWidth > 767 && this.imageSequence();
    },
    imageSequence: function () {
      var e = document.querySelector(".bottle-model img"),
        t = 99,
        i = 1,
        n = null,
        a = [];
      window.addEventListener("mousemove", function (o) {
        requestAnimationFrame(function () {
          return (function (o) {
            var r = o.clientX,
              s = null !== n && r > n;
            (n = r),
              a[(i = s ? (i % t) + 1 : (i - 1 + t) % t || t) - 1] &&
                !!e &&
                (e.src = a[i - 1].src);
          })(o);
        });
      }),
        window.addEventListener("load", function () {
          for (var e = 1; e <= t; e++) {
            var i = new Image(),
              n = "final" + e.toString().padStart(3, "0") + ".png";
            (i.src =
              "https://cdn.shopify.com/s/files/1/0728/2871/5290/files/" +
              n +
              "?v=1681383636"),
              a.push(i);
          }
        });
    },
  };
  function M(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function x(e, t) {
    for (var i = 0; i < t.length; i++) {
      var n = t[i];
      (n.enumerable = n.enumerable || !1),
        (n.configurable = !0),
        "value" in n && (n.writable = !0),
        Object.defineProperty(e, n.key, n);
    }
  }
  function P(e, t, i) {
    return t && x(e.prototype, t), i && x(e, i), e;
  }
  "product" === window.ThemeVars.template.name &&
    ((window.ProductPageScripts = N), N.init());
  var I = (function () {
    "use strict";
    function e(t, i) {
      var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 767,
        a = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
      M(this, e),
        S(this, "swiperInstance", null),
        S(this, "swiperElement", null),
        S(this, "swiperWrapperElement", null),
        S(this, "properties", {}),
        (this.swiperElement = document.querySelector(t)),
        (this.swiperWrapperElement = this.swiperElement.firstElementChild),
        (this.properties = i),
        (a ? window.innerWidth <= n : window.innerWidth >= n) &&
          !this.swiperInstance &&
          this.initSwiper(),
        window.addEventListener(
          "resize",
          function () {
            var e = a ? window.innerWidth <= n : window.innerWidth >= n,
              t = a ? window.innerWidth > n : window.innerWidth < n;
            e && !this.swiperInstance
              ? this.initSwiper()
              : t && this.swiperInstance && this.destroySwiper();
          }.bind(this)
        );
    }
    return (
      P(e, [
        {
          key: "initSwiper",
          value: function () {
            this.swiperElement.classList.add("swiper"),
              this.swiperWrapperElement.classList.add("swiper-wrapper"),
              (this.swiperInstance = new window.Swiper(
                this.swiperElement,
                this.properties
              ));
          },
        },
        {
          key: "destroySwiper",
          value: function () {
            this.swiperElement.classList.remove("swiper"),
              this.swiperWrapperElement.classList.remove("swiper-wrapper"),
              this.swiperInstance.destroy(!0, !0),
              (this.swiperInstance = null);
          },
        },
      ]),
      e
    );
  })();
  window.SwiperOnBreakpoint = I;
  var L = (function () {
      "use strict";
      function e(t) {
        var i = t.outerClass,
          n = t.markup;
        M(this, e),
          this._validateArgs({ markup: n, outerClass: i }) &&
            ((this.markup = n), (this.outerClass = i));
      }
      return (
        P(e, [
          {
            key: "_validateArgs",
            value: function (e) {
              var t = !0,
                i = !1,
                n = void 0;
              try {
                for (
                  var a, o = Object.entries(e)[Symbol.iterator]();
                  !(t = (a = o.next()).done);
                  t = !0
                ) {
                  var r = c(a.value, 2),
                    s = r[0];
                  if (!r[1])
                    return (
                      this._showError(
                        "Modal: Could not create modal, requires a ".concat(
                          s,
                          "."
                        )
                      ),
                      !1
                    );
                }
              } catch (e) {
                (i = !0), (n = e);
              } finally {
                try {
                  t || null == o.return || o.return();
                } finally {
                  if (i) throw n;
                }
              }
              return !0;
            },
          },
          {
            key: "_showError",
            value: function (e) {
              console.error(e);
            },
          },
          {
            key: "createModal",
            value: function () {
              var e,
                t,
                i =
                  ((e = this.outerClass),
                  (t = this.markup),
                  '\n  <div class="'
                    .concat(e, '">\n    <div class="')
                    .concat(e, '__inner">\n      ')
                    .concat(t, "\n    </div>\n  </div>\n"));
              document.body.insertAdjacentHTML("beforeend", i),
                document.body.classList.add("no-scroll");
            },
          },
          {
            key: "destroyModal",
            value: function () {
              var e = document.querySelector(".".concat(this.outerClass));
              e && e.remove(), document.body.classList.remove("no-scroll");
            },
          },
        ]),
        e
      );
    })(),
    k = window.ThemeVars,
    O = {
      state: { modal: null, markup: null },
      config: {
        outerClass: "geo-modal",
        countries: [
          { name: "United Kingdom", domain: "renais.co.uk", iso2: "GB" },
          { name: "Europe", domain: "eu.renais.co.uk", continent: "Europe" },
          {
            name: "United States",
            domain: "renais.com",
            continent: "Americas",
          },
          {
            name: "Rest of World",
            domain: window.location.host.replace("www.", ""),
            buttonUrl: k.geoModal.signupUrl,
            region: "Rest of World",
          },
        ],
      },
      init: t(function () {
        var e, t, i, a;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              return (
                (e = this.getDomainFromSessionStorage()),
                (t = window.location.host),
                (i = t.replace("www.", "")),
                [4, this.checkIfUserNeedsRedirect()]
              );
            case 1:
              return (
                (a = n.sent()),
                e !== i &&
                  a &&
                  ((this.state.markup = this.generateMarkup()),
                  this.renderModal()),
                [2]
              );
          }
        });
      }),
      renderModal: function () {
        (this.state.modal = new L({
          markup: this.state.markup,
          outerClass: this.config.outerClass,
        })),
          this.state.modal.createModal(),
          this.setGeoModalButtons();
      },
      setGeoModalButtons: function () {
        var e = this;
        document
          .querySelectorAll(".".concat(this.config.outerClass, "__button"))
          .forEach(function (t) {
            t.addEventListener("click", e.handleButton.bind(e));
          });
      },
      handleButton: function (e) {
        var t = e.currentTarget,
          i = t.dataset.domain,
          n = t.dataset.url;
        this.saveDomainInSessionStorage(i),
          this.saveUserHasVisited(),
          this.checkDomainMatch(i)
            ? n
              ? (location.href = n)
              : this.state.modal.destroyModal()
            : this.redirectToDomain(i);
      },
      generateMarkup: function () {
        var e = this;
        return '\n      <div class="'
          .concat(
            this.config.outerClass,
            '__content">\n        <img\n          class="'
          )
          .concat(this.config.outerClass, '__logo"\n          src="')
          .concat(
            k.geoModal.logo,
            '"\n          alt="Logo"\n        >\n\n        <h2 class="'
          )
          .concat(this.config.outerClass, '__title">')
          .concat(k.geoModal.title, '</h2>\n\n        <div class="')
          .concat(this.config.outerClass, "__actions ")
          .concat(this.config.outerClass, '__actions--vertical">\n          ')
          .concat(
            this.config.countries
              .map(function (t) {
                return '<button class="'
                  .concat(e.config.outerClass, '__button" data-domain="')
                  .concat(t.domain, '" ')
                  .concat(
                    t.buttonUrl ? "data-url=".concat(t.buttonUrl) : "",
                    ">"
                  )
                  .concat(t.name, "</button>");
              })
              .join(""),
            "\n        </div>\n      </div>\n    "
          );
      },
      saveDomainInSessionStorage: function (e) {
        sessionStorage.setItem("domain", e);
      },
      getDomainFromSessionStorage: function () {
        return sessionStorage.getItem("domain");
      },
      saveUserHasVisited: function () {
        localStorage.setItem("userHasVisited", !0);
      },
      getUserHasVisited: function () {
        return localStorage.getItem("userHasVisited");
      },
      redirectToDomain: function (e) {
        var t = window.location.pathname,
          i = "https://".concat(e).concat(t);
        window.location = i;
      },
      checkDomainMatch: function (e) {
        return window.location.host.replace("www.", "") === e;
      },
      checkIfUserNeedsRedirect: t(function () {
        var e, t, i, a;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, y.getUserLocationData()];
            case 1:
              return (
                (e = n.sent()),
                (t = e.iso2),
                (i = e.continent),
                (a = null),
                (a = this.config.countries.find(function (e) {
                  return e.iso2 === t;
                })) ||
                  (a = this.config.countries.find(function (e) {
                    return e.continent === i;
                  })),
                a && !this.checkDomainMatch(a.domain)
                  ? [2, !0]
                  : a && this.getUserHasVisited()
                  ? [2, !1]
                  : [2, !0]
              );
          }
        });
      }),
    },
    B = window.ThemeVars,
    G = {
      modal: null,
      config: {
        outerClass: "age-consent-modal",
        yesButtonId: "ageConsentYes",
        noButtonId: "ageConsentNo",
      },
      init: function () {
        (this.modal = new L({
          markup: this.generateMarkup(),
          outerClass: this.config.outerClass,
        })),
          this.modal.createModal(),
          this.setButtons();
      },
      setButtons: function () {
        var e = document.getElementById(this.config.yesButtonId),
          t = document.getElementById(this.config.noButtonId);
        e.addEventListener("click", this.handleYesClick.bind(this)),
          t.addEventListener("click", this.handleNoClick.bind(this));
      },
      handleYesClick: function () {
        h("ageConsent", !0), this.modal.destroyModal(), O.init();
      },
      handleNoClick: function () {
        document.querySelector(
          ".".concat(this.config.outerClass, "__content")
        ).innerHTML =
          '\n      <img\n        class="age-consent-modal__logo"\n        src="'.concat(
            B.ageConsentModal.logo,
            '"\n        alt="Logo"\n      >\n      <p class="age-consent-modal__message">Unfortunately, due to your age  we cannot let you enter our site at this time</p>\n    '
          );
      },
      generateMarkup: function () {
        return '\n      <div class="'
          .concat(
            this.config.outerClass,
            '__content">\n\n        <img\n          class="'
          )
          .concat(this.config.outerClass, '__logo"\n          src="')
          .concat(
            B.ageConsentModal.logo,
            '"\n          alt="Logo"\n        >\n\n        <h2 class="'
          )
          .concat(this.config.outerClass, '__title">')
          .concat(B.ageConsentModal.title, '</h2>\n\n        <div class="')
          .concat(
            this.config.outerClass,
            '__actions">\n            <button id="ageConsentYes" class="'
          )
          .concat(
            this.config.outerClass,
            '__button">Yes</button>\n            <button id="ageConsentNo" class="'
          )
          .concat(
            this.config.outerClass,
            '__button">No</button>\n        </div>\n      </div>\n    '
          );
      },
    };
  function D(e) {
    if (Array.isArray(e)) return s(e);
  }
  function R() {
    throw new TypeError(
      "Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
    );
  }
  function W(e) {
    return D(e) || o(e) || l(e) || R();
  }
  function F(e) {
    return (
      null !== e &&
      "object" == typeof e &&
      "constructor" in e &&
      e.constructor === Object
    );
  }
  function _() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    Object.keys(t).forEach(function (i) {
      void 0 === e[i]
        ? (e[i] = t[i])
        : F(t[i]) && F(e[i]) && Object.keys(t[i]).length > 0 && _(e[i], t[i]);
    });
  }
  (function () {
    // The rebuilt theme's region/age gate replaces the legacy age and geo modals.
    if (document.getElementById("rn-age")) return;
    var e, t, i;
    null ===
    ((e = "ageConsent"),
    void 0 !==
    (i =
      null ===
        (t = document.cookie.split("; ").find(function (t) {
          return t.startsWith("".concat(e, "="));
        })) || void 0 === t
        ? void 0
        : t.split("=")[1])
      ? "true" === i
      : null)
      ? G.init()
      : O.init();
  })();
  var H = {
    body: {},
    addEventListener: function () {},
    removeEventListener: function () {},
    activeElement: { blur: function () {}, nodeName: "" },
    querySelector: function () {
      return null;
    },
    querySelectorAll: function () {
      return [];
    },
    getElementById: function () {
      return null;
    },
    createEvent: function () {
      return { initEvent: function () {} };
    },
    createElement: function () {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function () {},
        getElementsByTagName: function () {
          return [];
        },
      };
    },
    createElementNS: function () {
      return {};
    },
    importNode: function () {
      return null;
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
  };
  function V() {
    var e = "undefined" != typeof document ? document : {};
    return _(e, H), e;
  }
  var U = {
    document: H,
    navigator: { userAgent: "" },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
    history: {
      replaceState: function () {},
      pushState: function () {},
      go: function () {},
      back: function () {},
    },
    CustomEvent: function () {
      return this;
    },
    addEventListener: function () {},
    removeEventListener: function () {},
    getComputedStyle: function () {
      return {
        getPropertyValue: function () {
          return "";
        },
      };
    },
    Image: function () {},
    Date: function () {},
    screen: {},
    setTimeout: function () {},
    clearTimeout: function () {},
    matchMedia: function () {
      return {};
    },
    requestAnimationFrame: function (e) {
      return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
    },
    cancelAnimationFrame: function (e) {
      "undefined" != typeof setTimeout && clearTimeout(e);
    },
  };
  function z() {
    var e = "undefined" != typeof window ? window : {};
    return _(e, U), e;
  }
  function K(e) {
    if (void 0 === e)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    return e;
  }
  function j(e, t) {
    return (
      (j =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        }),
      j(e, t)
    );
  }
  function q(e, t) {
    return j(e, t);
  }
  function $(e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function");
    (e.prototype = Object.create(t && t.prototype, {
      constructor: { value: e, writable: !0, configurable: !0 },
    })),
      t && q(e, t);
  }
  function Y(e, t) {
    return !t || ("object" !== i(t) && "function" != typeof t) ? K(e) : t;
  }
  function Z(e, t, i) {
    return (
      (Z = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Date.prototype.toString.call(
              Reflect.construct(Date, [], function () {})
            ),
            !0
          );
        } catch (e) {
          return !1;
        }
      })()
        ? Reflect.construct
        : function (e, t, i) {
            var n = [null];
            n.push.apply(n, t);
            var a = new (Function.bind.apply(e, n))();
            return i && q(a, i.prototype), a;
          }),
      Z.apply(null, arguments)
    );
  }
  function J(e, t, i) {
    return Z.apply(null, arguments);
  }
  function X(e) {
    return (
      (X = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }),
      X(e)
    );
  }
  function Q(e) {
    return X(e);
  }
  function ee(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (
      (ee = function (e) {
        if (
          null === e ||
          ((i = e), -1 === Function.toString.call(i).indexOf("[native code]"))
        )
          return e;
        var i;
        if ("function" != typeof e)
          throw new TypeError(
            "Super expression must either be null or a function"
          );
        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, n);
        }
        function n() {
          return J(e, arguments, Q(this).constructor);
        }
        return (
          (n.prototype = Object.create(e.prototype, {
            constructor: {
              value: n,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
          q(n, e)
        );
      }),
      ee(e)
    );
  }
  function te() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return (
        Boolean.prototype.valueOf.call(
          Reflect.construct(Boolean, [], function () {})
        ),
        !0
      );
    } catch (e) {
      return !1;
    }
  }
  function ie(e) {
    var t = te();
    return function () {
      var i,
        n = Q(e);
      if (t) {
        var a = Q(this).constructor;
        i = Reflect.construct(n, arguments, a);
      } else i = n.apply(this, arguments);
      return Y(this, i);
    };
  }
  var ne = (function (e) {
    "use strict";
    $(i, e);
    var t = ie(i);
    function i(e) {
      var n, a, o;
      return (
        M(this, i),
        "number" == typeof e
          ? (n = t.call(this, e))
          : ((n = t.call.apply(t, [this].concat(W(e || [])))),
            (a = K(n)),
            (o = a.__proto__),
            Object.defineProperty(a, "__proto__", {
              get: function () {
                return o;
              },
              set: function (e) {
                o.__proto__ = e;
              },
            })),
        Y(n)
      );
    }
    return i;
  })(ee(Array));
  function ae() {
    var e = [];
    return (
      (arguments.length > 0 && void 0 !== arguments[0]
        ? arguments[0]
        : []
      ).forEach(function (t) {
        var i;
        Array.isArray(t) ? (i = e).push.apply(i, W(ae(t))) : e.push(t);
      }),
      e
    );
  }
  function oe(e, t) {
    return Array.prototype.filter.call(e, t);
  }
  function re(e, t) {
    var i = z(),
      n = V(),
      a = [];
    if (!t && e instanceof ne) return e;
    if (!e) return new ne(a);
    if ("string" == typeof e) {
      var o = e.trim();
      if (o.indexOf("<") >= 0 && o.indexOf(">") >= 0) {
        var r = "div";
        0 === o.indexOf("<li") && (r = "ul"),
          0 === o.indexOf("<tr") && (r = "tbody"),
          (0 !== o.indexOf("<td") && 0 !== o.indexOf("<th")) || (r = "tr"),
          0 === o.indexOf("<tbody") && (r = "table"),
          0 === o.indexOf("<option") && (r = "select");
        var s = n.createElement(r);
        s.innerHTML = o;
        for (var l = 0; l < s.childNodes.length; l += 1)
          a.push(s.childNodes[l]);
      } else
        a = (function (e, t) {
          if ("string" != typeof e) return [e];
          for (
            var i = [], n = t.querySelectorAll(e), a = 0;
            a < n.length;
            a += 1
          )
            i.push(n[a]);
          return i;
        })(e.trim(), t || n);
    } else if (e.nodeType || e === i || e === n) a.push(e);
    else if (Array.isArray(e)) {
      if (e instanceof ne) return e;
      a = e;
    }
    return new ne(
      (function (e) {
        for (var t = [], i = 0; i < e.length; i += 1)
          -1 === t.indexOf(e[i]) && t.push(e[i]);
        return t;
      })(a)
    );
  }
  re.fn = ne.prototype;
  var se = "resize scroll".split(" ");
  function le(e) {
    return function () {
      for (var t = arguments.length, i = new Array(t), n = 0; n < t; n++)
        i[n] = arguments[n];
      if (void 0 === i[0]) {
        for (var a = 0; a < this.length; a += 1)
          se.indexOf(e) < 0 &&
            (e in this[a] ? this[a][e]() : re(this[a]).trigger(e));
        return this;
      }
      return this.on.apply(this, [e].concat(W(i)));
    };
  }
  le("click"),
    le("blur"),
    le("focus"),
    le("focusin"),
    le("focusout"),
    le("keyup"),
    le("keydown"),
    le("keypress"),
    le("submit"),
    le("change"),
    le("mousedown"),
    le("mousemove"),
    le("mouseup"),
    le("mouseenter"),
    le("mouseleave"),
    le("mouseout"),
    le("mouseover"),
    le("touchstart"),
    le("touchend"),
    le("touchmove"),
    le("resize"),
    le("scroll");
  var ce = {
    addClass: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var n = ae(
        t.map(function (e) {
          return e.split(" ");
        })
      );
      return (
        this.forEach(function (e) {
          var t;
          (t = e.classList).add.apply(t, W(n));
        }),
        this
      );
    },
    removeClass: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var n = ae(
        t.map(function (e) {
          return e.split(" ");
        })
      );
      return (
        this.forEach(function (e) {
          var t;
          (t = e.classList).remove.apply(t, W(n));
        }),
        this
      );
    },
    hasClass: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var n = ae(
        t.map(function (e) {
          return e.split(" ");
        })
      );
      return (
        oe(this, function (e) {
          return (
            n.filter(function (t) {
              return e.classList.contains(t);
            }).length > 0
          );
        }).length > 0
      );
    },
    toggleClass: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var n = ae(
        t.map(function (e) {
          return e.split(" ");
        })
      );
      this.forEach(function (e) {
        n.forEach(function (t) {
          e.classList.toggle(t);
        });
      });
    },
    attr: function (e, t) {
      if (1 === arguments.length && "string" == typeof e)
        return this[0] ? this[0].getAttribute(e) : void 0;
      for (var i = 0; i < this.length; i += 1)
        if (2 === arguments.length) this[i].setAttribute(e, t);
        else
          for (var n in e) (this[i][n] = e[n]), this[i].setAttribute(n, e[n]);
      return this;
    },
    removeAttr: function (e) {
      for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
      return this;
    },
    transform: function (e) {
      for (var t = 0; t < this.length; t += 1) this[t].style.transform = e;
      return this;
    },
    transition: function (e) {
      for (var t = 0; t < this.length; t += 1)
        this[t].style.transitionDuration =
          "string" != typeof e ? "".concat(e, "ms") : e;
      return this;
    },
    on: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var n,
        a = function (e) {
          var t = e.target;
          if (t) {
            var i = e.target.dom7EventData || [];
            if ((i.indexOf(e) < 0 && i.unshift(e), re(t).is(l))) u.apply(t, i);
            else
              for (var n = re(t).parents(), a = 0; a < n.length; a += 1)
                re(n[a]).is(l) && u.apply(n[a], i);
          }
        },
        o = function (e) {
          var t = (e && e.target && e.target.dom7EventData) || [];
          t.indexOf(e) < 0 && t.unshift(e), u.apply(this, t);
        },
        r = c(t, 4),
        s = r[0],
        l = r[1],
        u = r[2],
        d = r[3];
      "function" == typeof t[1] &&
        ((s = (n = c(t, 3))[0]), (u = n[1]), (d = n[2]), (l = void 0)),
        d || (d = !1);
      for (var p, f = s.split(" "), h = 0; h < this.length; h += 1) {
        var g = this[h];
        if (l)
          for (p = 0; p < f.length; p += 1) {
            var v = f[p];
            g.dom7LiveListeners || (g.dom7LiveListeners = {}),
              g.dom7LiveListeners[v] || (g.dom7LiveListeners[v] = []),
              g.dom7LiveListeners[v].push({ listener: u, proxyListener: a }),
              g.addEventListener(v, a, d);
          }
        else
          for (p = 0; p < f.length; p += 1) {
            var m = f[p];
            g.dom7Listeners || (g.dom7Listeners = {}),
              g.dom7Listeners[m] || (g.dom7Listeners[m] = []),
              g.dom7Listeners[m].push({ listener: u, proxyListener: o }),
              g.addEventListener(m, o, d);
          }
      }
      return this;
    },
    off: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var n,
        a = c(t, 4),
        o = a[0],
        r = a[1],
        s = a[2],
        l = a[3];
      "function" == typeof t[1] &&
        ((o = (n = c(t, 3))[0]), (s = n[1]), (l = n[2]), (r = void 0)),
        l || (l = !1);
      for (var u = o.split(" "), d = 0; d < u.length; d += 1)
        for (var p = u[d], f = 0; f < this.length; f += 1) {
          var h = this[f],
            g = void 0;
          if (
            (!r && h.dom7Listeners
              ? (g = h.dom7Listeners[p])
              : r && h.dom7LiveListeners && (g = h.dom7LiveListeners[p]),
            g && g.length)
          )
            for (var v = g.length - 1; v >= 0; v -= 1) {
              var m = g[v];
              (s && m.listener === s) ||
              (s &&
                m.listener &&
                m.listener.dom7proxy &&
                m.listener.dom7proxy === s)
                ? (h.removeEventListener(p, m.proxyListener, l), g.splice(v, 1))
                : s ||
                  (h.removeEventListener(p, m.proxyListener, l),
                  g.splice(v, 1));
            }
        }
      return this;
    },
    trigger: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      for (
        var n = z(), a = t[0].split(" "), o = t[1], r = 0;
        r < a.length;
        r += 1
      )
        for (var s = a[r], l = 0; l < this.length; l += 1) {
          var c = this[l];
          if (n.CustomEvent) {
            var u = new n.CustomEvent(s, {
              detail: o,
              bubbles: !0,
              cancelable: !0,
            });
            (c.dom7EventData = t.filter(function (e, t) {
              return t > 0;
            })),
              c.dispatchEvent(u),
              (c.dom7EventData = []),
              delete c.dom7EventData;
          }
        }
      return this;
    },
    transitionEnd: function (e) {
      var t = this;
      return (
        e &&
          t.on("transitionend", function i(n) {
            n.target === this && (e.call(this, n), t.off("transitionend", i));
          }),
        this
      );
    },
    outerWidth: function (e) {
      if (this.length > 0) {
        if (e) {
          var t = this.styles();
          return (
            this[0].offsetWidth +
            parseFloat(t.getPropertyValue("margin-right")) +
            parseFloat(t.getPropertyValue("margin-left"))
          );
        }
        return this[0].offsetWidth;
      }
      return null;
    },
    outerHeight: function (e) {
      if (this.length > 0) {
        if (e) {
          var t = this.styles();
          return (
            this[0].offsetHeight +
            parseFloat(t.getPropertyValue("margin-top")) +
            parseFloat(t.getPropertyValue("margin-bottom"))
          );
        }
        return this[0].offsetHeight;
      }
      return null;
    },
    styles: function () {
      var e = z();
      return this[0] ? e.getComputedStyle(this[0], null) : {};
    },
    offset: function () {
      if (this.length > 0) {
        var e = z(),
          t = V(),
          i = this[0],
          n = i.getBoundingClientRect(),
          a = t.body,
          o = i.clientTop || a.clientTop || 0,
          r = i.clientLeft || a.clientLeft || 0,
          s = i === e ? e.scrollY : i.scrollTop,
          l = i === e ? e.scrollX : i.scrollLeft;
        return { top: n.top + s - o, left: n.left + l - r };
      }
      return null;
    },
    css: function (e, t) {
      var i,
        n = z();
      if (1 === arguments.length) {
        if ("string" != typeof e) {
          for (i = 0; i < this.length; i += 1)
            for (var a in e) this[i].style[a] = e[a];
          return this;
        }
        if (this[0])
          return n.getComputedStyle(this[0], null).getPropertyValue(e);
      }
      if (2 === arguments.length && "string" == typeof e) {
        for (i = 0; i < this.length; i += 1) this[i].style[e] = t;
        return this;
      }
      return this;
    },
    each: function (e) {
      return e
        ? (this.forEach(function (t, i) {
            e.apply(t, [t, i]);
          }),
          this)
        : this;
    },
    html: function (e) {
      if (void 0 === e) return this[0] ? this[0].innerHTML : null;
      for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
      return this;
    },
    text: function (e) {
      if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
      for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
      return this;
    },
    is: function (e) {
      var t,
        i,
        n = z(),
        a = V(),
        o = this[0];
      if (!o || void 0 === e) return !1;
      if ("string" == typeof e) {
        if (o.matches) return o.matches(e);
        if (o.webkitMatchesSelector) return o.webkitMatchesSelector(e);
        if (o.msMatchesSelector) return o.msMatchesSelector(e);
        for (t = re(e), i = 0; i < t.length; i += 1) if (t[i] === o) return !0;
        return !1;
      }
      if (e === a) return o === a;
      if (e === n) return o === n;
      if (e.nodeType || e instanceof ne) {
        for (t = e.nodeType ? [e] : e, i = 0; i < t.length; i += 1)
          if (t[i] === o) return !0;
        return !1;
      }
      return !1;
    },
    index: function () {
      var e,
        t = this[0];
      if (t) {
        for (e = 0; null !== (t = t.previousSibling); )
          1 === t.nodeType && (e += 1);
        return e;
      }
    },
    eq: function (e) {
      if (void 0 === e) return this;
      var t = this.length;
      if (e > t - 1) return re([]);
      if (e < 0) {
        var i = t + e;
        return re(i < 0 ? [] : [this[i]]);
      }
      return re([this[e]]);
    },
    append: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      for (var n, a = V(), o = 0; o < t.length; o += 1) {
        n = t[o];
        for (var r = 0; r < this.length; r += 1)
          if ("string" == typeof n) {
            var s = a.createElement("div");
            for (s.innerHTML = n; s.firstChild; )
              this[r].appendChild(s.firstChild);
          } else if (n instanceof ne)
            for (var l = 0; l < n.length; l += 1) this[r].appendChild(n[l]);
          else this[r].appendChild(n);
      }
      return this;
    },
    prepend: function (e) {
      var t,
        i,
        n = V();
      for (t = 0; t < this.length; t += 1)
        if ("string" == typeof e) {
          var a = n.createElement("div");
          for (a.innerHTML = e, i = a.childNodes.length - 1; i >= 0; i -= 1)
            this[t].insertBefore(a.childNodes[i], this[t].childNodes[0]);
        } else if (e instanceof ne)
          for (i = 0; i < e.length; i += 1)
            this[t].insertBefore(e[i], this[t].childNodes[0]);
        else this[t].insertBefore(e, this[t].childNodes[0]);
      return this;
    },
    next: function (e) {
      return this.length > 0
        ? e
          ? this[0].nextElementSibling && re(this[0].nextElementSibling).is(e)
            ? re([this[0].nextElementSibling])
            : re([])
          : this[0].nextElementSibling
          ? re([this[0].nextElementSibling])
          : re([])
        : re([]);
    },
    nextAll: function (e) {
      var t = [],
        i = this[0];
      if (!i) return re([]);
      for (; i.nextElementSibling; ) {
        var n = i.nextElementSibling;
        e ? re(n).is(e) && t.push(n) : t.push(n), (i = n);
      }
      return re(t);
    },
    prev: function (e) {
      if (this.length > 0) {
        var t = this[0];
        return e
          ? t.previousElementSibling && re(t.previousElementSibling).is(e)
            ? re([t.previousElementSibling])
            : re([])
          : t.previousElementSibling
          ? re([t.previousElementSibling])
          : re([]);
      }
      return re([]);
    },
    prevAll: function (e) {
      var t = [],
        i = this[0];
      if (!i) return re([]);
      for (; i.previousElementSibling; ) {
        var n = i.previousElementSibling;
        e ? re(n).is(e) && t.push(n) : t.push(n), (i = n);
      }
      return re(t);
    },
    parent: function (e) {
      for (var t = [], i = 0; i < this.length; i += 1)
        null !== this[i].parentNode &&
          (e
            ? re(this[i].parentNode).is(e) && t.push(this[i].parentNode)
            : t.push(this[i].parentNode));
      return re(t);
    },
    parents: function (e) {
      for (var t = [], i = 0; i < this.length; i += 1)
        for (var n = this[i].parentNode; n; )
          e ? re(n).is(e) && t.push(n) : t.push(n), (n = n.parentNode);
      return re(t);
    },
    closest: function (e) {
      var t = this;
      return void 0 === e ? re([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
    },
    find: function (e) {
      for (var t = [], i = 0; i < this.length; i += 1)
        for (var n = this[i].querySelectorAll(e), a = 0; a < n.length; a += 1)
          t.push(n[a]);
      return re(t);
    },
    children: function (e) {
      for (var t = [], i = 0; i < this.length; i += 1)
        for (var n = this[i].children, a = 0; a < n.length; a += 1)
          (e && !re(n[a]).is(e)) || t.push(n[a]);
      return re(t);
    },
    filter: function (e) {
      return re(oe(this, e));
    },
    remove: function () {
      for (var e = 0; e < this.length; e += 1)
        this[e].parentNode && this[e].parentNode.removeChild(this[e]);
      return this;
    },
  };
  Object.keys(ce).forEach(function (e) {
    Object.defineProperty(re.fn, e, { value: ce[e], writable: !0 });
  });
  var ue,
    de,
    pe,
    fe = re;
  function he(e) {
    return setTimeout(
      e,
      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0
    );
  }
  function ge() {
    return Date.now();
  }
  function ve(e) {
    var t,
      i,
      n,
      a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x",
      o = z(),
      r = (function (e) {
        var t,
          i = z();
        return (
          i.getComputedStyle && (t = i.getComputedStyle(e, null)),
          !t && e.currentStyle && (t = e.currentStyle),
          t || (t = e.style),
          t
        );
      })(e);
    return (
      o.WebKitCSSMatrix
        ? ((i = r.transform || r.webkitTransform).split(",").length > 6 &&
            (i = i
              .split(", ")
              .map(function (e) {
                return e.replace(",", ".");
              })
              .join(", ")),
          (n = new o.WebKitCSSMatrix("none" === i ? "" : i)))
        : (t = (n =
            r.MozTransform ||
            r.OTransform ||
            r.MsTransform ||
            r.msTransform ||
            r.transform ||
            r
              .getPropertyValue("transform")
              .replace("translate(", "matrix(1, 0, 0, 1,"))
            .toString()
            .split(",")),
      "x" === a &&
        (i = o.WebKitCSSMatrix
          ? n.m41
          : 16 === t.length
          ? parseFloat(t[12])
          : parseFloat(t[4])),
      "y" === a &&
        (i = o.WebKitCSSMatrix
          ? n.m42
          : 16 === t.length
          ? parseFloat(t[13])
          : parseFloat(t[5])),
      i || 0
    );
  }
  function me(e) {
    return (
      "object" == typeof e &&
      null !== e &&
      e.constructor &&
      "Object" === Object.prototype.toString.call(e).slice(8, -1)
    );
  }
  function ye() {
    for (
      var e = function (e) {
          var t,
            n = i[e];
          if (
            null != n &&
            ((t = n),
            !("undefined" != typeof window && void 0 !== window.HTMLElement
              ? t instanceof HTMLElement
              : t && (1 === t.nodeType || 11 === t.nodeType)))
          )
            for (
              var r = Object.keys(Object(n)).filter(function (e) {
                  return o.indexOf(e) < 0;
                }),
                s = 0,
                l = r.length;
              s < l;
              s += 1
            ) {
              var c = r[s],
                u = Object.getOwnPropertyDescriptor(n, c);
              void 0 !== u &&
                u.enumerable &&
                (me(a[c]) && me(n[c])
                  ? n[c].__swiper__
                    ? (a[c] = n[c])
                    : ye(a[c], n[c])
                  : !me(a[c]) && me(n[c])
                  ? ((a[c] = {}),
                    n[c].__swiper__ ? (a[c] = n[c]) : ye(a[c], n[c]))
                  : (a[c] = n[c]));
            }
        },
        t = arguments.length,
        i = new Array(t),
        n = 0;
      n < t;
      n++
    )
      i[n] = arguments[n];
    for (
      var a = Object(i[0]),
        o = ["__proto__", "constructor", "prototype"],
        r = 1;
      r < i.length;
      r += 1
    )
      e(r);
    return a;
  }
  function Se(e, t, i) {
    e.style.setProperty(t, i);
  }
  function we(e) {
    var t,
      i = e.swiper,
      n = e.targetPosition,
      a = e.side,
      o = z(),
      r = -i.translate,
      s = null,
      l = i.params.speed;
    (i.wrapperEl.style.scrollSnapType = "none"),
      o.cancelAnimationFrame(i.cssModeFrameID);
    var c = n > r ? "next" : "prev",
      u = function (e, t) {
        return ("next" === c && e >= t) || ("prev" === c && e <= t);
      },
      d = function () {
        (t = new Date().getTime()), null === s && (s = t);
        var e = Math.max(Math.min((t - s) / l, 1), 0),
          c = 0.5 - Math.cos(e * Math.PI) / 2,
          p = r + c * (n - r);
        if ((u(p, n) && (p = n), i.wrapperEl.scrollTo(S({}, a, p)), u(p, n)))
          return (
            (i.wrapperEl.style.overflow = "hidden"),
            (i.wrapperEl.style.scrollSnapType = ""),
            setTimeout(function () {
              (i.wrapperEl.style.overflow = ""),
                i.wrapperEl.scrollTo(S({}, a, p));
            }),
            void o.cancelAnimationFrame(i.cssModeFrameID)
          );
        i.cssModeFrameID = o.requestAnimationFrame(d);
      };
    d();
  }
  function Ce() {
    return (
      ue ||
        (ue = (function () {
          var e = z(),
            t = V();
          return {
            smoothScroll:
              t.documentElement && "scrollBehavior" in t.documentElement.style,
            touch: !!(
              "ontouchstart" in e ||
              (e.DocumentTouch && t instanceof e.DocumentTouch)
            ),
            passiveListener: (function () {
              var t = !1;
              try {
                var i = Object.defineProperty({}, "passive", {
                  get: function () {
                    t = !0;
                  },
                });
                e.addEventListener("testPassiveListener", null, i);
              } catch (e) {}
              return t;
            })(),
            gestures: "ongesturestart" in e,
          };
        })()),
      ue
    );
  }
  function be() {
    return (
      de ||
        (de = (function () {
          var e = (
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : {}
            ).userAgent,
            t = Ce(),
            i = z(),
            n = i.navigator.platform,
            a = e || i.navigator.userAgent,
            o = { ios: !1, android: !1 },
            r = i.screen.width,
            s = i.screen.height,
            l = a.match(/(Android);?[\s\/]+([\d.]+)?/),
            c = a.match(/(iPad).*OS\s([\d_]+)/),
            u = a.match(/(iPod)(.*OS\s([\d_]+))?/),
            d = !c && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
            p = "Win32" === n,
            f = "MacIntel" === n;
          return (
            !c &&
              f &&
              t.touch &&
              [
                "1024x1366",
                "1366x1024",
                "834x1194",
                "1194x834",
                "834x1112",
                "1112x834",
                "768x1024",
                "1024x768",
                "820x1180",
                "1180x820",
                "810x1080",
                "1080x810",
              ].indexOf("".concat(r, "x").concat(s)) >= 0 &&
              ((c = a.match(/(Version)\/([\d.]+)/)) || (c = [0, 1, "13_0_0"]),
              (f = !1)),
            l && !p && ((o.os = "android"), (o.android = !0)),
            (c || d || u) && ((o.os = "ios"), (o.ios = !0)),
            o
          );
        })(
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
        )),
      de
    );
  }
  function Ae() {
    return (
      pe ||
        (pe = (function () {
          var e,
            t = z();
          return {
            isSafari:
              ((e = t.navigator.userAgent.toLowerCase()),
              e.indexOf("safari") >= 0 &&
                e.indexOf("chrome") < 0 &&
                e.indexOf("android") < 0),
            isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
              t.navigator.userAgent
            ),
          };
        })()),
      pe
    );
  }
  var Ee = {
    on: function (e, t, i) {
      var n = this;
      if (!n.eventsListeners || n.destroyed) return n;
      if ("function" != typeof t) return n;
      var a = i ? "unshift" : "push";
      return (
        e.split(" ").forEach(function (e) {
          n.eventsListeners[e] || (n.eventsListeners[e] = []),
            n.eventsListeners[e][a](t);
        }),
        n
      );
    },
    once: function (e, t, i) {
      var n = this;
      if (!n.eventsListeners || n.destroyed) return n;
      if ("function" != typeof t) return n;
      function a() {
        for (var i = arguments.length, o = new Array(i), r = 0; r < i; r++)
          o[r] = arguments[r];
        n.off(e, a), a.__emitterProxy && delete a.__emitterProxy, t.apply(n, o);
      }
      return (a.__emitterProxy = t), n.on(e, a, i);
    },
    onAny: function (e, t) {
      var i = this;
      if (!i.eventsListeners || i.destroyed) return i;
      if ("function" != typeof e) return i;
      var n = t ? "unshift" : "push";
      return (
        i.eventsAnyListeners.indexOf(e) < 0 && i.eventsAnyListeners[n](e), i
      );
    },
    offAny: function (e) {
      var t = this;
      if (!t.eventsListeners || t.destroyed) return t;
      if (!t.eventsAnyListeners) return t;
      var i = t.eventsAnyListeners.indexOf(e);
      return i >= 0 && t.eventsAnyListeners.splice(i, 1), t;
    },
    off: function (e, t) {
      var i = this;
      return !i.eventsListeners || i.destroyed
        ? i
        : i.eventsListeners
        ? (e.split(" ").forEach(function (e) {
            void 0 === t
              ? (i.eventsListeners[e] = [])
              : i.eventsListeners[e] &&
                i.eventsListeners[e].forEach(function (n, a) {
                  (n === t || (n.__emitterProxy && n.__emitterProxy === t)) &&
                    i.eventsListeners[e].splice(a, 1);
                });
          }),
          i)
        : i;
    },
    emit: function () {
      for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
        t[i] = arguments[i];
      var n,
        a,
        o,
        r = this;
      return !r.eventsListeners || r.destroyed
        ? r
        : r.eventsListeners
        ? ("string" == typeof t[0] || Array.isArray(t[0])
            ? ((n = t[0]), (a = t.slice(1, t.length)), (o = r))
            : ((n = t[0].events), (a = t[0].data), (o = t[0].context || r)),
          a.unshift(o),
          (Array.isArray(n) ? n : n.split(" ")).forEach(function (e) {
            r.eventsAnyListeners &&
              r.eventsAnyListeners.length &&
              r.eventsAnyListeners.forEach(function (t) {
                t.apply(o, [e].concat(W(a)));
              }),
              r.eventsListeners &&
                r.eventsListeners[e] &&
                r.eventsListeners[e].forEach(function (e) {
                  e.apply(o, a);
                });
          }),
          r)
        : r;
    },
  };
  var Te = {
    updateSize: function () {
      var e,
        t,
        i = this,
        n = i.$el;
      (e =
        void 0 !== i.params.width && null !== i.params.width
          ? i.params.width
          : n[0].clientWidth),
        (t =
          void 0 !== i.params.height && null !== i.params.height
            ? i.params.height
            : n[0].clientHeight),
        (0 === e && i.isHorizontal()) ||
          (0 === t && i.isVertical()) ||
          ((e =
            e -
            parseInt(n.css("padding-left") || 0, 10) -
            parseInt(n.css("padding-right") || 0, 10)),
          (t =
            t -
            parseInt(n.css("padding-top") || 0, 10) -
            parseInt(n.css("padding-bottom") || 0, 10)),
          Number.isNaN(e) && (e = 0),
          Number.isNaN(t) && (t = 0),
          Object.assign(i, {
            width: e,
            height: t,
            size: i.isHorizontal() ? e : t,
          }));
    },
    updateSlides: function () {
      var e = function (e) {
          return i.isHorizontal()
            ? e
            : {
                width: "height",
                "margin-top": "margin-left",
                "margin-bottom ": "margin-right",
                "margin-left": "margin-top",
                "margin-right": "margin-bottom",
                "padding-left": "padding-top",
                "padding-right": "padding-bottom",
                marginRight: "marginBottom",
              }[e];
        },
        t = function (t, i) {
          return parseFloat(t.getPropertyValue(e(i)) || 0);
        },
        i = this,
        n = i.params,
        a = i.$wrapperEl,
        o = i.size,
        r = i.rtlTranslate,
        s = i.wrongRTL,
        l = i.virtual && n.virtual.enabled,
        c = l ? i.virtual.slides.length : i.slides.length,
        u = a.children(".".concat(i.params.slideClass)),
        d = l ? i.virtual.slides.length : u.length,
        p = [],
        f = [],
        h = [],
        g = n.slidesOffsetBefore;
      "function" == typeof g && (g = n.slidesOffsetBefore.call(i));
      var v = n.slidesOffsetAfter;
      "function" == typeof v && (v = n.slidesOffsetAfter.call(i));
      var m = i.snapGrid.length,
        y = i.slidesGrid.length,
        w = n.spaceBetween,
        C = -g,
        b = 0,
        A = 0;
      if (void 0 !== o) {
        "string" == typeof w &&
          w.indexOf("%") >= 0 &&
          (w = (parseFloat(w.replace("%", "")) / 100) * o),
          (i.virtualSize = -w),
          r
            ? u.css({ marginLeft: "", marginBottom: "", marginTop: "" })
            : u.css({ marginRight: "", marginBottom: "", marginTop: "" }),
          n.centeredSlides &&
            n.cssMode &&
            (Se(i.wrapperEl, "--swiper-centered-offset-before", ""),
            Se(i.wrapperEl, "--swiper-centered-offset-after", ""));
        var E,
          T = n.grid && n.grid.rows > 1 && i.grid;
        T && i.grid.initSlides(d);
        for (
          var N =
              "auto" === n.slidesPerView &&
              n.breakpoints &&
              Object.keys(n.breakpoints).filter(function (e) {
                return void 0 !== n.breakpoints[e].slidesPerView;
              }).length > 0,
            M = 0;
          M < d;
          M += 1
        ) {
          E = 0;
          var x = u.eq(M);
          if (
            (T && i.grid.updateSlide(M, x, d, e), "none" !== x.css("display"))
          ) {
            if ("auto" === n.slidesPerView) {
              N && (u[M].style[e("width")] = "");
              var P = getComputedStyle(x[0]),
                I = x[0].style.transform,
                L = x[0].style.webkitTransform;
              if (
                (I && (x[0].style.transform = "none"),
                L && (x[0].style.webkitTransform = "none"),
                n.roundLengths)
              )
                E = i.isHorizontal() ? x.outerWidth(!0) : x.outerHeight(!0);
              else {
                var k = t(P, "width"),
                  O = t(P, "padding-left"),
                  B = t(P, "padding-right"),
                  G = t(P, "margin-left"),
                  D = t(P, "margin-right"),
                  R = P.getPropertyValue("box-sizing");
                if (R && "border-box" === R) E = k + G + D;
                else {
                  var W = x[0],
                    F = W.clientWidth;
                  E = k + O + B + G + D + (W.offsetWidth - F);
                }
              }
              I && (x[0].style.transform = I),
                L && (x[0].style.webkitTransform = L),
                n.roundLengths && (E = Math.floor(E));
            } else
              (E = (o - (n.slidesPerView - 1) * w) / n.slidesPerView),
                n.roundLengths && (E = Math.floor(E)),
                u[M] && (u[M].style[e("width")] = "".concat(E, "px"));
            u[M] && (u[M].swiperSlideSize = E),
              h.push(E),
              n.centeredSlides
                ? ((C = C + E / 2 + b / 2 + w),
                  0 === b && 0 !== M && (C = C - o / 2 - w),
                  0 === M && (C = C - o / 2 - w),
                  Math.abs(C) < 0.001 && (C = 0),
                  n.roundLengths && (C = Math.floor(C)),
                  A % n.slidesPerGroup == 0 && p.push(C),
                  f.push(C))
                : (n.roundLengths && (C = Math.floor(C)),
                  (A - Math.min(i.params.slidesPerGroupSkip, A)) %
                    i.params.slidesPerGroup ==
                    0 && p.push(C),
                  f.push(C),
                  (C = C + E + w)),
              (i.virtualSize += E + w),
              (b = E),
              (A += 1);
          }
        }
        if (
          ((i.virtualSize = Math.max(i.virtualSize, o) + v),
          r &&
            s &&
            ("slide" === n.effect || "coverflow" === n.effect) &&
            a.css({ width: "".concat(i.virtualSize + n.spaceBetween, "px") }),
          n.setWrapperSize &&
            a.css(
              S({}, e("width"), "".concat(i.virtualSize + n.spaceBetween, "px"))
            ),
          T && i.grid.updateWrapperSize(E, p, e),
          !n.centeredSlides)
        ) {
          for (var _ = [], H = 0; H < p.length; H += 1) {
            var V = p[H];
            n.roundLengths && (V = Math.floor(V)),
              p[H] <= i.virtualSize - o && _.push(V);
          }
          (p = _),
            Math.floor(i.virtualSize - o) - Math.floor(p[p.length - 1]) > 1 &&
              p.push(i.virtualSize - o);
        }
        if ((0 === p.length && (p = [0]), 0 !== n.spaceBetween)) {
          var U = i.isHorizontal() && r ? "marginLeft" : e("marginRight");
          u.filter(function (e, t) {
            return !n.cssMode || t !== u.length - 1;
          }).css(S({}, U, "".concat(w, "px")));
        }
        if (n.centeredSlides && n.centeredSlidesBounds) {
          var z = 0;
          h.forEach(function (e) {
            z += e + (n.spaceBetween ? n.spaceBetween : 0);
          });
          var K = (z -= n.spaceBetween) - o;
          p = p.map(function (e) {
            return e < 0 ? -g : e > K ? K + v : e;
          });
        }
        if (n.centerInsufficientSlides) {
          var j = 0;
          if (
            (h.forEach(function (e) {
              j += e + (n.spaceBetween ? n.spaceBetween : 0);
            }),
            (j -= n.spaceBetween) < o)
          ) {
            var q = (o - j) / 2;
            p.forEach(function (e, t) {
              p[t] = e - q;
            }),
              f.forEach(function (e, t) {
                f[t] = e + q;
              });
          }
        }
        if (
          (Object.assign(i, {
            slides: u,
            snapGrid: p,
            slidesGrid: f,
            slidesSizesGrid: h,
          }),
          n.centeredSlides && n.cssMode && !n.centeredSlidesBounds)
        ) {
          Se(
            i.wrapperEl,
            "--swiper-centered-offset-before",
            "".concat(-p[0], "px")
          ),
            Se(
              i.wrapperEl,
              "--swiper-centered-offset-after",
              "".concat(i.size / 2 - h[h.length - 1] / 2, "px")
            );
          var $ = -i.snapGrid[0],
            Y = -i.slidesGrid[0];
          (i.snapGrid = i.snapGrid.map(function (e) {
            return e + $;
          })),
            (i.slidesGrid = i.slidesGrid.map(function (e) {
              return e + Y;
            }));
        }
        if (
          (d !== c && i.emit("slidesLengthChange"),
          p.length !== m &&
            (i.params.watchOverflow && i.checkOverflow(),
            i.emit("snapGridLengthChange")),
          f.length !== y && i.emit("slidesGridLengthChange"),
          n.watchSlidesProgress && i.updateSlidesOffset(),
          !(l || n.cssMode || ("slide" !== n.effect && "fade" !== n.effect)))
        ) {
          var Z = "".concat(n.containerModifierClass, "backface-hidden"),
            J = i.$el.hasClass(Z);
          d <= n.maxBackfaceHiddenSlides
            ? J || i.$el.addClass(Z)
            : J && i.$el.removeClass(Z);
        }
      }
    },
    updateAutoHeight: function (e) {
      var t,
        i = this,
        n = [],
        a = i.virtual && i.params.virtual.enabled,
        o = 0;
      "number" == typeof e
        ? i.setTransition(e)
        : !0 === e && i.setTransition(i.params.speed);
      var r = function (e) {
        return a
          ? i.slides.filter(function (t) {
              return (
                parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e
              );
            })[0]
          : i.slides.eq(e)[0];
      };
      if ("auto" !== i.params.slidesPerView && i.params.slidesPerView > 1)
        if (i.params.centeredSlides)
          (i.visibleSlides || fe([])).each(function (e) {
            n.push(e);
          });
        else
          for (t = 0; t < Math.ceil(i.params.slidesPerView); t += 1) {
            var s = i.activeIndex + t;
            if (s > i.slides.length && !a) break;
            n.push(r(s));
          }
      else n.push(r(i.activeIndex));
      for (t = 0; t < n.length; t += 1)
        if (void 0 !== n[t]) {
          var l = n[t].offsetHeight;
          o = l > o ? l : o;
        }
      (o || 0 === o) && i.$wrapperEl.css("height", "".concat(o, "px"));
    },
    updateSlidesOffset: function () {
      for (var e = this.slides, t = 0; t < e.length; t += 1)
        e[t].swiperSlideOffset = this.isHorizontal()
          ? e[t].offsetLeft
          : e[t].offsetTop;
    },
    updateSlidesProgress: function () {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : (this && this.translate) || 0,
        t = this,
        i = t.params,
        n = t.slides,
        a = t.rtlTranslate,
        o = t.snapGrid;
      if (0 !== n.length) {
        void 0 === n[0].swiperSlideOffset && t.updateSlidesOffset();
        var r = -e;
        a && (r = e),
          n.removeClass(i.slideVisibleClass),
          (t.visibleSlidesIndexes = []),
          (t.visibleSlides = []);
        for (var s = 0; s < n.length; s += 1) {
          var l = n[s],
            c = l.swiperSlideOffset;
          i.cssMode && i.centeredSlides && (c -= n[0].swiperSlideOffset);
          var u =
              (r + (i.centeredSlides ? t.minTranslate() : 0) - c) /
              (l.swiperSlideSize + i.spaceBetween),
            d =
              (r - o[0] + (i.centeredSlides ? t.minTranslate() : 0) - c) /
              (l.swiperSlideSize + i.spaceBetween),
            p = -(r - c),
            f = p + t.slidesSizesGrid[s];
          ((p >= 0 && p < t.size - 1) ||
            (f > 1 && f <= t.size) ||
            (p <= 0 && f >= t.size)) &&
            (t.visibleSlides.push(l),
            t.visibleSlidesIndexes.push(s),
            n.eq(s).addClass(i.slideVisibleClass)),
            (l.progress = a ? -u : u),
            (l.originalProgress = a ? -d : d);
        }
        t.visibleSlides = fe(t.visibleSlides);
      }
    },
    updateProgress: function (e) {
      var t = this;
      if (void 0 === e) {
        var i = t.rtlTranslate ? -1 : 1;
        e = (t && t.translate && t.translate * i) || 0;
      }
      var n = t.params,
        a = t.maxTranslate() - t.minTranslate(),
        o = t.progress,
        r = t.isBeginning,
        s = t.isEnd,
        l = r,
        c = s;
      0 === a
        ? ((o = 0), (r = !0), (s = !0))
        : ((r = (o = (e - t.minTranslate()) / a) <= 0), (s = o >= 1)),
        Object.assign(t, { progress: o, isBeginning: r, isEnd: s }),
        (n.watchSlidesProgress || (n.centeredSlides && n.autoHeight)) &&
          t.updateSlidesProgress(e),
        r && !l && t.emit("reachBeginning toEdge"),
        s && !c && t.emit("reachEnd toEdge"),
        ((l && !r) || (c && !s)) && t.emit("fromEdge"),
        t.emit("progress", o);
    },
    updateSlidesClasses: function () {
      var e,
        t = this,
        i = t.slides,
        n = t.params,
        a = t.$wrapperEl,
        o = t.activeIndex,
        r = t.realIndex,
        s = t.virtual && n.virtual.enabled;
      i.removeClass(
        ""
          .concat(n.slideActiveClass, " ")
          .concat(n.slideNextClass, " ")
          .concat(n.slidePrevClass, " ")
          .concat(n.slideDuplicateActiveClass, " ")
          .concat(n.slideDuplicateNextClass, " ")
          .concat(n.slideDuplicatePrevClass)
      ),
        (e = s
          ? t.$wrapperEl.find(
              "."
                .concat(n.slideClass, '[data-swiper-slide-index="')
                .concat(o, '"]')
            )
          : i.eq(o)).addClass(n.slideActiveClass),
        n.loop &&
          (e.hasClass(n.slideDuplicateClass)
            ? a
                .children(
                  "."
                    .concat(n.slideClass, ":not(.")
                    .concat(
                      n.slideDuplicateClass,
                      ')[data-swiper-slide-index="'
                    )
                    .concat(r, '"]')
                )
                .addClass(n.slideDuplicateActiveClass)
            : a
                .children(
                  "."
                    .concat(n.slideClass, ".")
                    .concat(n.slideDuplicateClass, '[data-swiper-slide-index="')
                    .concat(r, '"]')
                )
                .addClass(n.slideDuplicateActiveClass));
      var l = e
        .nextAll(".".concat(n.slideClass))
        .eq(0)
        .addClass(n.slideNextClass);
      n.loop && 0 === l.length && (l = i.eq(0)).addClass(n.slideNextClass);
      var c = e
        .prevAll(".".concat(n.slideClass))
        .eq(0)
        .addClass(n.slidePrevClass);
      n.loop && 0 === c.length && (c = i.eq(-1)).addClass(n.slidePrevClass),
        n.loop &&
          (l.hasClass(n.slideDuplicateClass)
            ? a
                .children(
                  "."
                    .concat(n.slideClass, ":not(.")
                    .concat(
                      n.slideDuplicateClass,
                      ')[data-swiper-slide-index="'
                    )
                    .concat(l.attr("data-swiper-slide-index"), '"]')
                )
                .addClass(n.slideDuplicateNextClass)
            : a
                .children(
                  "."
                    .concat(n.slideClass, ".")
                    .concat(n.slideDuplicateClass, '[data-swiper-slide-index="')
                    .concat(l.attr("data-swiper-slide-index"), '"]')
                )
                .addClass(n.slideDuplicateNextClass),
          c.hasClass(n.slideDuplicateClass)
            ? a
                .children(
                  "."
                    .concat(n.slideClass, ":not(.")
                    .concat(
                      n.slideDuplicateClass,
                      ')[data-swiper-slide-index="'
                    )
                    .concat(c.attr("data-swiper-slide-index"), '"]')
                )
                .addClass(n.slideDuplicatePrevClass)
            : a
                .children(
                  "."
                    .concat(n.slideClass, ".")
                    .concat(n.slideDuplicateClass, '[data-swiper-slide-index="')
                    .concat(c.attr("data-swiper-slide-index"), '"]')
                )
                .addClass(n.slideDuplicatePrevClass)),
        t.emitSlidesClasses();
    },
    updateActiveIndex: function (e) {
      var t,
        i = this,
        n = i.rtlTranslate ? i.translate : -i.translate,
        a = i.slidesGrid,
        o = i.snapGrid,
        r = i.params,
        s = i.activeIndex,
        l = i.realIndex,
        c = i.snapIndex,
        u = e;
      if (void 0 === u) {
        for (var d = 0; d < a.length; d += 1)
          void 0 !== a[d + 1]
            ? n >= a[d] && n < a[d + 1] - (a[d + 1] - a[d]) / 2
              ? (u = d)
              : n >= a[d] && n < a[d + 1] && (u = d + 1)
            : n >= a[d] && (u = d);
        r.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0);
      }
      if (o.indexOf(n) >= 0) t = o.indexOf(n);
      else {
        var p = Math.min(r.slidesPerGroupSkip, u);
        t = p + Math.floor((u - p) / r.slidesPerGroup);
      }
      if ((t >= o.length && (t = o.length - 1), u !== s)) {
        var f = parseInt(
          i.slides.eq(u).attr("data-swiper-slide-index") || u,
          10
        );
        Object.assign(i, {
          snapIndex: t,
          realIndex: f,
          previousIndex: s,
          activeIndex: u,
        }),
          i.emit("activeIndexChange"),
          i.emit("snapIndexChange"),
          l !== f && i.emit("realIndexChange"),
          (i.initialized || i.params.runCallbacksOnInit) &&
            i.emit("slideChange");
      } else t !== c && ((i.snapIndex = t), i.emit("snapIndexChange"));
    },
    updateClickedSlide: function (e) {
      var t,
        i = this,
        n = i.params,
        a = fe(e).closest(".".concat(n.slideClass))[0],
        o = !1;
      if (a)
        for (var r = 0; r < i.slides.length; r += 1)
          if (i.slides[r] === a) {
            (o = !0), (t = r);
            break;
          }
      if (!a || !o)
        return (i.clickedSlide = void 0), void (i.clickedIndex = void 0);
      (i.clickedSlide = a),
        i.virtual && i.params.virtual.enabled
          ? (i.clickedIndex = parseInt(
              fe(a).attr("data-swiper-slide-index"),
              10
            ))
          : (i.clickedIndex = t),
        n.slideToClickedSlide &&
          void 0 !== i.clickedIndex &&
          i.clickedIndex !== i.activeIndex &&
          i.slideToClickedSlide();
    },
  };
  var Ne = {
    getTranslate: function () {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : this.isHorizontal()
            ? "x"
            : "y",
        t = this,
        i = t.params,
        n = t.rtlTranslate,
        a = t.translate,
        o = t.$wrapperEl;
      if (i.virtualTranslate) return n ? -a : a;
      if (i.cssMode) return a;
      var r = ve(o[0], e);
      return n && (r = -r), r || 0;
    },
    setTranslate: function (e, t) {
      var i = this,
        n = i.rtlTranslate,
        a = i.params,
        o = i.$wrapperEl,
        r = i.wrapperEl,
        s = i.progress,
        l = 0,
        c = 0;
      i.isHorizontal() ? (l = n ? -e : e) : (c = e),
        a.roundLengths && ((l = Math.floor(l)), (c = Math.floor(c))),
        a.cssMode
          ? (r[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal()
              ? -l
              : -c)
          : a.virtualTranslate ||
            o.transform(
              "translate3d("
                .concat(l, "px, ")
                .concat(c, "px, ")
                .concat(0, "px)")
            ),
        (i.previousTranslate = i.translate),
        (i.translate = i.isHorizontal() ? l : c);
      var u = i.maxTranslate() - i.minTranslate();
      (0 === u ? 0 : (e - i.minTranslate()) / u) !== s && i.updateProgress(e),
        i.emit("setTranslate", i.translate, t);
    },
    minTranslate: function () {
      return -this.snapGrid[0];
    },
    maxTranslate: function () {
      return -this.snapGrid[this.snapGrid.length - 1];
    },
    translateTo: function () {
      var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
        t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : this.params.speed,
        i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
        n = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
        a = arguments.length > 4 ? arguments[4] : void 0,
        o = this,
        r = o.params,
        s = o.wrapperEl;
      if (o.animating && r.preventInteractionOnTransition) return !1;
      var l,
        c = o.minTranslate(),
        u = o.maxTranslate();
      if (
        ((l = n && e > c ? c : n && e < u ? u : e),
        o.updateProgress(l),
        r.cssMode)
      ) {
        var d = o.isHorizontal();
        if (0 === t) s[d ? "scrollLeft" : "scrollTop"] = -l;
        else {
          if (!o.support.smoothScroll)
            return (
              we({ swiper: o, targetPosition: -l, side: d ? "left" : "top" }),
              !0
            );
          var p;
          s.scrollTo(
            (S((p = {}), d ? "left" : "top", -l), S(p, "behavior", "smooth"), p)
          );
        }
        return !0;
      }
      return (
        0 === t
          ? (o.setTransition(0),
            o.setTranslate(l),
            i &&
              (o.emit("beforeTransitionStart", t, a), o.emit("transitionEnd")))
          : (o.setTransition(t),
            o.setTranslate(l),
            i &&
              (o.emit("beforeTransitionStart", t, a),
              o.emit("transitionStart")),
            o.animating ||
              ((o.animating = !0),
              o.onTranslateToWrapperTransitionEnd ||
                (o.onTranslateToWrapperTransitionEnd = function (e) {
                  o &&
                    !o.destroyed &&
                    e.target === this &&
                    (o.$wrapperEl[0].removeEventListener(
                      "transitionend",
                      o.onTranslateToWrapperTransitionEnd
                    ),
                    o.$wrapperEl[0].removeEventListener(
                      "webkitTransitionEnd",
                      o.onTranslateToWrapperTransitionEnd
                    ),
                    (o.onTranslateToWrapperTransitionEnd = null),
                    delete o.onTranslateToWrapperTransitionEnd,
                    i && o.emit("transitionEnd"));
                }),
              o.$wrapperEl[0].addEventListener(
                "transitionend",
                o.onTranslateToWrapperTransitionEnd
              ),
              o.$wrapperEl[0].addEventListener(
                "webkitTransitionEnd",
                o.onTranslateToWrapperTransitionEnd
              ))),
        !0
      );
    },
  };
  function Me(e) {
    var t = e.swiper,
      i = e.runCallbacks,
      n = e.direction,
      a = e.step,
      o = t.activeIndex,
      r = t.previousIndex,
      s = n;
    if (
      (s || (s = o > r ? "next" : o < r ? "prev" : "reset"),
      t.emit("transition".concat(a)),
      i && o !== r)
    ) {
      if ("reset" === s) return void t.emit("slideResetTransition".concat(a));
      t.emit("slideChangeTransition".concat(a)),
        "next" === s
          ? t.emit("slideNextTransition".concat(a))
          : t.emit("slidePrevTransition".concat(a));
    }
  }
  var xe = {
    setTransition: function (e, t) {
      var i = this;
      i.params.cssMode || i.$wrapperEl.transition(e),
        i.emit("setTransition", e, t);
    },
    transitionStart: function () {
      var e =
          !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
        t = arguments.length > 1 ? arguments[1] : void 0,
        i = this,
        n = i.params;
      n.cssMode ||
        (n.autoHeight && i.updateAutoHeight(),
        Me({ swiper: i, runCallbacks: e, direction: t, step: "Start" }));
    },
    transitionEnd: function () {
      var e =
          !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
        t = arguments.length > 1 ? arguments[1] : void 0,
        i = this,
        n = i.params;
      (i.animating = !1),
        n.cssMode ||
          (i.setTransition(0),
          Me({ swiper: i, runCallbacks: e, direction: t, step: "End" }));
    },
  };
  var Pe = {
    slideTo: function () {
      var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
        t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : this.params.speed,
        n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
        a = arguments.length > 3 ? arguments[3] : void 0,
        o = arguments.length > 4 ? arguments[4] : void 0;
      if ("number" != typeof e && "string" != typeof e)
        throw new Error(
          "The 'index' argument cannot have type other than 'number' or 'string'. [".concat(
            void 0 === e ? "undefined" : i(e),
            "] given."
          )
        );
      if ("string" == typeof e) {
        var r = parseInt(e, 10);
        if (!isFinite(r))
          throw new Error(
            "The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(
              e,
              "] given."
            )
          );
        e = r;
      }
      var s = this,
        l = e;
      l < 0 && (l = 0);
      var c = s.params,
        u = s.snapGrid,
        d = s.slidesGrid,
        p = s.previousIndex,
        f = s.activeIndex,
        h = s.rtlTranslate,
        g = s.wrapperEl,
        v = s.enabled;
      if ((s.animating && c.preventInteractionOnTransition) || (!v && !a && !o))
        return !1;
      var m = Math.min(s.params.slidesPerGroupSkip, l),
        y = m + Math.floor((l - m) / s.params.slidesPerGroup);
      y >= u.length && (y = u.length - 1);
      var w,
        C = -u[y];
      if (c.normalizeSlideIndex)
        for (var b = 0; b < d.length; b += 1) {
          var A = -Math.floor(100 * C),
            E = Math.floor(100 * d[b]),
            T = Math.floor(100 * d[b + 1]);
          void 0 !== d[b + 1]
            ? A >= E && A < T - (T - E) / 2
              ? (l = b)
              : A >= E && A < T && (l = b + 1)
            : A >= E && (l = b);
        }
      if (s.initialized && l !== f) {
        if (!s.allowSlideNext && C < s.translate && C < s.minTranslate())
          return !1;
        if (
          !s.allowSlidePrev &&
          C > s.translate &&
          C > s.maxTranslate() &&
          (f || 0) !== l
        )
          return !1;
      }
      if (
        (l !== (p || 0) && n && s.emit("beforeSlideChangeStart"),
        s.updateProgress(C),
        (w = l > f ? "next" : l < f ? "prev" : "reset"),
        (h && -C === s.translate) || (!h && C === s.translate))
      )
        return (
          s.updateActiveIndex(l),
          c.autoHeight && s.updateAutoHeight(),
          s.updateSlidesClasses(),
          "slide" !== c.effect && s.setTranslate(C),
          "reset" !== w && (s.transitionStart(n, w), s.transitionEnd(n, w)),
          !1
        );
      if (c.cssMode) {
        var N = s.isHorizontal(),
          M = h ? C : -C;
        if (0 === t) {
          var x = s.virtual && s.params.virtual.enabled;
          x &&
            ((s.wrapperEl.style.scrollSnapType = "none"),
            (s._immediateVirtual = !0)),
            (g[N ? "scrollLeft" : "scrollTop"] = M),
            x &&
              requestAnimationFrame(function () {
                (s.wrapperEl.style.scrollSnapType = ""),
                  (s._swiperImmediateVirtual = !1);
              });
        } else {
          if (!s.support.smoothScroll)
            return (
              we({ swiper: s, targetPosition: M, side: N ? "left" : "top" }), !0
            );
          var P;
          g.scrollTo(
            (S((P = {}), N ? "left" : "top", M), S(P, "behavior", "smooth"), P)
          );
        }
        return !0;
      }
      return (
        s.setTransition(t),
        s.setTranslate(C),
        s.updateActiveIndex(l),
        s.updateSlidesClasses(),
        s.emit("beforeTransitionStart", t, a),
        s.transitionStart(n, w),
        0 === t
          ? s.transitionEnd(n, w)
          : s.animating ||
            ((s.animating = !0),
            s.onSlideToWrapperTransitionEnd ||
              (s.onSlideToWrapperTransitionEnd = function (e) {
                s &&
                  !s.destroyed &&
                  e.target === this &&
                  (s.$wrapperEl[0].removeEventListener(
                    "transitionend",
                    s.onSlideToWrapperTransitionEnd
                  ),
                  s.$wrapperEl[0].removeEventListener(
                    "webkitTransitionEnd",
                    s.onSlideToWrapperTransitionEnd
                  ),
                  (s.onSlideToWrapperTransitionEnd = null),
                  delete s.onSlideToWrapperTransitionEnd,
                  s.transitionEnd(n, w));
              }),
            s.$wrapperEl[0].addEventListener(
              "transitionend",
              s.onSlideToWrapperTransitionEnd
            ),
            s.$wrapperEl[0].addEventListener(
              "webkitTransitionEnd",
              s.onSlideToWrapperTransitionEnd
            )),
        !0
      );
    },
    slideToLoop: function () {
      var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
        t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : this.params.speed,
        i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
        n = arguments.length > 3 ? arguments[3] : void 0;
      if ("string" == typeof e) {
        var a = parseInt(e, 10);
        if (!isFinite(a))
          throw new Error(
            "The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(
              e,
              "] given."
            )
          );
        e = a;
      }
      var o = this,
        r = e;
      return o.params.loop && (r += o.loopedSlides), o.slideTo(r, t, i, n);
    },
    slideNext: function () {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : this.params.speed,
        t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
        i = arguments.length > 2 ? arguments[2] : void 0,
        n = this,
        a = n.animating,
        o = n.enabled,
        r = n.params;
      if (!o) return n;
      var s = r.slidesPerGroup;
      "auto" === r.slidesPerView &&
        1 === r.slidesPerGroup &&
        r.slidesPerGroupAuto &&
        (s = Math.max(n.slidesPerViewDynamic("current", !0), 1));
      var l = n.activeIndex < r.slidesPerGroupSkip ? 1 : s;
      if (r.loop) {
        if (a && r.loopPreventsSlide) return !1;
        n.loopFix(), (n._clientLeft = n.$wrapperEl[0].clientLeft);
      }
      return r.rewind && n.isEnd
        ? n.slideTo(0, e, t, i)
        : n.slideTo(n.activeIndex + l, e, t, i);
    },
    slidePrev: function () {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : this.params.speed,
        t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
        i = arguments.length > 2 ? arguments[2] : void 0,
        n = function (e) {
          return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
        },
        a = this,
        o = a.params,
        r = a.animating,
        s = a.snapGrid,
        l = a.slidesGrid,
        c = a.rtlTranslate;
      if (!a.enabled) return a;
      if (o.loop) {
        if (r && o.loopPreventsSlide) return !1;
        a.loopFix(), (a._clientLeft = a.$wrapperEl[0].clientLeft);
      }
      var u,
        d = c ? a.translate : -a.translate,
        p = n(d),
        f = s.map(function (e) {
          return n(e);
        }),
        h = s[f.indexOf(p) - 1];
      void 0 === h &&
        o.cssMode &&
        (s.forEach(function (e, t) {
          p >= e && (u = t);
        }),
        void 0 !== u && (h = s[u > 0 ? u - 1 : u]));
      var g = 0;
      if (
        (void 0 !== h &&
          ((g = l.indexOf(h)) < 0 && (g = a.activeIndex - 1),
          "auto" === o.slidesPerView &&
            1 === o.slidesPerGroup &&
            o.slidesPerGroupAuto &&
            ((g = g - a.slidesPerViewDynamic("previous", !0) + 1),
            (g = Math.max(g, 0)))),
        o.rewind && a.isBeginning)
      ) {
        var v =
          a.params.virtual && a.params.virtual.enabled && a.virtual
            ? a.virtual.slides.length - 1
            : a.slides.length - 1;
        return a.slideTo(v, e, t, i);
      }
      return a.slideTo(g, e, t, i);
    },
    slideReset: function () {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : this.params.speed,
        t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
        i = arguments.length > 2 ? arguments[2] : void 0;
      return this.slideTo(this.activeIndex, e, t, i);
    },
    slideToClosest: function () {
      var e =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : this.params.speed,
        t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
        i = arguments.length > 2 ? arguments[2] : void 0,
        n =
          arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0.5,
        a = this,
        o = a.activeIndex,
        r = Math.min(a.params.slidesPerGroupSkip, o),
        s = r + Math.floor((o - r) / a.params.slidesPerGroup),
        l = a.rtlTranslate ? a.translate : -a.translate;
      if (l >= a.snapGrid[s]) {
        var c = a.snapGrid[s];
        l - c > (a.snapGrid[s + 1] - c) * n && (o += a.params.slidesPerGroup);
      } else {
        var u = a.snapGrid[s - 1];
        l - u <= (a.snapGrid[s] - u) * n && (o -= a.params.slidesPerGroup);
      }
      return (
        (o = Math.max(o, 0)),
        (o = Math.min(o, a.slidesGrid.length - 1)),
        a.slideTo(o, e, t, i)
      );
    },
    slideToClickedSlide: function () {
      var e,
        t = this,
        i = t.params,
        n = t.$wrapperEl,
        a =
          "auto" === i.slidesPerView
            ? t.slidesPerViewDynamic()
            : i.slidesPerView,
        o = t.clickedIndex;
      if (i.loop) {
        if (t.animating) return;
        (e = parseInt(fe(t.clickedSlide).attr("data-swiper-slide-index"), 10)),
          i.centeredSlides
            ? o < t.loopedSlides - a / 2 ||
              o > t.slides.length - t.loopedSlides + a / 2
              ? (t.loopFix(),
                (o = n
                  .children(
                    "."
                      .concat(i.slideClass, '[data-swiper-slide-index="')
                      .concat(e, '"]:not(.')
                      .concat(i.slideDuplicateClass, ")")
                  )
                  .eq(0)
                  .index()),
                he(function () {
                  t.slideTo(o);
                }))
              : t.slideTo(o)
            : o > t.slides.length - a
            ? (t.loopFix(),
              (o = n
                .children(
                  "."
                    .concat(i.slideClass, '[data-swiper-slide-index="')
                    .concat(e, '"]:not(.')
                    .concat(i.slideDuplicateClass, ")")
                )
                .eq(0)
                .index()),
              he(function () {
                t.slideTo(o);
              }))
            : t.slideTo(o);
      } else t.slideTo(o);
    },
  };
  function Ie(e) {
    var t = this,
      i = V(),
      n = z(),
      a = t.touchEventsData,
      o = t.params,
      r = t.touches;
    if (t.enabled && (!t.animating || !o.preventInteractionOnTransition)) {
      !t.animating && o.cssMode && o.loop && t.loopFix();
      var s = e;
      s.originalEvent && (s = s.originalEvent);
      var l = fe(s.target);
      if (
        ("wrapper" !== o.touchEventsTarget || l.closest(t.wrapperEl).length) &&
        ((a.isTouchEvent = "touchstart" === s.type),
        (a.isTouchEvent || !("which" in s) || 3 !== s.which) &&
          !(
            (!a.isTouchEvent && "button" in s && s.button > 0) ||
            (a.isTouched && a.isMoved)
          ))
      ) {
        var c = !!o.noSwipingClass && "" !== o.noSwipingClass,
          u = e.composedPath ? e.composedPath() : e.path;
        c && s.target && s.target.shadowRoot && u && (l = fe(u[0]));
        var d = o.noSwipingSelector
            ? o.noSwipingSelector
            : ".".concat(o.noSwipingClass),
          p = !(!s.target || !s.target.shadowRoot);
        if (
          o.noSwiping &&
          (p
            ? (function (e) {
                return (function t(i) {
                  if (!i || i === V() || i === z()) return null;
                  i.assignedSlot && (i = i.assignedSlot);
                  var n = i.closest(e);
                  return n || i.getRootNode
                    ? n || t(i.getRootNode().host)
                    : null;
                })(
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : this
                );
              })(d, l[0])
            : l.closest(d)[0])
        )
          t.allowClick = !0;
        else if (!o.swipeHandler || l.closest(o.swipeHandler)[0]) {
          (r.currentX =
            "touchstart" === s.type ? s.targetTouches[0].pageX : s.pageX),
            (r.currentY =
              "touchstart" === s.type ? s.targetTouches[0].pageY : s.pageY);
          var f = r.currentX,
            h = r.currentY,
            g = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
            v = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
          if (g && (f <= v || f >= n.innerWidth - v)) {
            if ("prevent" !== g) return;
            e.preventDefault();
          }
          if (
            (Object.assign(a, {
              isTouched: !0,
              isMoved: !1,
              allowTouchCallbacks: !0,
              isScrolling: void 0,
              startMoving: void 0,
            }),
            (r.startX = f),
            (r.startY = h),
            (a.touchStartTime = ge()),
            (t.allowClick = !0),
            t.updateSize(),
            (t.swipeDirection = void 0),
            o.threshold > 0 && (a.allowThresholdMove = !1),
            "touchstart" !== s.type)
          ) {
            var m = !0;
            l.is(a.focusableElements) &&
              ((m = !1), "SELECT" === l[0].nodeName && (a.isTouched = !1)),
              i.activeElement &&
                fe(i.activeElement).is(a.focusableElements) &&
                i.activeElement !== l[0] &&
                i.activeElement.blur();
            var y = m && t.allowTouchMove && o.touchStartPreventDefault;
            (!o.touchStartForcePreventDefault && !y) ||
              l[0].isContentEditable ||
              s.preventDefault();
          }
          t.params.freeMode &&
            t.params.freeMode.enabled &&
            t.freeMode &&
            t.animating &&
            !o.cssMode &&
            t.freeMode.onTouchStart(),
            t.emit("touchStart", s);
        }
      }
    }
  }
  function Le(e) {
    var t = V(),
      i = this,
      n = i.touchEventsData,
      a = i.params,
      o = i.touches,
      r = i.rtlTranslate;
    if (i.enabled) {
      var s = e;
      if ((s.originalEvent && (s = s.originalEvent), n.isTouched)) {
        if (!n.isTouchEvent || "touchmove" === s.type) {
          var l =
              "touchmove" === s.type &&
              s.targetTouches &&
              (s.targetTouches[0] || s.changedTouches[0]),
            c = "touchmove" === s.type ? l.pageX : s.pageX,
            u = "touchmove" === s.type ? l.pageY : s.pageY;
          if (s.preventedByNestedSwiper)
            return (o.startX = c), void (o.startY = u);
          if (!i.allowTouchMove)
            return (
              fe(s.target).is(n.focusableElements) || (i.allowClick = !1),
              void (
                n.isTouched &&
                (Object.assign(o, {
                  startX: c,
                  startY: u,
                  currentX: c,
                  currentY: u,
                }),
                (n.touchStartTime = ge()))
              )
            );
          if (n.isTouchEvent && a.touchReleaseOnEdges && !a.loop)
            if (i.isVertical()) {
              if (
                (u < o.startY && i.translate <= i.maxTranslate()) ||
                (u > o.startY && i.translate >= i.minTranslate())
              )
                return (n.isTouched = !1), void (n.isMoved = !1);
            } else if (
              (c < o.startX && i.translate <= i.maxTranslate()) ||
              (c > o.startX && i.translate >= i.minTranslate())
            )
              return;
          if (
            n.isTouchEvent &&
            t.activeElement &&
            s.target === t.activeElement &&
            fe(s.target).is(n.focusableElements)
          )
            return (n.isMoved = !0), void (i.allowClick = !1);
          if (
            (n.allowTouchCallbacks && i.emit("touchMove", s),
            !(s.targetTouches && s.targetTouches.length > 1))
          ) {
            (o.currentX = c), (o.currentY = u);
            var d = o.currentX - o.startX,
              p = o.currentY - o.startY;
            if (
              !(
                i.params.threshold &&
                Math.sqrt(Math.pow(d, 2) + Math.pow(p, 2)) < i.params.threshold
              )
            ) {
              var f;
              if (void 0 === n.isScrolling)
                (i.isHorizontal() && o.currentY === o.startY) ||
                (i.isVertical() && o.currentX === o.startX)
                  ? (n.isScrolling = !1)
                  : d * d + p * p >= 25 &&
                    ((f =
                      (180 * Math.atan2(Math.abs(p), Math.abs(d))) / Math.PI),
                    (n.isScrolling = i.isHorizontal()
                      ? f > a.touchAngle
                      : 90 - f > a.touchAngle));
              if (
                (n.isScrolling && i.emit("touchMoveOpposite", s),
                void 0 === n.startMoving &&
                  ((o.currentX === o.startX && o.currentY === o.startY) ||
                    (n.startMoving = !0)),
                n.isScrolling)
              )
                n.isTouched = !1;
              else if (n.startMoving) {
                (i.allowClick = !1),
                  !a.cssMode && s.cancelable && s.preventDefault(),
                  a.touchMoveStopPropagation &&
                    !a.nested &&
                    s.stopPropagation(),
                  n.isMoved ||
                    (a.loop && !a.cssMode && i.loopFix(),
                    (n.startTranslate = i.getTranslate()),
                    i.setTransition(0),
                    i.animating &&
                      i.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
                    (n.allowMomentumBounce = !1),
                    !a.grabCursor ||
                      (!0 !== i.allowSlideNext && !0 !== i.allowSlidePrev) ||
                      i.setGrabCursor(!0),
                    i.emit("sliderFirstMove", s)),
                  i.emit("sliderMove", s),
                  (n.isMoved = !0);
                var h = i.isHorizontal() ? d : p;
                (o.diff = h),
                  (h *= a.touchRatio),
                  r && (h = -h),
                  (i.swipeDirection = h > 0 ? "prev" : "next"),
                  (n.currentTranslate = h + n.startTranslate);
                var g = !0,
                  v = a.resistanceRatio;
                if (
                  (a.touchReleaseOnEdges && (v = 0),
                  h > 0 && n.currentTranslate > i.minTranslate()
                    ? ((g = !1),
                      a.resistance &&
                        (n.currentTranslate =
                          i.minTranslate() -
                          1 +
                          Math.pow(
                            -i.minTranslate() + n.startTranslate + h,
                            v
                          )))
                    : h < 0 &&
                      n.currentTranslate < i.maxTranslate() &&
                      ((g = !1),
                      a.resistance &&
                        (n.currentTranslate =
                          i.maxTranslate() +
                          1 -
                          Math.pow(
                            i.maxTranslate() - n.startTranslate - h,
                            v
                          ))),
                  g && (s.preventedByNestedSwiper = !0),
                  !i.allowSlideNext &&
                    "next" === i.swipeDirection &&
                    n.currentTranslate < n.startTranslate &&
                    (n.currentTranslate = n.startTranslate),
                  !i.allowSlidePrev &&
                    "prev" === i.swipeDirection &&
                    n.currentTranslate > n.startTranslate &&
                    (n.currentTranslate = n.startTranslate),
                  i.allowSlidePrev ||
                    i.allowSlideNext ||
                    (n.currentTranslate = n.startTranslate),
                  a.threshold > 0)
                ) {
                  if (!(Math.abs(h) > a.threshold || n.allowThresholdMove))
                    return void (n.currentTranslate = n.startTranslate);
                  if (!n.allowThresholdMove)
                    return (
                      (n.allowThresholdMove = !0),
                      (o.startX = o.currentX),
                      (o.startY = o.currentY),
                      (n.currentTranslate = n.startTranslate),
                      void (o.diff = i.isHorizontal()
                        ? o.currentX - o.startX
                        : o.currentY - o.startY)
                    );
                }
                a.followFinger &&
                  !a.cssMode &&
                  (((a.freeMode && a.freeMode.enabled && i.freeMode) ||
                    a.watchSlidesProgress) &&
                    (i.updateActiveIndex(), i.updateSlidesClasses()),
                  i.params.freeMode &&
                    a.freeMode.enabled &&
                    i.freeMode &&
                    i.freeMode.onTouchMove(),
                  i.updateProgress(n.currentTranslate),
                  i.setTranslate(n.currentTranslate));
              }
            }
          }
        }
      } else n.startMoving && n.isScrolling && i.emit("touchMoveOpposite", s);
    }
  }
  function ke(e) {
    var t = this,
      i = t.touchEventsData,
      n = t.params,
      a = t.touches,
      o = t.rtlTranslate,
      r = t.slidesGrid;
    if (t.enabled) {
      var s = e;
      if (
        (s.originalEvent && (s = s.originalEvent),
        i.allowTouchCallbacks && t.emit("touchEnd", s),
        (i.allowTouchCallbacks = !1),
        !i.isTouched)
      )
        return (
          i.isMoved && n.grabCursor && t.setGrabCursor(!1),
          (i.isMoved = !1),
          void (i.startMoving = !1)
        );
      n.grabCursor &&
        i.isMoved &&
        i.isTouched &&
        (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
        t.setGrabCursor(!1);
      var l,
        c = ge(),
        u = c - i.touchStartTime;
      if (t.allowClick) {
        var d = s.path || (s.composedPath && s.composedPath());
        t.updateClickedSlide((d && d[0]) || s.target),
          t.emit("tap click", s),
          u < 300 &&
            c - i.lastClickTime < 300 &&
            t.emit("doubleTap doubleClick", s);
      }
      if (
        ((i.lastClickTime = ge()),
        he(function () {
          t.destroyed || (t.allowClick = !0);
        }),
        !i.isTouched ||
          !i.isMoved ||
          !t.swipeDirection ||
          0 === a.diff ||
          i.currentTranslate === i.startTranslate)
      )
        return (i.isTouched = !1), (i.isMoved = !1), void (i.startMoving = !1);
      if (
        ((i.isTouched = !1),
        (i.isMoved = !1),
        (i.startMoving = !1),
        (l = n.followFinger
          ? o
            ? t.translate
            : -t.translate
          : -i.currentTranslate),
        !n.cssMode)
      )
        if (t.params.freeMode && n.freeMode.enabled)
          t.freeMode.onTouchEnd({ currentPos: l });
        else {
          for (
            var p = 0, f = t.slidesSizesGrid[0], h = 0;
            h < r.length;
            h += h < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup
          ) {
            var g = h < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
            void 0 !== r[h + g]
              ? l >= r[h] && l < r[h + g] && ((p = h), (f = r[h + g] - r[h]))
              : l >= r[h] && ((p = h), (f = r[r.length - 1] - r[r.length - 2]));
          }
          var v = null,
            m = null;
          n.rewind &&
            (t.isBeginning
              ? (m =
                  t.params.virtual && t.params.virtual.enabled && t.virtual
                    ? t.virtual.slides.length - 1
                    : t.slides.length - 1)
              : t.isEnd && (v = 0));
          var y = (l - r[p]) / f,
            S = p < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
          if (u > n.longSwipesMs) {
            if (!n.longSwipes) return void t.slideTo(t.activeIndex);
            "next" === t.swipeDirection &&
              (y >= n.longSwipesRatio
                ? t.slideTo(n.rewind && t.isEnd ? v : p + S)
                : t.slideTo(p)),
              "prev" === t.swipeDirection &&
                (y > 1 - n.longSwipesRatio
                  ? t.slideTo(p + S)
                  : null !== m && y < 0 && Math.abs(y) > n.longSwipesRatio
                  ? t.slideTo(m)
                  : t.slideTo(p));
          } else {
            if (!n.shortSwipes) return void t.slideTo(t.activeIndex);
            t.navigation &&
            (s.target === t.navigation.nextEl ||
              s.target === t.navigation.prevEl)
              ? s.target === t.navigation.nextEl
                ? t.slideTo(p + S)
                : t.slideTo(p)
              : ("next" === t.swipeDirection &&
                  t.slideTo(null !== v ? v : p + S),
                "prev" === t.swipeDirection && t.slideTo(null !== m ? m : p));
          }
        }
    }
  }
  function Oe() {
    var e = this,
      t = e.params,
      i = e.el;
    if (!i || 0 !== i.offsetWidth) {
      t.breakpoints && e.setBreakpoint();
      var n = e.allowSlideNext,
        a = e.allowSlidePrev,
        o = e.snapGrid;
      (e.allowSlideNext = !0),
        (e.allowSlidePrev = !0),
        e.updateSize(),
        e.updateSlides(),
        e.updateSlidesClasses(),
        ("auto" === t.slidesPerView || t.slidesPerView > 1) &&
        e.isEnd &&
        !e.isBeginning &&
        !e.params.centeredSlides
          ? e.slideTo(e.slides.length - 1, 0, !1, !0)
          : e.slideTo(e.activeIndex, 0, !1, !0),
        e.autoplay &&
          e.autoplay.running &&
          e.autoplay.paused &&
          e.autoplay.run(),
        (e.allowSlidePrev = a),
        (e.allowSlideNext = n),
        e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow();
    }
  }
  function Be(e) {
    var t = this;
    t.enabled &&
      (t.allowClick ||
        (t.params.preventClicks && e.preventDefault(),
        t.params.preventClicksPropagation &&
          t.animating &&
          (e.stopPropagation(), e.stopImmediatePropagation())));
  }
  function Ge() {
    var e = this,
      t = e.wrapperEl,
      i = e.rtlTranslate;
    if (e.enabled) {
      (e.previousTranslate = e.translate),
        e.isHorizontal()
          ? (e.translate = -t.scrollLeft)
          : (e.translate = -t.scrollTop),
        0 === e.translate && (e.translate = 0),
        e.updateActiveIndex(),
        e.updateSlidesClasses();
      var n = e.maxTranslate() - e.minTranslate();
      (0 === n ? 0 : (e.translate - e.minTranslate()) / n) !== e.progress &&
        e.updateProgress(i ? -e.translate : e.translate),
        e.emit("setTranslate", e.translate, !1);
    }
  }
  var De = !1;
  function Re() {}
  var We = function (e, t) {
    var i = V(),
      n = e.params,
      a = e.touchEvents,
      o = e.el,
      r = e.wrapperEl,
      s = e.device,
      l = e.support,
      c = !!n.nested,
      u = "on" === t ? "addEventListener" : "removeEventListener",
      d = t;
    if (l.touch) {
      var p = !(
        "touchstart" !== a.start ||
        !l.passiveListener ||
        !n.passiveListeners
      ) && { passive: !0, capture: !1 };
      o[u](a.start, e.onTouchStart, p),
        o[u](
          a.move,
          e.onTouchMove,
          l.passiveListener ? { passive: !1, capture: c } : c
        ),
        o[u](a.end, e.onTouchEnd, p),
        a.cancel && o[u](a.cancel, e.onTouchEnd, p);
    } else
      o[u](a.start, e.onTouchStart, !1),
        i[u](a.move, e.onTouchMove, c),
        i[u](a.end, e.onTouchEnd, !1);
    (n.preventClicks || n.preventClicksPropagation) &&
      o[u]("click", e.onClick, !0),
      n.cssMode && r[u]("scroll", e.onScroll),
      n.updateOnWindowResize
        ? e[d](
            s.ios || s.android
              ? "resize orientationchange observerUpdate"
              : "resize observerUpdate",
            Oe,
            !0
          )
        : e[d]("observerUpdate", Oe, !0);
  };
  var Fe = function (e, t) {
    return e.grid && t.grid && t.grid.rows > 1;
  };
  var _e = {
    setBreakpoint: function () {
      var e = this,
        t = e.activeIndex,
        i = e.initialized,
        n = e.loopedSlides,
        a = void 0 === n ? 0 : n,
        o = e.params,
        r = e.$el,
        s = o.breakpoints;
      if (s && (!s || 0 !== Object.keys(s).length)) {
        var l = e.getBreakpoint(s, e.params.breakpointsBase, e.el);
        if (l && e.currentBreakpoint !== l) {
          var c = (l in s ? s[l] : void 0) || e.originalParams,
            u = Fe(e, o),
            d = Fe(e, c),
            p = o.enabled;
          u && !d
            ? (r.removeClass(
                ""
                  .concat(o.containerModifierClass, "grid ")
                  .concat(o.containerModifierClass, "grid-column")
              ),
              e.emitContainerClasses())
            : !u &&
              d &&
              (r.addClass("".concat(o.containerModifierClass, "grid")),
              ((c.grid.fill && "column" === c.grid.fill) ||
                (!c.grid.fill && "column" === o.grid.fill)) &&
                r.addClass("".concat(o.containerModifierClass, "grid-column")),
              e.emitContainerClasses()),
            ["navigation", "pagination", "scrollbar"].forEach(function (t) {
              var i = o[t] && o[t].enabled,
                n = c[t] && c[t].enabled;
              i && !n && e[t].disable(), !i && n && e[t].enable();
            });
          var f = c.direction && c.direction !== o.direction,
            h = o.loop && (c.slidesPerView !== o.slidesPerView || f);
          f && i && e.changeDirection(), ye(e.params, c);
          var g = e.params.enabled;
          Object.assign(e, {
            allowTouchMove: e.params.allowTouchMove,
            allowSlideNext: e.params.allowSlideNext,
            allowSlidePrev: e.params.allowSlidePrev,
          }),
            p && !g ? e.disable() : !p && g && e.enable(),
            (e.currentBreakpoint = l),
            e.emit("_beforeBreakpoint", c),
            h &&
              i &&
              (e.loopDestroy(),
              e.loopCreate(),
              e.updateSlides(),
              e.slideTo(t - a + e.loopedSlides, 0, !1)),
            e.emit("breakpoint", c);
        }
      }
    },
    getBreakpoint: function (e) {
      var t =
          arguments.length > 1 && void 0 !== arguments[1]
            ? arguments[1]
            : "window",
        i = arguments.length > 2 ? arguments[2] : void 0;
      if (e && ("container" !== t || i)) {
        var n = !1,
          a = z(),
          o = "window" === t ? a.innerHeight : i.clientHeight,
          r = Object.keys(e).map(function (e) {
            if ("string" == typeof e && 0 === e.indexOf("@")) {
              var t = parseFloat(e.substr(1));
              return { value: o * t, point: e };
            }
            return { value: e, point: e };
          });
        r.sort(function (e, t) {
          return parseInt(e.value, 10) - parseInt(t.value, 10);
        });
        for (var s = 0; s < r.length; s += 1) {
          var l = r[s],
            c = l.point,
            u = l.value;
          "window" === t
            ? a.matchMedia("(min-width: ".concat(u, "px)")).matches && (n = c)
            : u <= i.clientWidth && (n = c);
        }
        return n || "max";
      }
    },
  };
  var He = {
    init: !0,
    direction: "horizontal",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 0,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    preloadImages: !0,
    updateOnImagesReady: !0,
    loop: !1,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: !0,
    loopFillGroupWithBlank: !1,
    loopPreventsSlide: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  };
  function Ve(e, t) {
    return function () {
      var i =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        n = Object.keys(i)[0],
        a = i[n];
      "object" == typeof a && null !== a
        ? (["navigation", "pagination", "scrollbar"].indexOf(n) >= 0 &&
            !0 === e[n] &&
            (e[n] = { auto: !0 }),
          n in e && "enabled" in a
            ? (!0 === e[n] && (e[n] = { enabled: !0 }),
              "object" != typeof e[n] ||
                "enabled" in e[n] ||
                (e[n].enabled = !0),
              e[n] || (e[n] = { enabled: !1 }),
              ye(t, i))
            : ye(t, i))
        : ye(t, i);
    };
  }
  var Ue = {
      eventsEmitter: Ee,
      update: Te,
      translate: Ne,
      transition: xe,
      slide: Pe,
      loop: {
        loopCreate: function () {
          var e = this,
            t = V(),
            i = e.params,
            n = e.$wrapperEl,
            a = n.children().length > 0 ? fe(n.children()[0].parentNode) : n;
          a.children(
            ".".concat(i.slideClass, ".").concat(i.slideDuplicateClass)
          ).remove();
          var o = a.children(".".concat(i.slideClass));
          if (i.loopFillGroupWithBlank) {
            var r = i.slidesPerGroup - (o.length % i.slidesPerGroup);
            if (r !== i.slidesPerGroup) {
              for (var s = 0; s < r; s += 1) {
                var l = fe(t.createElement("div")).addClass(
                  "".concat(i.slideClass, " ").concat(i.slideBlankClass)
                );
                a.append(l);
              }
              o = a.children(".".concat(i.slideClass));
            }
          }
          "auto" !== i.slidesPerView ||
            i.loopedSlides ||
            (i.loopedSlides = o.length),
            (e.loopedSlides = Math.ceil(
              parseFloat(i.loopedSlides || i.slidesPerView, 10)
            )),
            (e.loopedSlides += i.loopAdditionalSlides),
            e.loopedSlides > o.length &&
              e.params.loopedSlidesLimit &&
              (e.loopedSlides = o.length);
          var c = [],
            u = [];
          o.each(function (e, t) {
            fe(e).attr("data-swiper-slide-index", t);
          });
          for (var d = 0; d < e.loopedSlides; d += 1) {
            var p = d - Math.floor(d / o.length) * o.length;
            u.push(o.eq(p)[0]), c.unshift(o.eq(o.length - p - 1)[0]);
          }
          for (var f = 0; f < u.length; f += 1)
            a.append(fe(u[f].cloneNode(!0)).addClass(i.slideDuplicateClass));
          for (var h = c.length - 1; h >= 0; h -= 1)
            a.prepend(fe(c[h].cloneNode(!0)).addClass(i.slideDuplicateClass));
        },
        loopFix: function () {
          var e = this;
          e.emit("beforeLoopFix");
          var t,
            i = e.activeIndex,
            n = e.slides,
            a = e.loopedSlides,
            o = e.allowSlidePrev,
            r = e.allowSlideNext,
            s = e.snapGrid,
            l = e.rtlTranslate;
          (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
          var c = -s[i] - e.getTranslate();
          if (i < a)
            (t = n.length - 3 * a + i),
              (t += a),
              e.slideTo(t, 0, !1, !0) &&
                0 !== c &&
                e.setTranslate((l ? -e.translate : e.translate) - c);
          else if (i >= n.length - a) {
            (t = -n.length + i + a),
              (t += a),
              e.slideTo(t, 0, !1, !0) &&
                0 !== c &&
                e.setTranslate((l ? -e.translate : e.translate) - c);
          }
          (e.allowSlidePrev = o), (e.allowSlideNext = r), e.emit("loopFix");
        },
        loopDestroy: function () {
          var e = this,
            t = e.$wrapperEl,
            i = e.params,
            n = e.slides;
          t
            .children(
              "."
                .concat(i.slideClass, ".")
                .concat(i.slideDuplicateClass, ",.")
                .concat(i.slideClass, ".")
                .concat(i.slideBlankClass)
            )
            .remove(),
            n.removeAttr("data-swiper-slide-index");
        },
      },
      grabCursor: {
        setGrabCursor: function (e) {
          var t = this;
          if (
            !(
              t.support.touch ||
              !t.params.simulateTouch ||
              (t.params.watchOverflow && t.isLocked) ||
              t.params.cssMode
            )
          ) {
            var i =
              "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
            (i.style.cursor = "move"),
              (i.style.cursor = e ? "grabbing" : "grab");
          }
        },
        unsetGrabCursor: function () {
          var e = this;
          e.support.touch ||
            (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e[
              "container" === e.params.touchEventsTarget ? "el" : "wrapperEl"
            ].style.cursor = "");
        },
      },
      events: {
        attachEvents: function () {
          var e = this,
            t = V(),
            i = e.params,
            n = e.support;
          (e.onTouchStart = Ie.bind(e)),
            (e.onTouchMove = Le.bind(e)),
            (e.onTouchEnd = ke.bind(e)),
            i.cssMode && (e.onScroll = Ge.bind(e)),
            (e.onClick = Be.bind(e)),
            n.touch && !De && (t.addEventListener("touchstart", Re), (De = !0)),
            We(e, "on");
        },
        detachEvents: function () {
          We(this, "off");
        },
      },
      breakpoints: _e,
      checkOverflow: {
        checkOverflow: function () {
          var e = this,
            t = e.isLocked,
            i = e.params,
            n = i.slidesOffsetBefore;
          if (n) {
            var a = e.slides.length - 1,
              o = e.slidesGrid[a] + e.slidesSizesGrid[a] + 2 * n;
            e.isLocked = e.size > o;
          } else e.isLocked = 1 === e.snapGrid.length;
          !0 === i.allowSlideNext && (e.allowSlideNext = !e.isLocked),
            !0 === i.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
            t && t !== e.isLocked && (e.isEnd = !1),
            t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
        },
      },
      classes: {
        addClasses: function () {
          var e,
            t,
            i,
            n,
            a = this,
            o = a.classNames,
            r = a.params,
            s = a.rtl,
            l = a.$el,
            c = a.device,
            u = a.support,
            d =
              ((t = [
                "initialized",
                r.direction,
                { "pointer-events": !u.touch },
                { "free-mode": a.params.freeMode && r.freeMode.enabled },
                { autoheight: r.autoHeight },
                { rtl: s },
                { grid: r.grid && r.grid.rows > 1 },
                {
                  "grid-column":
                    r.grid && r.grid.rows > 1 && "column" === r.grid.fill,
                },
                { android: c.android },
                { ios: c.ios },
                { "css-mode": r.cssMode },
                { centered: r.cssMode && r.centeredSlides },
                { "watch-progress": r.watchSlidesProgress },
              ]),
              (i = r.containerModifierClass),
              (n = []),
              t.forEach(function (e) {
                "object" == typeof e
                  ? Object.keys(e).forEach(function (t) {
                      e[t] && n.push(i + t);
                    })
                  : "string" == typeof e && n.push(i + e);
              }),
              n);
          (e = o).push.apply(e, W(d)),
            l.addClass(W(o).join(" ")),
            a.emitContainerClasses();
        },
        removeClasses: function () {
          var e = this,
            t = e.$el,
            i = e.classNames;
          t.removeClass(i.join(" ")), e.emitContainerClasses();
        },
      },
      images: {
        loadImage: function (e, t, i, n, a, o) {
          var r,
            s = function () {
              o && o();
            },
            l = z();
          fe(e).parent("picture")[0] || (e.complete && a)
            ? s()
            : t
            ? (((r = new l.Image()).onload = s),
              (r.onerror = s),
              n && (r.sizes = n),
              i && (r.srcset = i),
              t && (r.src = t))
            : s();
        },
        preloadImages: function () {
          var e = function () {
              null != t &&
                t &&
                !t.destroyed &&
                (void 0 !== t.imagesLoaded && (t.imagesLoaded += 1),
                t.imagesLoaded === t.imagesToLoad.length &&
                  (t.params.updateOnImagesReady && t.update(),
                  t.emit("imagesReady")));
            },
            t = this;
          t.imagesToLoad = t.$el.find("img");
          for (var i = 0; i < t.imagesToLoad.length; i += 1) {
            var n = t.imagesToLoad[i];
            t.loadImage(
              n,
              n.currentSrc || n.getAttribute("src"),
              n.srcset || n.getAttribute("srcset"),
              n.sizes || n.getAttribute("sizes"),
              !0,
              e
            );
          }
        },
      },
    },
    ze = {},
    Ke = (function () {
      "use strict";
      function e() {
        for (var t = arguments.length, i = new Array(t), n = 0; n < t; n++)
          i[n] = arguments[n];
        var a, o, r, s;
        if (
          (M(this, e),
          1 === i.length &&
          i[0].constructor &&
          "Object" === Object.prototype.toString.call(i[0]).slice(8, -1)
            ? (r = i[0])
            : ((o = (s = c(i, 2))[0]), (r = s[1])),
          r || (r = {}),
          (r = ye({}, r)),
          o && !r.el && (r.el = o),
          r.el && fe(r.el).length > 1)
        ) {
          var l = [];
          return (
            fe(r.el).each(function (t) {
              var i = ye({}, r, { el: t });
              l.push(new e(i));
            }),
            l
          );
        }
        var u = this;
        (u.__swiper__ = !0),
          (u.support = Ce()),
          (u.device = be({ userAgent: r.userAgent })),
          (u.browser = Ae()),
          (u.eventsListeners = {}),
          (u.eventsAnyListeners = []),
          (u.modules = W(u.__modules__)),
          r.modules &&
            Array.isArray(r.modules) &&
            (a = u.modules).push.apply(a, W(r.modules));
        var d = {};
        u.modules.forEach(function (e) {
          e({
            swiper: u,
            extendParams: Ve(r, d),
            on: u.on.bind(u),
            once: u.once.bind(u),
            off: u.off.bind(u),
            emit: u.emit.bind(u),
          });
        });
        var p,
          f,
          h = ye({}, He, d);
        return (
          (u.params = ye({}, h, ze, r)),
          (u.originalParams = ye({}, u.params)),
          (u.passedParams = ye({}, r)),
          u.params &&
            u.params.on &&
            Object.keys(u.params.on).forEach(function (e) {
              u.on(e, u.params.on[e]);
            }),
          u.params && u.params.onAny && u.onAny(u.params.onAny),
          (u.$ = fe),
          Object.assign(u, {
            enabled: u.params.enabled,
            el: o,
            classNames: [],
            slides: fe(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            isHorizontal: function () {
              return "horizontal" === u.params.direction;
            },
            isVertical: function () {
              return "vertical" === u.params.direction;
            },
            activeIndex: 0,
            realIndex: 0,
            isBeginning: !0,
            isEnd: !1,
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: !1,
            allowSlideNext: u.params.allowSlideNext,
            allowSlidePrev: u.params.allowSlidePrev,
            touchEvents:
              ((p = ["touchstart", "touchmove", "touchend", "touchcancel"]),
              (f = ["pointerdown", "pointermove", "pointerup"]),
              (u.touchEventsTouch = {
                start: p[0],
                move: p[1],
                end: p[2],
                cancel: p[3],
              }),
              (u.touchEventsDesktop = { start: f[0], move: f[1], end: f[2] }),
              u.support.touch || !u.params.simulateTouch
                ? u.touchEventsTouch
                : u.touchEventsDesktop),
            touchEventsData: {
              isTouched: void 0,
              isMoved: void 0,
              allowTouchCallbacks: void 0,
              touchStartTime: void 0,
              isScrolling: void 0,
              currentTranslate: void 0,
              startTranslate: void 0,
              allowThresholdMove: void 0,
              focusableElements: u.params.focusableElements,
              lastClickTime: ge(),
              clickTimeout: void 0,
              velocities: [],
              allowMomentumBounce: void 0,
              isTouchEvent: void 0,
              startMoving: void 0,
            },
            allowClick: !0,
            allowTouchMove: u.params.allowTouchMove,
            touches: {
              startX: 0,
              startY: 0,
              currentX: 0,
              currentY: 0,
              diff: 0,
            },
            imagesToLoad: [],
            imagesLoaded: 0,
          }),
          u.emit("_swiper"),
          u.params.init && u.init(),
          u
        );
      }
      return (
        P(
          e,
          [
            {
              key: "enable",
              value: function () {
                var e = this;
                e.enabled ||
                  ((e.enabled = !0),
                  e.params.grabCursor && e.setGrabCursor(),
                  e.emit("enable"));
              },
            },
            {
              key: "disable",
              value: function () {
                var e = this;
                e.enabled &&
                  ((e.enabled = !1),
                  e.params.grabCursor && e.unsetGrabCursor(),
                  e.emit("disable"));
              },
            },
            {
              key: "setProgress",
              value: function (e, t) {
                var i = this;
                e = Math.min(Math.max(e, 0), 1);
                var n = i.minTranslate(),
                  a = (i.maxTranslate() - n) * e + n;
                i.translateTo(a, void 0 === t ? 0 : t),
                  i.updateActiveIndex(),
                  i.updateSlidesClasses();
              },
            },
            {
              key: "emitContainerClasses",
              value: function () {
                var e = this;
                if (e.params._emitClasses && e.el) {
                  var t = e.el.className.split(" ").filter(function (t) {
                    return (
                      0 === t.indexOf("swiper") ||
                      0 === t.indexOf(e.params.containerModifierClass)
                    );
                  });
                  e.emit("_containerClasses", t.join(" "));
                }
              },
            },
            {
              key: "getSlideClasses",
              value: function (e) {
                var t = this;
                return t.destroyed
                  ? ""
                  : e.className
                      .split(" ")
                      .filter(function (e) {
                        return (
                          0 === e.indexOf("swiper-slide") ||
                          0 === e.indexOf(t.params.slideClass)
                        );
                      })
                      .join(" ");
              },
            },
            {
              key: "emitSlidesClasses",
              value: function () {
                var e = this;
                if (e.params._emitClasses && e.el) {
                  var t = [];
                  e.slides.each(function (i) {
                    var n = e.getSlideClasses(i);
                    t.push({ slideEl: i, classNames: n }),
                      e.emit("_slideClass", i, n);
                  }),
                    e.emit("_slideClasses", t);
                }
              },
            },
            {
              key: "slidesPerViewDynamic",
              value: function () {
                var e =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : "current",
                  t =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1],
                  i = this,
                  n = i.params,
                  a = i.slides,
                  o = i.slidesGrid,
                  r = i.slidesSizesGrid,
                  s = i.size,
                  l = i.activeIndex,
                  c = 1;
                if (n.centeredSlides) {
                  for (
                    var u, d = a[l].swiperSlideSize, p = l + 1;
                    p < a.length;
                    p += 1
                  )
                    a[p] &&
                      !u &&
                      ((c += 1), (d += a[p].swiperSlideSize) > s && (u = !0));
                  for (var f = l - 1; f >= 0; f -= 1)
                    a[f] &&
                      !u &&
                      ((c += 1), (d += a[f].swiperSlideSize) > s && (u = !0));
                } else if ("current" === e)
                  for (var h = l + 1; h < a.length; h += 1) {
                    (t ? o[h] + r[h] - o[l] < s : o[h] - o[l] < s) && (c += 1);
                  }
                else
                  for (var g = l - 1; g >= 0; g -= 1) {
                    o[l] - o[g] < s && (c += 1);
                  }
                return c;
              },
            },
            {
              key: "update",
              value: function () {
                var e = function () {
                    var e = t.rtlTranslate ? -1 * t.translate : t.translate,
                      i = Math.min(
                        Math.max(e, t.maxTranslate()),
                        t.minTranslate()
                      );
                    t.setTranslate(i),
                      t.updateActiveIndex(),
                      t.updateSlidesClasses();
                  },
                  t = this;
                if (t && !t.destroyed) {
                  var i = t.snapGrid,
                    n = t.params;
                  n.breakpoints && t.setBreakpoint(),
                    t.updateSize(),
                    t.updateSlides(),
                    t.updateProgress(),
                    t.updateSlidesClasses(),
                    t.params.freeMode && t.params.freeMode.enabled
                      ? (e(), t.params.autoHeight && t.updateAutoHeight())
                      : (("auto" === t.params.slidesPerView ||
                          t.params.slidesPerView > 1) &&
                        t.isEnd &&
                        !t.params.centeredSlides
                          ? t.slideTo(t.slides.length - 1, 0, !1, !0)
                          : t.slideTo(t.activeIndex, 0, !1, !0)) || e(),
                    n.watchOverflow && i !== t.snapGrid && t.checkOverflow(),
                    t.emit("update");
                }
              },
            },
            {
              key: "changeDirection",
              value: function (e) {
                var t =
                    !(arguments.length > 1 && void 0 !== arguments[1]) ||
                    arguments[1],
                  i = this,
                  n = i.params.direction;
                return (
                  e || (e = "horizontal" === n ? "vertical" : "horizontal"),
                  e === n ||
                    ("horizontal" !== e && "vertical" !== e) ||
                    (i.$el
                      .removeClass(
                        "".concat(i.params.containerModifierClass).concat(n)
                      )
                      .addClass(
                        "".concat(i.params.containerModifierClass).concat(e)
                      ),
                    i.emitContainerClasses(),
                    (i.params.direction = e),
                    i.slides.each(function (t) {
                      "vertical" === e
                        ? (t.style.width = "")
                        : (t.style.height = "");
                    }),
                    i.emit("changeDirection"),
                    t && i.update()),
                  i
                );
              },
            },
            {
              key: "changeLanguageDirection",
              value: function (e) {
                var t = this;
                (t.rtl && "rtl" === e) ||
                  (!t.rtl && "ltr" === e) ||
                  ((t.rtl = "rtl" === e),
                  (t.rtlTranslate =
                    "horizontal" === t.params.direction && t.rtl),
                  t.rtl
                    ? (t.$el.addClass(
                        "".concat(t.params.containerModifierClass, "rtl")
                      ),
                      (t.el.dir = "rtl"))
                    : (t.$el.removeClass(
                        "".concat(t.params.containerModifierClass, "rtl")
                      ),
                      (t.el.dir = "ltr")),
                  t.update());
              },
            },
            {
              key: "mount",
              value: function (e) {
                var t = this;
                if (t.mounted) return !0;
                var i = fe(e || t.params.el);
                if (!(e = i[0])) return !1;
                e.swiper = t;
                var n = function () {
                    return ".".concat(
                      (t.params.wrapperClass || "").trim().split(" ").join(".")
                    );
                  },
                  a = (function () {
                    if (e && e.shadowRoot && e.shadowRoot.querySelector) {
                      var t = fe(e.shadowRoot.querySelector(n()));
                      return (
                        (t.children = function (e) {
                          return i.children(e);
                        }),
                        t
                      );
                    }
                    return i.children ? i.children(n()) : fe(i).children(n());
                  })();
                if (0 === a.length && t.params.createElements) {
                  var o = V().createElement("div");
                  (a = fe(o)),
                    (o.className = t.params.wrapperClass),
                    i.append(o),
                    i
                      .children(".".concat(t.params.slideClass))
                      .each(function (e) {
                        a.append(e);
                      });
                }
                return (
                  Object.assign(t, {
                    $el: i,
                    el: e,
                    $wrapperEl: a,
                    wrapperEl: a[0],
                    mounted: !0,
                    rtl:
                      "rtl" === e.dir.toLowerCase() ||
                      "rtl" === i.css("direction"),
                    rtlTranslate:
                      "horizontal" === t.params.direction &&
                      ("rtl" === e.dir.toLowerCase() ||
                        "rtl" === i.css("direction")),
                    wrongRTL: "-webkit-box" === a.css("display"),
                  }),
                  !0
                );
              },
            },
            {
              key: "init",
              value: function (e) {
                var t = this;
                return (
                  t.initialized ||
                    !1 === t.mount(e) ||
                    (t.emit("beforeInit"),
                    t.params.breakpoints && t.setBreakpoint(),
                    t.addClasses(),
                    t.params.loop && t.loopCreate(),
                    t.updateSize(),
                    t.updateSlides(),
                    t.params.watchOverflow && t.checkOverflow(),
                    t.params.grabCursor && t.enabled && t.setGrabCursor(),
                    t.params.preloadImages && t.preloadImages(),
                    t.params.loop
                      ? t.slideTo(
                          t.params.initialSlide + t.loopedSlides,
                          0,
                          t.params.runCallbacksOnInit,
                          !1,
                          !0
                        )
                      : t.slideTo(
                          t.params.initialSlide,
                          0,
                          t.params.runCallbacksOnInit,
                          !1,
                          !0
                        ),
                    t.attachEvents(),
                    (t.initialized = !0),
                    t.emit("init"),
                    t.emit("afterInit")),
                  t
                );
              },
            },
            {
              key: "destroy",
              value: function () {
                var e,
                  t =
                    !(arguments.length > 0 && void 0 !== arguments[0]) ||
                    arguments[0],
                  i =
                    !(arguments.length > 1 && void 0 !== arguments[1]) ||
                    arguments[1],
                  n = this,
                  a = n.params,
                  o = n.$el,
                  r = n.$wrapperEl,
                  s = n.slides;
                return (
                  void 0 === n.params ||
                    n.destroyed ||
                    (n.emit("beforeDestroy"),
                    (n.initialized = !1),
                    n.detachEvents(),
                    a.loop && n.loopDestroy(),
                    i &&
                      (n.removeClasses(),
                      o.removeAttr("style"),
                      r.removeAttr("style"),
                      s &&
                        s.length &&
                        s
                          .removeClass(
                            [
                              a.slideVisibleClass,
                              a.slideActiveClass,
                              a.slideNextClass,
                              a.slidePrevClass,
                            ].join(" ")
                          )
                          .removeAttr("style")
                          .removeAttr("data-swiper-slide-index")),
                    n.emit("destroy"),
                    Object.keys(n.eventsListeners).forEach(function (e) {
                      n.off(e);
                    }),
                    !1 !== t &&
                      ((n.$el[0].swiper = null),
                      (e = n),
                      Object.keys(e).forEach(function (t) {
                        try {
                          e[t] = null;
                        } catch (e) {}
                        try {
                          delete e[t];
                        } catch (e) {}
                      })),
                    (n.destroyed = !0)),
                  null
                );
              },
            },
          ],
          [
            {
              key: "extendDefaults",
              value: function (e) {
                ye(ze, e);
              },
            },
            {
              key: "extendedDefaults",
              get: function () {
                return ze;
              },
            },
            {
              key: "defaults",
              get: function () {
                return He;
              },
            },
            {
              key: "installModule",
              value: function (t) {
                e.prototype.__modules__ || (e.prototype.__modules__ = []);
                var i = e.prototype.__modules__;
                "function" == typeof t && i.indexOf(t) < 0 && i.push(t);
              },
            },
            {
              key: "use",
              value: function (t) {
                return Array.isArray(t)
                  ? (t.forEach(function (t) {
                      return e.installModule(t);
                    }),
                    e)
                  : (e.installModule(t), e);
              },
            },
          ]
        ),
        e
      );
    })();
  Object.keys(Ue).forEach(function (e) {
    Object.keys(Ue[e]).forEach(function (t) {
      Ke.prototype[t] = Ue[e][t];
    });
  }),
    Ke.use([
      function (e) {
        var t = e.swiper,
          i = e.on,
          n = e.emit,
          a = z(),
          o = null,
          r = null,
          s = function () {
            t &&
              !t.destroyed &&
              t.initialized &&
              (n("beforeResize"), n("resize"));
          },
          l = function () {
            t && !t.destroyed && t.initialized && n("orientationchange");
          };
        i("init", function () {
          t.params.resizeObserver && void 0 !== a.ResizeObserver
            ? t &&
              !t.destroyed &&
              t.initialized &&
              ((o = new ResizeObserver(function (e) {
                r = a.requestAnimationFrame(function () {
                  var i = t.width,
                    n = t.height,
                    a = i,
                    o = n;
                  e.forEach(function (e) {
                    var i = e.contentBoxSize,
                      n = e.contentRect,
                      r = e.target;
                    (r && r !== t.el) ||
                      ((a = n ? n.width : (i[0] || i).inlineSize),
                      (o = n ? n.height : (i[0] || i).blockSize));
                  }),
                    (a === i && o === n) || s();
                });
              })),
              o.observe(t.el))
            : (a.addEventListener("resize", s),
              a.addEventListener("orientationchange", l));
        }),
          i("destroy", function () {
            r && a.cancelAnimationFrame(r),
              o && o.unobserve && t.el && (o.unobserve(t.el), (o = null)),
              a.removeEventListener("resize", s),
              a.removeEventListener("orientationchange", l);
          });
      },
      function (e) {
        var t = e.swiper,
          i = e.extendParams,
          n = e.on,
          a = e.emit,
          o = [],
          r = z(),
          s = function (e) {
            var t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {},
              i = new (r.MutationObserver || r.WebkitMutationObserver)(
                function (e) {
                  if (1 !== e.length) {
                    var t = function () {
                      a("observerUpdate", e[0]);
                    };
                    r.requestAnimationFrame
                      ? r.requestAnimationFrame(t)
                      : r.setTimeout(t, 0);
                  } else a("observerUpdate", e[0]);
                }
              );
            i.observe(e, {
              attributes: void 0 === t.attributes || t.attributes,
              childList: void 0 === t.childList || t.childList,
              characterData: void 0 === t.characterData || t.characterData,
            }),
              o.push(i);
          };
        i({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          n("init", function () {
            if (t.params.observer) {
              if (t.params.observeParents)
                for (var e = t.$el.parents(), i = 0; i < e.length; i += 1)
                  s(e[i]);
              s(t.$el[0], { childList: t.params.observeSlideChildren }),
                s(t.$wrapperEl[0], { attributes: !1 });
            }
          }),
          n("destroy", function () {
            o.forEach(function (e) {
              e.disconnect();
            }),
              o.splice(0, o.length);
          });
      },
    ]);
  var je = Ke;
  function qe(e, t, i, n) {
    var a = V();
    return (
      e.params.createElements &&
        Object.keys(n).forEach(function (o) {
          if (!i[o] && !0 === i.auto) {
            var r = e.$el.children(".".concat(n[o]))[0];
            r ||
              (((r = a.createElement("div")).className = n[o]),
              e.$el.append(r)),
              (i[o] = r),
              (t[o] = r);
          }
        }),
      i
    );
  }
  function $e() {
    return ".".concat(
      (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "")
        .trim()
        .replace(/([\.:!\/])/g, "\\$1")
        .replace(/ /g, ".")
    );
  }
  var Ye = window.ThemeVars;
  (window.toMoneyString = function (e) {
    !(arguments.length > 1 && void 0 !== arguments[1]) ||
      arguments[1] ||
      (e = (function (e) {
        return (e = e.toString().replace(/[^0-9.]/g, "")).includes(".")
          ? ((e = parseFloat(e)), (e *= 100), Math.round(e))
          : parseInt(100 * e);
      })(e));
    var t = (parseFloat(e) / 100).toFixed(2),
      i = d.moneyFormat || "${{amount}}";
    if (i.includes("amount_no_decimals"))
      return i.replace("{{amount_no_decimals}}", parseFloat(t).toFixed(0));
    if (i.includes("amount_with_comma_separator")) {
      var n = t.split("."),
        a = n[0],
        o = n[1],
        r = a.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (o ? "." + o : "");
      return i.replace("{{amount_with_comma_separator}}", r);
    }
    return i.replace("{{amount}}", t);
  }),
    (window.scrollToElement = function (e) {
      var t =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      if (
        ("string" == typeof e && (e = document.getElementById(e)),
        e && e instanceof HTMLElement)
      ) {
        var i = e.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: i + t, behavior: "smooth" });
      }
    }),
    document.dispatchEvent(new CustomEvent("utilsReady")),
    je.use([
      function (e) {
        var t = e.swiper,
          i = e.extendParams,
          n = e.on,
          a = e.emit,
          o = function (e) {
            var i;
            return (
              e &&
                ((i = fe(e)),
                t.params.uniqueNavElements &&
                  "string" == typeof e &&
                  i.length > 1 &&
                  1 === t.$el.find(e).length &&
                  (i = t.$el.find(e))),
              i
            );
          },
          r = function (e, i) {
            var n = t.params.navigation;
            e &&
              e.length > 0 &&
              (e[i ? "addClass" : "removeClass"](n.disabledClass),
              e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = i),
              t.params.watchOverflow &&
                t.enabled &&
                e[t.isLocked ? "addClass" : "removeClass"](n.lockClass));
          },
          s = function () {
            if (!t.params.loop) {
              var e = t.navigation,
                i = e.$nextEl,
                n = e.$prevEl;
              r(n, t.isBeginning && !t.params.rewind),
                r(i, t.isEnd && !t.params.rewind);
            }
          },
          l = function (e) {
            e.preventDefault(),
              (!t.isBeginning || t.params.loop || t.params.rewind) &&
                (t.slidePrev(), a("navigationPrev"));
          },
          c = function (e) {
            e.preventDefault(),
              (!t.isEnd || t.params.loop || t.params.rewind) &&
                (t.slideNext(), a("navigationNext"));
          },
          u = function () {
            var e = t.params.navigation;
            if (
              ((t.params.navigation = qe(
                t,
                t.originalParams.navigation,
                t.params.navigation,
                { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" }
              )),
              e.nextEl || e.prevEl)
            ) {
              var i = o(e.nextEl),
                n = o(e.prevEl);
              i && i.length > 0 && i.on("click", c),
                n && n.length > 0 && n.on("click", l),
                Object.assign(t.navigation, {
                  $nextEl: i,
                  nextEl: i && i[0],
                  $prevEl: n,
                  prevEl: n && n[0],
                }),
                t.enabled ||
                  (i && i.addClass(e.lockClass), n && n.addClass(e.lockClass));
            }
          },
          d = function () {
            var e = t.navigation,
              i = e.$nextEl,
              n = e.$prevEl;
            i &&
              i.length &&
              (i.off("click", c),
              i.removeClass(t.params.navigation.disabledClass)),
              n &&
                n.length &&
                (n.off("click", l),
                n.removeClass(t.params.navigation.disabledClass));
          };
        i({
          navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled",
          },
        }),
          (t.navigation = {
            nextEl: null,
            $nextEl: null,
            prevEl: null,
            $prevEl: null,
          }),
          n("init", function () {
            !1 === t.params.navigation.enabled ? p() : (u(), s());
          }),
          n("toEdge fromEdge lock unlock", function () {
            s();
          }),
          n("destroy", function () {
            d();
          }),
          n("enable disable", function () {
            var e = t.navigation,
              i = e.$nextEl,
              n = e.$prevEl;
            i &&
              i[t.enabled ? "removeClass" : "addClass"](
                t.params.navigation.lockClass
              ),
              n &&
                n[t.enabled ? "removeClass" : "addClass"](
                  t.params.navigation.lockClass
                );
          }),
          n("click", function (e, i) {
            var n = t.navigation,
              o = n.$nextEl,
              r = n.$prevEl,
              s = i.target;
            if (
              t.params.navigation.hideOnClick &&
              !fe(s).is(r) &&
              !fe(s).is(o)
            ) {
              if (
                t.pagination &&
                t.params.pagination &&
                t.params.pagination.clickable &&
                (t.pagination.el === s || t.pagination.el.contains(s))
              )
                return;
              var l;
              o
                ? (l = o.hasClass(t.params.navigation.hiddenClass))
                : r && (l = r.hasClass(t.params.navigation.hiddenClass)),
                a(!0 === l ? "navigationShow" : "navigationHide"),
                o && o.toggleClass(t.params.navigation.hiddenClass),
                r && r.toggleClass(t.params.navigation.hiddenClass);
            }
          });
        var p = function () {
          t.$el.addClass(t.params.navigation.navigationDisabledClass), d();
        };
        Object.assign(t.navigation, {
          enable: function () {
            t.$el.removeClass(t.params.navigation.navigationDisabledClass),
              u(),
              s();
          },
          disable: p,
          update: s,
          init: u,
          destroy: d,
        });
      },
      function (e) {
        var t,
          i = e.swiper,
          n = e.extendParams,
          a = e.on,
          o = e.emit,
          r = function () {
            return (
              !i.params.pagination.el ||
              !i.pagination.el ||
              !i.pagination.$el ||
              0 === i.pagination.$el.length
            );
          },
          s = function (e, t) {
            var n = i.params.pagination.bulletActiveClass;
            e[t]()
              .addClass("".concat(n, "-").concat(t))
              [t]()
              .addClass("".concat(n, "-").concat(t, "-").concat(t));
          },
          l = function () {
            var e = i.rtl,
              n = i.params.pagination;
            if (!r()) {
              var a,
                l =
                  i.virtual && i.params.virtual.enabled
                    ? i.virtual.slides.length
                    : i.slides.length,
                c = i.pagination.$el,
                u = i.params.loop
                  ? Math.ceil(
                      (l - 2 * i.loopedSlides) / i.params.slidesPerGroup
                    )
                  : i.snapGrid.length;
              if (
                (i.params.loop
                  ? ((a = Math.ceil(
                      (i.activeIndex - i.loopedSlides) / i.params.slidesPerGroup
                    )) >
                      l - 1 - 2 * i.loopedSlides &&
                      (a -= l - 2 * i.loopedSlides),
                    a > u - 1 && (a -= u),
                    a < 0 &&
                      "bullets" !== i.params.paginationType &&
                      (a = u + a))
                  : (a =
                      void 0 !== i.snapIndex
                        ? i.snapIndex
                        : i.activeIndex || 0),
                "bullets" === n.type &&
                  i.pagination.bullets &&
                  i.pagination.bullets.length > 0)
              ) {
                var d,
                  p,
                  h,
                  g = i.pagination.bullets;
                if (
                  (n.dynamicBullets &&
                    ((t = g
                      .eq(0)
                      [i.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                    c.css(
                      i.isHorizontal() ? "width" : "height",
                      "".concat(t * (n.dynamicMainBullets + 4), "px")
                    ),
                    n.dynamicMainBullets > 1 &&
                      void 0 !== i.previousIndex &&
                      ((f += a - (i.previousIndex - i.loopedSlides || 0)) >
                      n.dynamicMainBullets - 1
                        ? (f = n.dynamicMainBullets - 1)
                        : f < 0 && (f = 0)),
                    (d = Math.max(a - f, 0)),
                    (h =
                      ((p =
                        d + (Math.min(g.length, n.dynamicMainBullets) - 1)) +
                        d) /
                      2)),
                  g.removeClass(
                    ["", "-next", "-next-next", "-prev", "-prev-prev", "-main"]
                      .map(function (e) {
                        return "".concat(n.bulletActiveClass).concat(e);
                      })
                      .join(" ")
                  ),
                  c.length > 1)
                )
                  g.each(function (e) {
                    var t = fe(e),
                      i = t.index();
                    i === a && t.addClass(n.bulletActiveClass),
                      n.dynamicBullets &&
                        (i >= d &&
                          i <= p &&
                          t.addClass("".concat(n.bulletActiveClass, "-main")),
                        i === d && s(t, "prev"),
                        i === p && s(t, "next"));
                  });
                else {
                  var v = g.eq(a),
                    m = v.index();
                  if ((v.addClass(n.bulletActiveClass), n.dynamicBullets)) {
                    for (var y = g.eq(d), S = g.eq(p), w = d; w <= p; w += 1)
                      g.eq(w).addClass("".concat(n.bulletActiveClass, "-main"));
                    if (i.params.loop)
                      if (m >= g.length) {
                        for (var C = n.dynamicMainBullets; C >= 0; C -= 1)
                          g.eq(g.length - C).addClass(
                            "".concat(n.bulletActiveClass, "-main")
                          );
                        g.eq(g.length - n.dynamicMainBullets - 1).addClass(
                          "".concat(n.bulletActiveClass, "-prev")
                        );
                      } else s(y, "prev"), s(S, "next");
                    else s(y, "prev"), s(S, "next");
                  }
                }
                if (n.dynamicBullets) {
                  var b = Math.min(g.length, n.dynamicMainBullets + 4),
                    A = (t * b - t) / 2 - h * t,
                    E = e ? "right" : "left";
                  g.css(i.isHorizontal() ? E : "top", "".concat(A, "px"));
                }
              }
              if (
                ("fraction" === n.type &&
                  (c
                    .find($e(n.currentClass))
                    .text(n.formatFractionCurrent(a + 1)),
                  c.find($e(n.totalClass)).text(n.formatFractionTotal(u))),
                "progressbar" === n.type)
              ) {
                var T;
                T = n.progressbarOpposite
                  ? i.isHorizontal()
                    ? "vertical"
                    : "horizontal"
                  : i.isHorizontal()
                  ? "horizontal"
                  : "vertical";
                var N = (a + 1) / u,
                  M = 1,
                  x = 1;
                "horizontal" === T ? (M = N) : (x = N),
                  c
                    .find($e(n.progressbarFillClass))
                    .transform(
                      "translate3d(0,0,0) scaleX("
                        .concat(M, ") scaleY(")
                        .concat(x, ")")
                    )
                    .transition(i.params.speed);
              }
              "custom" === n.type && n.renderCustom
                ? (c.html(n.renderCustom(i, a + 1, u)),
                  o("paginationRender", c[0]))
                : o("paginationUpdate", c[0]),
                i.params.watchOverflow &&
                  i.enabled &&
                  c[i.isLocked ? "addClass" : "removeClass"](n.lockClass);
            }
          },
          c = function () {
            var e = i.params.pagination;
            if (!r()) {
              var t =
                  i.virtual && i.params.virtual.enabled
                    ? i.virtual.slides.length
                    : i.slides.length,
                n = i.pagination.$el,
                a = "";
              if ("bullets" === e.type) {
                var s = i.params.loop
                  ? Math.ceil(
                      (t - 2 * i.loopedSlides) / i.params.slidesPerGroup
                    )
                  : i.snapGrid.length;
                i.params.freeMode &&
                  i.params.freeMode.enabled &&
                  !i.params.loop &&
                  s > t &&
                  (s = t);
                for (var l = 0; l < s; l += 1)
                  e.renderBullet
                    ? (a += e.renderBullet.call(i, l, e.bulletClass))
                    : (a += "<"
                        .concat(e.bulletElement, ' class="')
                        .concat(e.bulletClass, '"></')
                        .concat(e.bulletElement, ">"));
                n.html(a), (i.pagination.bullets = n.find($e(e.bulletClass)));
              }
              "fraction" === e.type &&
                ((a = e.renderFraction
                  ? e.renderFraction.call(i, e.currentClass, e.totalClass)
                  : '<span class="'.concat(e.currentClass, '"></span>') +
                    " / " +
                    '<span class="'.concat(e.totalClass, '"></span>')),
                n.html(a)),
                "progressbar" === e.type &&
                  ((a = e.renderProgressbar
                    ? e.renderProgressbar.call(i, e.progressbarFillClass)
                    : '<span class="'.concat(
                        e.progressbarFillClass,
                        '"></span>'
                      )),
                  n.html(a)),
                "custom" !== e.type &&
                  o("paginationRender", i.pagination.$el[0]);
            }
          },
          u = function () {
            i.params.pagination = qe(
              i,
              i.originalParams.pagination,
              i.params.pagination,
              { el: "swiper-pagination" }
            );
            var e = i.params.pagination;
            if (e.el) {
              var t = fe(e.el);
              0 !== t.length &&
                (i.params.uniqueNavElements &&
                  "string" == typeof e.el &&
                  t.length > 1 &&
                  (t = i.$el.find(e.el)).length > 1 &&
                  (t = t.filter(function (e) {
                    return fe(e).parents(".swiper")[0] === i.el;
                  })),
                "bullets" === e.type &&
                  e.clickable &&
                  t.addClass(e.clickableClass),
                t.addClass(e.modifierClass + e.type),
                t.addClass(
                  i.isHorizontal() ? e.horizontalClass : e.verticalClass
                ),
                "bullets" === e.type &&
                  e.dynamicBullets &&
                  (t.addClass(
                    "".concat(e.modifierClass).concat(e.type, "-dynamic")
                  ),
                  (f = 0),
                  e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
                "progressbar" === e.type &&
                  e.progressbarOpposite &&
                  t.addClass(e.progressbarOppositeClass),
                e.clickable &&
                  t.on("click", $e(e.bulletClass), function (e) {
                    e.preventDefault();
                    var t = fe(this).index() * i.params.slidesPerGroup;
                    i.params.loop && (t += i.loopedSlides), i.slideTo(t);
                  }),
                Object.assign(i.pagination, { $el: t, el: t[0] }),
                i.enabled || t.addClass(e.lockClass));
            }
          },
          d = function () {
            var e = i.params.pagination;
            if (!r()) {
              var t = i.pagination.$el;
              t.removeClass(e.hiddenClass),
                t.removeClass(e.modifierClass + e.type),
                t.removeClass(
                  i.isHorizontal() ? e.horizontalClass : e.verticalClass
                ),
                i.pagination.bullets &&
                  i.pagination.bullets.removeClass &&
                  i.pagination.bullets.removeClass(e.bulletActiveClass),
                e.clickable && t.off("click", $e(e.bulletClass));
            }
          },
          p = "swiper-pagination";
        n({
          pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: function (e) {
              return e;
            },
            formatFractionTotal: function (e) {
              return e;
            },
            bulletClass: "".concat(p, "-bullet"),
            bulletActiveClass: "".concat(p, "-bullet-active"),
            modifierClass: "".concat(p, "-"),
            currentClass: "".concat(p, "-current"),
            totalClass: "".concat(p, "-total"),
            hiddenClass: "".concat(p, "-hidden"),
            progressbarFillClass: "".concat(p, "-progressbar-fill"),
            progressbarOppositeClass: "".concat(p, "-progressbar-opposite"),
            clickableClass: "".concat(p, "-clickable"),
            lockClass: "".concat(p, "-lock"),
            horizontalClass: "".concat(p, "-horizontal"),
            verticalClass: "".concat(p, "-vertical"),
            paginationDisabledClass: "".concat(p, "-disabled"),
          },
        }),
          (i.pagination = { el: null, $el: null, bullets: [] });
        var f = 0;
        a("init", function () {
          !1 === i.params.pagination.enabled ? h() : (u(), c(), l());
        }),
          a("activeIndexChange", function () {
            (i.params.loop || void 0 === i.snapIndex) && l();
          }),
          a("snapIndexChange", function () {
            i.params.loop || l();
          }),
          a("slidesLengthChange", function () {
            i.params.loop && (c(), l());
          }),
          a("snapGridLengthChange", function () {
            i.params.loop || (c(), l());
          }),
          a("destroy", function () {
            d();
          }),
          a("enable disable", function () {
            var e = i.pagination.$el;
            e &&
              e[i.enabled ? "removeClass" : "addClass"](
                i.params.pagination.lockClass
              );
          }),
          a("lock unlock", function () {
            l();
          }),
          a("click", function (e, t) {
            var n = t.target,
              a = i.pagination.$el;
            if (
              i.params.pagination.el &&
              i.params.pagination.hideOnClick &&
              a &&
              a.length > 0 &&
              !fe(n).hasClass(i.params.pagination.bulletClass)
            ) {
              if (
                i.navigation &&
                ((i.navigation.nextEl && n === i.navigation.nextEl) ||
                  (i.navigation.prevEl && n === i.navigation.prevEl))
              )
                return;
              var r = a.hasClass(i.params.pagination.hiddenClass);
              o(!0 === r ? "paginationShow" : "paginationHide"),
                a.toggleClass(i.params.pagination.hiddenClass);
            }
          });
        var h = function () {
          i.$el.addClass(i.params.pagination.paginationDisabledClass),
            i.pagination.$el &&
              i.pagination.$el.addClass(
                i.params.pagination.paginationDisabledClass
              ),
            d();
        };
        Object.assign(i.pagination, {
          enable: function () {
            i.$el.removeClass(i.params.pagination.paginationDisabledClass),
              i.pagination.$el &&
                i.pagination.$el.removeClass(
                  i.params.pagination.paginationDisabledClass
                ),
              u(),
              c(),
              l();
          },
          disable: h,
          render: c,
          update: l,
          init: u,
          destroy: d,
        });
      },
      function (e) {
        var t,
          i = e.swiper,
          n = e.extendParams,
          a = e.on,
          o = e.emit,
          r = function () {
            return (
              void 0 === t &&
              !i.autoplay.running &&
              ((i.autoplay.running = !0), o("autoplayStart"), p(), !0)
            );
          },
          s = function () {
            return (
              !!i.autoplay.running &&
              void 0 !== t &&
              (t && (clearTimeout(t), (t = void 0)),
              (i.autoplay.running = !1),
              o("autoplayStop"),
              !0)
            );
          },
          l = function (e) {
            i.autoplay.running &&
              (i.autoplay.paused ||
                (t && clearTimeout(t),
                (i.autoplay.paused = !0),
                0 !== e && i.params.autoplay.waitForTransition
                  ? ["transitionend", "webkitTransitionEnd"].forEach(function (
                      e
                    ) {
                      i.$wrapperEl[0].addEventListener(e, f);
                    })
                  : ((i.autoplay.paused = !1), p())));
          },
          c = function () {
            var e = V();
            "hidden" === e.visibilityState && i.autoplay.running && l(),
              "visible" === e.visibilityState &&
                i.autoplay.paused &&
                (p(), (i.autoplay.paused = !1));
          },
          u = function () {
            i.params.autoplay.disableOnInteraction
              ? s()
              : (o("autoplayPause"), l()),
              ["transitionend", "webkitTransitionEnd"].forEach(function (e) {
                i.$wrapperEl[0].removeEventListener(e, f);
              });
          },
          d = function () {
            i.params.autoplay.disableOnInteraction ||
              ((i.autoplay.paused = !1), o("autoplayResume"), p());
          };
        function p() {
          if (!i.size)
            return (i.autoplay.running = !1), void (i.autoplay.paused = !1);
          var e = i.slides.eq(i.activeIndex),
            n = i.params.autoplay.delay;
          e.attr("data-swiper-autoplay") &&
            (n = e.attr("data-swiper-autoplay") || i.params.autoplay.delay),
            clearTimeout(t),
            (t = he(function () {
              var e;
              i.params.autoplay.reverseDirection
                ? i.params.loop
                  ? (i.loopFix(),
                    (e = i.slidePrev(i.params.speed, !0, !0)),
                    o("autoplay"))
                  : i.isBeginning
                  ? i.params.autoplay.stopOnLastSlide
                    ? s()
                    : ((e = i.slideTo(
                        i.slides.length - 1,
                        i.params.speed,
                        !0,
                        !0
                      )),
                      o("autoplay"))
                  : ((e = i.slidePrev(i.params.speed, !0, !0)), o("autoplay"))
                : i.params.loop
                ? (i.loopFix(),
                  (e = i.slideNext(i.params.speed, !0, !0)),
                  o("autoplay"))
                : i.isEnd
                ? i.params.autoplay.stopOnLastSlide
                  ? s()
                  : ((e = i.slideTo(0, i.params.speed, !0, !0)), o("autoplay"))
                : ((e = i.slideNext(i.params.speed, !0, !0)), o("autoplay")),
                ((i.params.cssMode && i.autoplay.running) || !1 === e) && p();
            }, n));
        }
        function f(e) {
          i &&
            !i.destroyed &&
            i.$wrapperEl &&
            e.target === i.$wrapperEl[0] &&
            (["transitionend", "webkitTransitionEnd"].forEach(function (e) {
              i.$wrapperEl[0].removeEventListener(e, f);
            }),
            (i.autoplay.paused = !1),
            i.autoplay.running ? p() : s());
        }
        (i.autoplay = { running: !1, paused: !1 }),
          n({
            autoplay: {
              enabled: !1,
              delay: 3e3,
              waitForTransition: !0,
              disableOnInteraction: !0,
              stopOnLastSlide: !1,
              reverseDirection: !1,
              pauseOnMouseEnter: !1,
            },
          }),
          a("init", function () {
            i.params.autoplay.enabled &&
              (r(),
              V().addEventListener("visibilitychange", c),
              i.params.autoplay.pauseOnMouseEnter &&
                (i.$el.on("mouseenter", u), i.$el.on("mouseleave", d)));
          }),
          a("beforeTransitionStart", function (e, t, n) {
            i.autoplay.running &&
              (n || !i.params.autoplay.disableOnInteraction
                ? i.autoplay.pause(t)
                : s());
          }),
          a("sliderFirstMove", function () {
            i.autoplay.running &&
              (i.params.autoplay.disableOnInteraction ? s() : l());
          }),
          a("touchEnd", function () {
            i.params.cssMode &&
              i.autoplay.paused &&
              !i.params.autoplay.disableOnInteraction &&
              p();
          }),
          a("destroy", function () {
            i.$el.off("mouseenter", u),
              i.$el.off("mouseleave", d),
              i.autoplay.running && s(),
              V().removeEventListener("visibilitychange", c);
          }),
          Object.assign(i.autoplay, { pause: l, run: p, start: r, stop: s });
      },
      function (e) {
        var t = e.swiper,
          i = e.extendParams,
          n = e.on,
          a = function () {
            var e = t.thumbs.swiper;
            if (e && !e.destroyed) {
              var i = e.clickedIndex,
                n = e.clickedSlide;
              if (
                !(
                  (n &&
                    fe(n).hasClass(t.params.thumbs.slideThumbActiveClass)) ||
                  null == i
                )
              ) {
                var a;
                if (
                  ((a = e.params.loop
                    ? parseInt(
                        fe(e.clickedSlide).attr("data-swiper-slide-index"),
                        10
                      )
                    : i),
                  t.params.loop)
                ) {
                  var o = t.activeIndex;
                  t.slides.eq(o).hasClass(t.params.slideDuplicateClass) &&
                    (t.loopFix(),
                    (t._clientLeft = t.$wrapperEl[0].clientLeft),
                    (o = t.activeIndex));
                  var r = t.slides
                      .eq(o)
                      .prevAll('[data-swiper-slide-index="'.concat(a, '"]'))
                      .eq(0)
                      .index(),
                    s = t.slides
                      .eq(o)
                      .nextAll('[data-swiper-slide-index="'.concat(a, '"]'))
                      .eq(0)
                      .index();
                  a =
                    void 0 === r ? s : void 0 === s ? r : s - o < o - r ? s : r;
                }
                t.slideTo(a);
              }
            }
          },
          o = function () {
            var e = t.params.thumbs;
            if (s) return !1;
            s = !0;
            var i = t.constructor;
            if (e.swiper instanceof i)
              (t.thumbs.swiper = e.swiper),
                Object.assign(t.thumbs.swiper.originalParams, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }),
                Object.assign(t.thumbs.swiper.params, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                });
            else if (me(e.swiper)) {
              var n = Object.assign({}, e.swiper);
              Object.assign(n, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }),
                (t.thumbs.swiper = new i(n)),
                (l = !0);
            }
            return (
              t.thumbs.swiper.$el.addClass(
                t.params.thumbs.thumbsContainerClass
              ),
              t.thumbs.swiper.on("tap", a),
              !0
            );
          },
          r = function (e) {
            var i = t.thumbs.swiper;
            if (i && !i.destroyed) {
              var n =
                  "auto" === i.params.slidesPerView
                    ? i.slidesPerViewDynamic()
                    : i.params.slidesPerView,
                a = 1,
                o = t.params.thumbs.slideThumbActiveClass;
              if (
                (t.params.slidesPerView > 1 &&
                  !t.params.centeredSlides &&
                  (a = t.params.slidesPerView),
                t.params.thumbs.multipleActiveThumbs || (a = 1),
                (a = Math.floor(a)),
                i.slides.removeClass(o),
                i.params.loop || (i.params.virtual && i.params.virtual.enabled))
              )
                for (var r = 0; r < a; r += 1)
                  i.$wrapperEl
                    .children(
                      '[data-swiper-slide-index="'.concat(t.realIndex + r, '"]')
                    )
                    .addClass(o);
              else
                for (var s = 0; s < a; s += 1)
                  i.slides.eq(t.realIndex + s).addClass(o);
              var l = t.params.thumbs.autoScrollOffset,
                c = l && !i.params.loop;
              if (t.realIndex !== i.realIndex || c) {
                var u,
                  d,
                  p = i.activeIndex;
                if (i.params.loop) {
                  i.slides.eq(p).hasClass(i.params.slideDuplicateClass) &&
                    (i.loopFix(),
                    (i._clientLeft = i.$wrapperEl[0].clientLeft),
                    (p = i.activeIndex));
                  var f = i.slides
                      .eq(p)
                      .prevAll(
                        '[data-swiper-slide-index="'.concat(t.realIndex, '"]')
                      )
                      .eq(0)
                      .index(),
                    h = i.slides
                      .eq(p)
                      .nextAll(
                        '[data-swiper-slide-index="'.concat(t.realIndex, '"]')
                      )
                      .eq(0)
                      .index();
                  (u =
                    void 0 === f
                      ? h
                      : void 0 === h
                      ? f
                      : h - p == p - f
                      ? i.params.slidesPerGroup > 1
                        ? h
                        : p
                      : h - p < p - f
                      ? h
                      : f),
                    (d = t.activeIndex > t.previousIndex ? "next" : "prev");
                } else
                  d = (u = t.realIndex) > t.previousIndex ? "next" : "prev";
                c && (u += "next" === d ? l : -1 * l),
                  i.visibleSlidesIndexes &&
                    i.visibleSlidesIndexes.indexOf(u) < 0 &&
                    (i.params.centeredSlides
                      ? (u =
                          u > p
                            ? u - Math.floor(n / 2) + 1
                            : u + Math.floor(n / 2) - 1)
                      : u > p && i.params.slidesPerGroup,
                    i.slideTo(u, e ? 0 : void 0));
              }
            }
          };
        i({
          thumbs: {
            swiper: null,
            multipleActiveThumbs: !0,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs",
          },
        });
        var s = !1,
          l = !1;
        (t.thumbs = { swiper: null }),
          n("beforeInit", function () {
            var e = t.params.thumbs;
            e && e.swiper && (o(), r(!0));
          }),
          n("slideChange update resize observerUpdate", function () {
            r();
          }),
          n("setTransition", function (e, i) {
            var n = t.thumbs.swiper;
            n && !n.destroyed && n.setTransition(i);
          }),
          n("beforeDestroy", function () {
            var e = t.thumbs.swiper;
            e && !e.destroyed && l && e.destroy();
          }),
          Object.assign(t.thumbs, { init: o, update: r });
      },
    ]),
    (window.Swiper = je),
    document.dispatchEvent(new CustomEvent("swiperReady"));
  if (
    Ye &&
    ("unpublished" == Ye.theme.role ||
      "demo" == Ye.theme.role ||
      "development" == Ye.theme.role)
  ) {
    var Ze = document.createElement("div");
    Ze.classList.add("preview-bar-toggle"),
      (Ze.innerHTML =
        '<span class="preview-bar-toggle__icon">\n      <?xml version="1.0" ?><!DOCTYPE svg  PUBLIC \'-//W3C//DTD SVG 1.1//EN\'  \'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\'><svg enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><polyline fill="none" points="   649,137.999 675,137.999 675,155.999 661,155.999  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><polyline fill="none" points="   653,155.999 649,155.999 649,141.999  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><polyline fill="none" points="   661,156 653,162 653,156  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/></g><g><g><path d="M16,25c-4.265,0-8.301-1.807-11.367-5.088c-0.377-0.403-0.355-1.036,0.048-1.413c0.404-0.377,1.036-0.355,1.414,0.048    C8.778,21.419,12.295,23,16,23c4.763,0,9.149-2.605,11.84-7c-2.69-4.395-7.077-7-11.84-7c-4.938,0-9.472,2.801-12.13,7.493    c-0.272,0.481-0.884,0.651-1.363,0.377c-0.481-0.272-0.649-0.882-0.377-1.363C5.147,10.18,10.333,7,16,7    c5.668,0,10.853,3.18,13.87,8.507c0.173,0.306,0.173,0.68,0,0.985C26.853,21.819,21.668,25,16,25z"/></g><g><path d="M16,21c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5S18.757,21,16,21z M16,13c-1.654,0-3,1.346-3,3s1.346,3,3,3    s3-1.346,3-3S17.654,13,16,13z"/></g></g></svg>\n    </span>'),
      Ze.addEventListener("click", function () {
        var e = document.querySelector("#preview-bar-iframe"),
          t = e.contentWindow.document.querySelector("#share_theme_url");
        if (t) {
          var i = ""
            .concat(window.location.href, "?preview_theme_id=")
            .concat(Ye.theme.id);
          t.value = i;
        }
        e && e.classList.toggle("closed"),
          e && Ze.classList.toggle("open"),
          (Ze.style.bottom =
            e && Ze.classList.contains("open")
              ? "calc(".concat(e.offsetHeight, "px + 1rem)")
              : "");
      }),
      document.body.appendChild(Ze),
      new MutationObserver(function (e) {
        e.forEach(function (e) {
          if ("childList" == e.type && e.addedNodes.length > 0) {
            var t = document.querySelector("#preview-bar-iframe");
            t && t.classList.add("closed");
          }
        });
      }).observe(document.body, { childList: !0 });
    var Je = document.querySelector("#preview-bar-iframe");
    Je && Je.classList.add("closed");
  }
})();

class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.isDown = false;
    this.startX = 0;
    this.sliderScrollLeft = 0;

    this.addEventListener("mousedown", this.handleMouseDown.bind(this));
    this.addEventListener("mouseleave", this.handleMouseLeave.bind(this));
    this.addEventListener("mouseup", this.handleMouseUp.bind(this));
    this.addEventListener("mousemove", this.handleMouseMove.bind(this));
  }

  handleMouseDown(e) {
    this.isDown = true;
    this.startX = e.pageX - this.offsetLeft;
    this.sliderScrollLeft = this.scrollLeft;
  }

  handleMouseLeave() {
    this.isDown = false;
    this.classList.remove("active");
  }

  handleMouseUp() {
    this.isDown = false;
    this.classList.remove("active");
  }

  handleMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.offsetLeft;
    const walk = (x - this.startX) * 1.5;
    this.scrollLeft = this.sliderScrollLeft - walk;
  }
}

customElements.define("custom-slider", CustomSlider);

// Set skip auto add cookie from query param on page load, this is used to prevent auto-add products when the query param is present.
window.addEventListener("load", function () {
  const skipAutoAddParam = "skip_auto_add";
  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.has(skipAutoAddParam)) {
    // Persist skip behavior for 1 hour from when this URL is visited.
    document.cookie = `${skipAutoAddParam}=1; path=/; Max-Age=3600; SameSite=Lax`;
  }
});

document.addEventListener("DOMContentLoaded", e => {
  let header = document.querySelector(".header");

  header && document.body.style.setProperty('--header-height', `${header.clientHeight - 1}px`);
});
